export default {
  welcome: "Welcome",
  migration: {
    destinationUnavailable:
      "Your account has moved, but the new sign-in address is unavailable. Please contact support.",
    statusUnavailable: "Unable to check account access. Please refresh to try again.",
  },
  security: {
    status: {
      enabled: "2FA enabled",
      disabled: "2FA off",
    },
    gate: {
      title: "Two-factor authentication required",
      description:
        "An account you belong to requires two-factor authentication. Set up an authenticator app to continue.",
    },
    totp: {
      intro:
        "Protect your account with an authenticator app such as Google Authenticator or 1Password.",
      start: "Set up authenticator",
      factorName: "Authenticator app",
      scanQr: "Scan this QR code with your authenticator app, then enter the 6-digit code below.",
      manualEntry: "Or enter this key manually:",
      codeLabel: "6-digit code",
      verify: "Verify",
      enrolled: "Two-factor authentication is enabled",
      enabledDescription:
        "Your account is protected with an authenticator app. You will be asked for a code every time you sign in.",
      replace: "Replace authenticator",
      replaceDescription:
        "Set up a new authenticator app. Your previous authenticator will be removed before the new setup begins.",
      remove: "Remove authenticator",
      removed: "Two-factor authentication removed",
      removeError: "Failed to remove two-factor authentication",
      removeConfirmTitle: "Remove authenticator?",
      removeConfirmMessage:
        "You will no longer be asked for a verification code when signing in. You can set it up again at any time.",
      unenrollBlocked:
        "An account you belong to requires two-factor authentication, so it cannot be removed. Contact support if you need help.",
      invalidCode: "Invalid verification code. Try again",
      enrollmentError: "Failed to start two-factor authentication setup",
      confirmIdentityTitle: "Confirm identity",
      reauthRequired: "For security, please confirm your identity to continue.",
      googleReauthRequired: "Continue with Google to confirm your identity.",
      continueWithGoogle: "Continue with Google",
      reauthFailed: "Identity confirmation failed. Try again",
    },
  },
  common: {
    or: "OR",
    emptyValue: "—",
    action: {
      confirm: "Confirm",
      continue: "Continue",
      action: "Action",
      createProductClass: "Create Product Group",
      confirmNavigation: "Confirm Navigation",
      returnToTransaction: "Return to Transaction",
      cancelTransaction: "Cancel Transaction",
      tag: "Tag",
      tags: "Tags",
      product: "Product",
      products: "Products",
      productClass: "Product Group",
      productClasses: "Product Groups",
      importTags: "Import Tags",
      createTag: "Create Tag",
      noResults: "No results found",
      default: "Default",
      globalDefault: "Global Default",
      noDefault: "No default price",
      cancel: "Cancel",
      cancelsOn: "Cancels on",
      clear: "Clear",
      update: "Update",
      close: "Close",
      print: "Print",
      create: "Create",
      delete: "Delete",
      select: "Select",
      selectAll: "Select All",
      enter: "Enter",
      retry: "Retry",
      scan: "Scan",
      resetPassword: "Reset Password",
      sendInstructions: "Send instructions",
      notSupported: "Incorrect File Type",
      noImage: "No Image to Delete",
      editUser: "Edit User",
      editNickname: "Edit Nickname",
      archivePrice: "Archive Price",
      deleteUser: "Delete User",
      reinviteUser: "Reinvite",
      email: "Email",
      fullName: "Full Name",
      save: "Save",
      add: "Add",
      addMore: "Add More",
      addPrice: "Add Price",
      amount: "Amount",
      color: "Color",
      name: "Name",
      customer: "Customer",
      location: "Location",
      formStatus: "Form Status",
      status: "Status",
      titleAndDescription: "Title & Description",
      metadata: "Metadata",
      type: "Type",
      submit: "Submit",
      skip: "Skip",
      required: "Required",
      created: "Created",
      added: "Added",
      text: "Text",
      transactionType: "Transaction Type",
      signed: "Signed",
      form: "Form",
      formOpen: "Form Open",
      number: "Number",
      selection: "Selection",
      updated: "Updated",
      export: "Export",
      confirmExport: "Confirm Export",
      details: "Details",
      notAvailable: "Not Available",
      description: "Description",
      address: "Address",
      firstName: "First Name",
      lastName: "Last Name",
      phone: "Phone",
      optional: "Optional",
      id: "ID",
      customId: "Custom ID",
      url: "URL",
      deleteConfirm: "Are you sure you want to delete this user? This action cannot be undone.",
      deactivateUserConfirm: "Are you sure you want to deactivate this user?",
      activateUserConfirm: "Are you sure you want to activate this user?",
      deactivate: "Deactivate",
      activate: "Activate",
      reset: "Reset",
      printQRCodes: "Print QR Codes",
      addLocation: "Add Location",
      editLocation: "Edit Location",
      editPricing: "Edit Pricing",
      deleteLocation: "Delete Location",
      addTerminal: "Add Terminal",
      addReader: "Add Reader",
      editTerminal: "Edit Terminal",
      deleteTerminal: "Delete Terminal",
      favorite: "Favorite",
      createPayment: "Create Payment",
      exportReport: "Export Report",
      exportProducts: "Export Products",
      exportProductsSuccess: "Products export completed successfully",
      exportError: "Failed to handle export",
      exportPrices: "Export Prices",
      exportPricesSuccess: "Prices export completed successfully",
      exportPricesError: "Failed to export prices",
      includeAdditionalPrices: "Include additional prices",
      includeAdditionalPricesHint:
        "Includes active prices that are not the global or a location default.",
      exportTags: "Export Tags",
      exportProductTagsSuccess: "Product tags export completed successfully",
      exportProductClasses: "Export Product Groups",
      exportProductClassesSuccess: "Product groups export completed successfully",
      preparingExport: "Preparing export, please wait...",
      importProducts: "Import Products",
      importCustomers: "Import Customers",
      metadataFields: "Metadata Fields",
      metadataFieldMapping: "Maps to {0}",
      metadataNoKeysConfigured:
        "Metadata columns will still import but appear unlabeled until you set keys in Settings > Product.",
      importPrices: "Import Prices",
      editPayment: "Edit Payment",
      sendPayment: "Send Payment",
      viewDetails: "View Details",
      remove: "Remove",
      removeFromAllProducts: "Remove from All Products",
      removeFromAllProductClasses: "Remove from All Product Groups",
      bulkActivateDeactivate: "Bulk Actions",
      addAsFavorite: "Add as Favorite",
      addFavorite: "Add Favorite",
      activateStripe: "Activate Stripe",
      stripeActivated: "Stripe activated",
      addANewLocation: "Add a location",
      addANewTerminal: "Add a terminal",
      showMore: "Go to Stripe Invoices",
      setAsDefault: "Set as Default Price",
      setAsGlobalDefault: "Set as Global Default Price",
      edit: "Edit",
      configure: "Configure",
      for: "for",
      redirecting: "Redirecting",
      actions: "Actions",
      upgrade: "Upgrade",
      value: "Value",
      back: "Back",
      next: "Next",
      prev: "Prev",
      previous: "Previous",
      send: "Send",
      sendReceipt: "Send Receipt",
      sms: "SMS",
      loading: "Loading...",
      uploading: "Uploading",
      addCustomer: "Add Customer",
      editCustomer: "Edit Customer",
      deleteCustomer: "Delete Customer",
      productDetails: "Product Details",
      priceInformation: "Price Information",
      image: "Image",
      skipped: "Skipped",
      saveProduct: "Save Product",
      upload: "Upload",
      price: "Price",
      nickname: "Nickname",
      sku: "SKU",
      skuWarning: "Once a SKU has been set, it cannot be changed",
      skuLocked: "SKU cannot be modified after being set",
      skuRequired: "SKU is required and must be unique across your entire catalog",
      skuExists: "SKU already exists in your catalog, please enter a unique SKU",
      priceSlotAdded: "Price Slot Added!",
      priceSlotRemoved: "Price Slot Removed!",
      preview: "Preview",
      productCreated: "Product Created!",
      failedToImport: "Failed to import data",
      importProductClasses: "Import Product Groups",
      importProductTags: "Import Product Tags",
      productClassActiveDesc: "Whether the product group is active, defaults to true",
      productClassDescriptionDesc: "A customer-facing description for this product group",
      productClassIdDesc:
        "The ID of an existing product group to associate with this product. If not provided or if the ID doesn't match an existing group, this field will be ignored",
      productClassImportBehavior:
        "Product groups with the same ID will be updated if they already exist. Each row in your CSV represents one group, such as a jacket, hoodie, ticket type, or drink that can contain sellable variants.",
      productClassNameDesc: "The name of the product group customers should browse first",
      productClassUrlDesc: "A URL related to this product group",
      productClassTagIdsDesc:
        "A comma-separated list of product tag IDs to assign to this product group for kiosk browsing/filtering (e.g., 'FEATURED,SEASONAL')",
      productClassTagsAliasDesc:
        "Alias for tag_ids. Use a comma-separated list of product tag IDs.",
      productTagNameDesc: "The name of the product tag",
      productTagIdDesc:
        "A unique identifier for the product tag, will be auto-generated if not provided",
      productTagColorDesc: "The color of the tag in hex format with # prefix (e.g. #FF5733)",
      productTagActiveDesc: "Whether the product tag is active, defaults to true",
      productTagsImported: "{count} product tags imported successfully",
      productClassesImported: "{count} product groups imported successfully",
      productIdentifierDesc: "A unique identifier used to group price rows under the same product",
      inventoryProductIdentifierDesc: "Unique identifier for the product",
      inventoryProductIdDesc:
        "ID of the product. This field uniquely identifies the product that the inventory adjustment will apply to.",
      inventoryLocationIdsDesc:
        "Required when location-based inventory is enabled. Use 'all' to apply the same adjustment to all active locations, or provide a comma-separated list of terminal location IDs (e.g., 'tml_1234,tml_5678'). Use separate rows if the same product needs different quantities at different locations.",
      productNameDesc:
        "Required for new products. If an id is provided, leaving this blank will preserve the existing product name.",
      productDescriptionDesc: "A brief description of the product, up to 255 characters",
      productActiveDesc: "Indicates whether the product is active, defaults to true",
      catalogSortDesc:
        "Optional non-negative integer used for defined kiosk ordering. Lower values appear first; duplicate or missing values fall back alphabetically. Leave blank to clear an existing rank.",
      all: "All",
      none: "None",
      filterName: "Filter by Name",
      defaultPrice: "Default Price",
      globalDefaultPrice: "Global Default Price",
      nicknameInternalUse: "For internal use only",
      USD: "USD",
      addAnotherPrice: "Add Another Price",
      addProduct: "Add Product",
      addNameValue: "Please Enter a Name",
      errorMakingProduct: "Error during product creation",
      activeStatus: "Active Status",
      clearFilters: "Clear Filters",
      enterName: "Enter Name",
      applyFilter: "Apply Filter",
      enterDescription: "Enter Description",
      both: "Both",
      active: "Active",
      inactive: "Inactive",
      page: "Page",
      dateCreated: "Date Created",
      notFound: "Not Found",
      green: "green",
      grey: "grey",
      selectLimit: "Select Limit",
      selectCustomer: "Select Customer",
      editPrice: "Edit Price",
      apply: "Apply",
      editProduct: "Edit Product",
      editProductClass: "Edit Product Group",
      editProductTag: "Edit Product Tag",
      editName: "Edit Name",
      editDescription: "Edit Description",
      savePrice: "Save Price",
      createProduct: "Create Product",
      noResultsFound: "No Results found",
      notApplicable: "N/A",
      priceAmount: "Price Amount",
      enterAPriceAmount: "Enter a Price Amount",
      cannotDeactivateDefaultPrice: "Cannot Deactivate Default Price",
      cannotDeactivateLocationDefaultPrice:
        "Remove all location assignments before deactivating this price.",
      locationDefault: "Location Default",
      defaultAtLocations: "Default at locations",
      defaultAtLocationsCreateHint: "This price will be selected by default at these locations.",
      defaultAtLocationsEditHint: "Clear all locations to restore the product's global default.",
      locationDefaultTooltip: "Default for {locations}",
      createAProductInstantly:
        "No products in your catalog yet. Products are the sellable items or variants customers buy. Add details like name, description, pricing, and inventory. Use product groups for families like a hoodie with multiple sizes/colors, and tags for filters or reporting.",
      createAProductClassInstantly:
        "No product groups yet. Groups help customers browse a product family first, then choose a sellable variant. For example, create a 'Shirt' group, then add variants based on size, color, or other options.",
      createAProductTagInstantly:
        "No tags available. Tags are flexible markers for filtering, reporting, or kiosk browse filters, such as 'Featured', 'Staff Favorites', or 'Winter Collection'. Get started with your first tag!",
      priceIsAlreadySetAsDefault: "Price is already set as the Default Price",
      priceMustBeActive: "Only active prices can be set to default",
      paymentLink: "Payment Link",
      copyAndShare: "Copy and share to start accepting payments with this link.",
      quantity: "Quantity",
      adjQuantity: "Adjustable Quantity",
      and: "and",
      moreFor: "more for",
      activeLC: "active",
      yes: "Yes",
      no: "No",
      downloadImage: "Download Image",
      downloadQRImage: "Download QR",
      CopyImage: "Copy Image",
      CopyQRCode: "Copy QR",
      sendToTerminal: "Buy",
      selected: "selected",
      saveAndContinue: "Save & Continue",
      defaultWithBrackets: "(Default)",
      total: "Total",
      subTotal: "Subtotal",
      clearAllFilters: "Clear All Filters",
      tax: "Tax",
      discount: "Discount",
      source: "Source",
      editDetails: "Edit Details",
      you: "You",
      archive: "Archive",
      lastUpdated: "Last Updated",
      paymentLowercase: "payment",
      to: "to",
      searchCustomers: "Search Customers",
      copiedToClipboard: "Copied to clipboard!",
      override: "Override",
      resetToDefault: "Reset to Default",
      view: "View",
      bulkAdjustInventory: "Bulk Adjustment",
      inventoryAdjusted: "Inventory adjusted successfully",
      downloadTemplate: "Download the Nectar Pay product template CSV",
      downloadTemplateButton: "Download Template",
      downloadTemplateDescription:
        "Download our template to ensure your product data is formatted correctly for import.",
      downloadProductTemplateDescription:
        "Download our template to ensure your product data is formatted correctly for import.",
      downloadPriceTemplateDescription:
        "Download our template to ensure your price data is formatted correctly for import.",
      downloadInventoryTemplateDescription:
        "Download our CSV template to prepare your inventory adjustments.",
      populateTemplate: "Populate the CSV with your products details",
      uploadFile: "Upload your completed CSV file",
      uploadProductTagsFile: "Upload your product tags CSV file",
      productsImported: "{count} products imported successfully",
      productsImportProcessed: "Processed {count} product row.|Processed {count} product rows.",
      productsImportCreatedProducts: "{count} product created.|{count} products created.",
      productsImportUpdatedProducts: "{count} product updated.|{count} products updated.",
      productsImportCreatedPrices: "{count} price created.|{count} prices created.",
      productsImportUpdatedPrices: "{count} price updated.|{count} prices updated.",
      productsImportWarningNoChanges:
        "Processed {count} product row, but no products or prices were created or updated. Review your CSV and try again.|Processed {count} product rows, but no products or prices were created or updated. Review your CSV and try again.",
      pricesImportProcessed: "Processed {count} price row.|Processed {count} price rows.",
      pricesImportCreated: "{count} price created.|{count} prices created.",
      pricesImportFailed: "{count} price failed.|{count} prices failed.",
      pricesImportUpdated: "{count} price updated.|{count} prices updated.",
      pricesImportDefaultUpdated:
        "{count} product default price updated.|{count} products' default prices updated.",
      pricesImportWarningNoChanges:
        "Processed {count} price row, but no prices were created or updated. Review your CSV and try again.|Processed {count} price rows, but no prices were created or updated. Review your CSV and try again.",
      populateTemplateDescription:
        "Fill in the template with your product information. Products with the same identifier will be grouped together with different price options.",
      populateProductTemplate: "Populate the CSV with your products details",
      populateProductTemplateDescription:
        "Fill in the template with your product information. Products with the same identifier will be grouped together with different price options.",
      populatePriceTemplate: "Populate the CSV with your price details",
      populatePriceTemplateDescription:
        "Add one row per price you want to create or update. Use the product ID exactly as it appears in Stripe.",
      populateInventoryTemplateDescription: "Fill in the template with your inventory adjustments.",
      productNameDescription: "Product name and description",
      priceCurrency: "Price and currency",
      productStatus: "Product status (active/inactive)",
      uploadFileDescription: "Select your completed CSV file to import your products.",
      uploadProductFileDescription: "Select your completed CSV file to import your products.",
      uploadPriceFileDescription: "Select your completed CSV file to import prices.",
      uploadInventoryFileDescription: "Upload your completed CSV file to adjust inventory.",
      selectCSVFile: "Select CSV file",
      csvFilePlaceholder: "Click to browse or drag and drop",
      onlyCSVSupported: "Only CSV files are supported",
      import: "Import",
      adjust: "Adjust Inventory",
      pleaseSelectCSV: "Please select a CSV file",
      onlyCSVAllowed: "Only CSV files are supported",
      inventoryAdjustmentBehavior:
        "Each row in your CSV adjusts inventory for one product and location scope. The product_id field should match your product's unique identifier. The adjustment_action field determines how the quantity is applied (add, remove, or set), and adjustment_quantity must always be a positive number. Use separate rows if the same product needs different quantities at different locations.",
      csvFieldsTitle: "Product Field Details",
      productImportFieldsTitle: "Product Field Details",
      saveCSVFormat: "Save your file in CSV format when complete.",
      priceIdentifierDesc:
        "A unique SKU for each price option. Must be unique within this import file. This is a required field if has_inventory is true.",
      inventoryPriceSkuDesc: "SKU of the specific price option",
      priceUnitAmountDesc:
        "The static price expressed in a numeric monetary amount (e.g., 10, 10.1 or 10.00)",
      priceActiveDesc: "Indicates whether the price is active (true/false)",
      priceNicknameDesc:
        "A human-friendly label for the price. Only used if price_amount_decimal is set",
      deactivatePricesDesc:
        "Optional true/false flag (leave blank for false). If true, deactivates all other prices associated with the provided product ID (it will not deactivate the new default price being imported via price_amount_decimal and price_nickname).",
      priceLowStockThresholdDesc:
        "The threshold at which this price option is flagged as low stock. When inventory falls below this number, a low stock alert will be triggered.",
      priceStartingStockAmountDesc:
        "The initial inventory quantity for this price option. This sets the starting stock level for the product variant.",
      hasInventoryDesc: "Optional true/false flag. Leave blank for no change.",
      stockCountDesc: "Starting stock count for new products. Must be a non-negative integer.",
      oversellTypeDesc:
        "Overselling mode. Use 'none', 'limited', or 'unlimited'. Only used when inventory is enabled.",
      oversellAmountDesc:
        "Positive quantity that can be oversold when oversell_type is 'limited'. Saved as a negative stock floor.",
      assignedLocationIdsDesc:
        "Comma-separated list of terminal location IDs to assign this product to (e.g., 'tml_1234,tml_5678'), or use 'all' to assign it to all locations. Only supported when location-based inventory is enabled.",
      adjustmentQuantityDesc:
        "Positive quantity to adjust. To remove inventory, set adjustment_action to 'remove'.",
      adjustmentActionDesc:
        "The action to be taken on the inventory. Valid values include: 'add' (increase inventory), 'remove' (decrease inventory), or 'set' (replace inventory)",
      adjustmentReasonDesc:
        "Reason for the adjustment (e.g., 'Restock', 'Damaged', 'Inventory Count')",
      adjustmentNotesDesc: "Additional notes about this adjustment",
      referenceCodeDesc:
        "A unique code to identify and track the adjustment operation for auditing and reference purposes",
      memoDesc: "Additional context or details about the adjustment",
      importNote: "Important:",
      productPriceImportBehavior:
        "Products with the same product_identifier will only be created once. Each row in your CSV will create a new price object, allowing you to add multiple price options for the same product.",
      priceImportNote:
        "Each row either creates a price or reuses an existing price. Leave price_id blank to create a price, or provide price_id to assign an existing price as a global or location default.",
      priceImportFieldsTitle: "Price CSV fields",
      importRequiredNew: "Required (New)",
      importRequiredUpdate: "Required (Update)",
      importRequiredNewProductsHint: "Must be included for new products.",
      importRequiredUpdateProductsHint: "Must be included to update existing products.",
      importRequiredUpdateProductGroupHint: "Must be included to update an existing product group.",
      importRequiredUpdateProductTagHint: "Must be included to update an existing product tag.",
      importOptionalHint: "Can be left blank.",
      priceImportRequiredHint: "Must be provided on every row.",
      priceImportOptionalHint: "Optional or conditionally required as described below.",
      priceImportProductIdDesc: "The Stripe product identifier the price belongs to.",
      priceImportPriceIdDesc:
        "Optional existing Stripe Price ID. When provided, amount, nickname, and tax behavior must be blank.",
      priceImportAmountDesc:
        "The price amount in decimal format (e.g., 12.99). Required when price_id is blank; leave blank when reusing a price.",
      priceImportDefaultDesc:
        "Optional TRUE/FALSE flag. TRUE makes the created or existing price the product's global default and cannot be combined with location_id.",
      priceImportLocationDesc:
        "One active location assigned to the product. Makes the created or existing price that location's default.",
      priceImportNicknameDesc:
        "Optional label to make this price easier to recognize in exports and reports.",
      priceImportTaxBehaviorDesc:
        "Optional tax behavior. Leave blank for unspecified, or enter inclusive or exclusive.",
      priceImportOptionalFlagNote:
        "For an existing price_id, provide location_id or set is_global_default to TRUE.",
      productTagImportBehavior:
        "Product tags with the same ID will be updated if they already exist. Each row in your CSV represents a single product tag.",
      productImportBehavior:
        "Products with the same ID will be updated if they already exist. Each row in your CSV represents a complete product.",
      lowStockThresholdDesc:
        "The threshold at which the product is flagged as low stock, only used when has_inventory is explicitly true",
      priceAmountDecimalDesc:
        "The price amount in decimal format (e.g., 12.99). If set, this will become the default price for the product",
      productIdDesc:
        "Required to update an existing product. Leave blank to create a new product (an ID will be auto-generated).",
      productSkuDesc:
        "Stock Keeping Unit - a unique identifier for the product in your catalog. Each product must have a unique SKU",
      productTagIdsDesc:
        "A comma-separated list of product tag IDs to assign to this product (e.g., 'STAFF-001,BEST-003')",
      productUrlDesc: "A URL related to this product, can link to your website or other resources",
      downloadProductClassTemplateDescription:
        "Download our template to ensure your product group data is formatted correctly for import.",
      populateProductClassTemplate: "Populate the CSV with your product group details",
      populateProductClassTemplateDescription:
        "Fill in the template with your product group information. Each row represents one browseable group. Groups with the same ID will be updated if they already exist.",
      productClassImportFieldsTitle: "Product Group Field Details",
      uploadProductClassFileDescription:
        "Select your completed CSV file to import your product groups.",
      downloadProductTagTemplateDescription:
        "Download our template to ensure your product tag data is formatted correctly for import.",
      populateProductTagTemplate: "Populate the CSV with your product tag details",
      populateProductTagTemplateDescription:
        "Fill in the template with your product tag information. Each row represents a single product tag. Tags with the same ID will be updated if they already exist.",
      productTagImportFieldsTitle: "Product Tag Field Details",
      uploadProductTagFileDescription:
        "Select your completed CSV file to import your product tags.",
      productClassesImportProcessed:
        "Processed {count} product group row.|Processed {count} product group rows.",
      productClassesImportCreated: "{count} product group created.|{count} product groups created.",
      productClassesImportUpdated: "{count} product group updated.|{count} product groups updated.",
      productClassesImportWarningNoChanges:
        "Processed {count} product group row, but no product groups were created or updated. Review your CSV and try again.|Processed {count} product group rows, but no product groups were created or updated. Review your CSV and try again.",
      productTagsImportProcessed:
        "Processed {count} product tag row.|Processed {count} product tag rows.",
      productTagsImportCreated: "{count} product tag created.|{count} product tags created.",
      productTagsImportUpdated: "{count} product tag updated.|{count} product tags updated.",
      productTagsImportWarningNoChanges:
        "Processed {count} product tag row, but no product tags were created or updated. Review your CSV and try again.|Processed {count} product tag rows, but no product tags were created or updated. Review your CSV and try again.",
    },
    cart: {
      cart: "Cart",
      addToCart: "Add",
      addToCartDisabledSelectLocation: "Select a location to add this item to the cart.",
      addToCartDisabledUnsupportedLocation: "This product is not available at {location}.",
      addToCartDisabledInactivePrice: "This price is inactive.",
      addToCartDisabledNoStockForLocation: "No stock is configured for {location}.",
      addToCartDisabledOutOfStock: "Out of stock at {location}.",
      removeFromCart: "Remove from Cart",
      checkout: "Checkout",
      clearCart: "Clear Cart",
      noItems: "No items in cart",
      copyCart: "Copy Cart",
      taxCartNote: "* Taxes will be calculated at checkout based on your location ({location})",
      standardPrice: "Standard",
      unit: "unit",
      eachAbbreviation: "ea.",
      discount: "Discount",
      cartDiscount: "Cart discount",
      clearDiscounts: "Clear discounts",
      originalSubtotal: "Original subtotal",
      discountsApplied: "Discounts applied",
      exceedsLimit: "Exceeds ({limit})",
      oversellingTo: "Overselling to {count}",
      atOversellLimit: "At oversell limit",
      onlyStockLeft: "Only {count} left",
      stockAvailable: "{count} available",
      unlimited: "Unlimited",
      atLocation: " at {location}",
      discountPerUnit: "-{amount} ea.",
      itemOutOfStock: '"{item}" is out of stock.',
      itemsOutOfStock: "{count} items in your cart are out of stock.",
      itemExceedsOversellLimit:
        'Requested quantity for "{item}" exceeds the oversell limit ({limit}).',
      itemsExceedOversellLimits:
        "Requested quantities for {count} items exceed their oversell limits.",
      inventoryIssuesPreventCheckout: "Inventory issues prevent checkout.",
    },
    country: {
      canada: "Canada",
      unitedStates: "United States",
      US: {
        code: "US",
        currency: "usd",
      },
      CA: {
        code: "CA",
        currency: "cad",
      },
    },
    entity: {
      user: "user",
    },
    notification: {
      paymentReceived: "Payment Received",
    },
    drag: "Drag",
    here: "Here",
    image: "image",
    images: "images",
    file: "file",
    files: "files",
    browse: "Browse",
    preview: "Preview",
    uploadNew: "Upload New",
    noResultsFound: "No results found",
    tryDifferentFilters: "Try adjusting your filters or search criteria",
    deleteMsg: "The {0} was deleted successfully",
    deactivateMsg: "The {0} was successfully deactivated",
    activateMsg: "The {0} was successfully activated",
    checkEmail: "Check your email",
    verifyEmail:
      "We have sent an email to {0} to confirm your email address and activate your account. Please check your inbox and follow the instructions in the email.",
    verifyEmailNote: "Note that the link provided in the email will expire in 24 hours.",
    resendEmailNote: "Didn't receive email? Check your spam filter or",
    resetPasswordNote:
      "Enter email associated with your account and we will send an email with instructions to reset your password.",
    items: "items",
    filter: {
      apply: "Apply Filter",
      clear: "Clear Filter",
      clearAll: "Clear All Filters",
      byProduct: "Product",
      byPrice: "Price",
      byName: "Filter by Name",
      byNickname: "Filter by Nickname",
      byProductGroup: "Group",
      byProductGroupTitle: "Filter by Group",
      catalog: "Groups",
      productFilterNotice: "When filtering by a product, other filters will be cleared.",
      tagMatchType: "Match Type",
      exactMatch: "Exact Match",
      anyMatch: "Any Match",
      exactMatchHint: "Products must have all selected tags",
      anyMatchHint: "Products with any of the selected tags will match",
      nameMinCharacters: "Name (min 3 characters)",
      nameMinCharactersError: "Name search must be at least {0} characters",
    },
    search: {
      products: "Search Products",
      productGroups: "Search groups",
      catalog: "Search Groups",
      noProductsFound: "No Products Found",
    },
    message: {
      additionalFieldsLater: "You can add more product details after creation.",
      exportWithFilters: "Your current filters will be applied to your export.",
      exportPricesWithFilters: "Your current Catalog filters will be applied to the price export.",
      noActiveFilters: "No filters currently applied. All products will be exported.",
      noActivePriceExportFilters:
        "No filters currently applied. Prices for all matching products will be exported.",
      exportProductTagsWithFilters:
        "Your current product tag filters will be applied to your export.",
      noActiveProductTagFilters: "No filters currently applied. All product tags will be exported.",
      printQRCodesDescription: "Your current filters will be applied to the QR codes generation.",
      activeFilters: "Active Filters:",
      selectedCount: "{count} selected",
      noProductsWithTag: "No products have this product tag yet.",
      noRecords: "No records found",
      loading: "Loading...",
      receiptPrintWarning: "Payment successful. We couldn’t confirm receipt printing.",
    },
    label: {
      nickname: "Nickname",
      sku: "SKU",
      product: "Product",
      productClass: "Product Group",
      myLocation: "My Location",
      allLocations: "All locations",
      lowStock: "Low Stock Items Only",
      outOfStock: "Out of Stock Items Only",
      stockRange: "Stock Range",
      global: "Global",
      unbounded: "∞",
      inventory: "Inventory",
      status: "Status",
    },
    status: {
      enabled: "Enabled",
      disabled: "Disabled",
      active: "Active",
      inactive: "Inactive",
    },
    snackbar: {
      dismiss: "Dismiss toast: {message}",
    },
  },
  importData: {
    newImport: "New Operation",
    uploadQueued: "Operation uploaded and queued for processing.",
    noImports: "No bulk operations have been created yet.",
    types: {
      products: "Import Products",
      prices: "Import Prices",
      product_groups: "Import Groups",
      product_tags: "Import Tags",
      customers: "Import Customers",
      inventory_adjustments: "Bulk Inventory Adjustment",
    },
    statuses: {
      queued: "Queued",
      validating: "Validating",
      validation_failed: "Validation failed",
      importing: "Processing",
      succeeded: "Succeeded",
      completed_with_errors: "Completed with errors",
      failed: "Failed",
      cancelled: "Cancelled",
    },
    phases: {
      validation: "Validation",
      importing: "Processing",
      system: "System",
    },
    filters: {
      type: "Operation",
      status: "Status",
      filterByType: "Filter by operation",
      filterByStatus: "Filter by status",
    },
    table: {
      file: "File",
      type: "Operation",
      status: "Status",
      rows: "Rows",
      createdBy: "Created by",
    },
    detail: {
      createdBy: "Created by",
      createdAt: "Created at",
      rows: "CSV rows",
      outcome: "Outcome",
      errors: "Errors",
      phase: "Phase",
      row: "CSV row",
      reason: "Reason",
      loadMore: "Load more errors",
    },
    cancel: {
      title: "Cancel queued operation?",
      action: "Cancel operation",
      message: "Cancel {file}? The uploaded file will be deleted and no rows will be processed.",
      success: "Operation cancelled.",
    },
    stats: {
      createdProducts: "Products created",
      updatedProducts: "Products updated",
      failedProducts: "Products failed",
      createdPrices: "Prices created",
      updatedPrices: "Prices updated",
      defaultPricesUpdated: "Default prices updated",
      failedPrices: "Prices failed",
      createdProductGroups: "Product groups created",
      updatedProductGroups: "Product groups updated",
      failedProductGroups: "Product groups failed",
      createdProductTags: "Tags created",
      updatedProductTags: "Tags updated",
      failedProductTags: "Tags failed",
      createdCustomers: "Customers created",
      failedCustomers: "Customers failed",
      totalAdjustments: "Total adjustments",
      addCount: "Stock additions",
      removeCount: "Stock removals",
      setCount: "Stock values set",
      batchesProcessed: "Batches processed",
    },
  },
  platform: {
    pos: "POS Terminal",
    account: "Already have an account?",
    newWindow: "Open in a new window",
    newAccount: "Need a new account?",
    changeSessionLoading: "Reloading the site with the new account selected...",
    tagline: "Modern Terminal Payment Solutions for Your Business",
    joinUs: "Join businesses transforming payments",
    loading: "Loading",
    loginLoading1: "Buzzing up something special for you",
    loginLoading2: "Gathering the nectar of innovation",
    loginLoading3: "Honeycombing through the final details",
    loginLoading4: "Pollinating your app with the latest features",
    loginLoading5: "Winging our way to readiness",
    loginLoading6: "Making a beeline to completion",
    loginLoading7: "Bees at work! Preparing your sweet experience",
    loginLoading8: "Just a hive moment away",
    loginLoading9: "Crafting a buzzworthy experience",
    loginLoading10: "Fluttering through the final checks",
    loginLoading11: "Building the buzz! Almost there",
    loginLoading12: "Sweeping the hive for perfection",
    loginLoading13: "Sprucing up the honey pot",
    loginLoading14: "Fine-tuning our buzzers and whistles",
    loginLoading15: "Perfecting our pollen technique",
    inviteLoading: "We are taking the info from the token please wait...",
    logoutLoading: "You are leaving now hope see you soon again...",
    logout: "Logout",
    menu: {
      dashboard: "Dashboard",
      payments: "Payments",
      products: "Products",
      terminals: "Terminals",
      account: "Account",
      users: "Users",
      help: "Help",
      logout: "Logout",
      customers: "Customers",
      paymentLinks: "Payment Links",
      forms: "Forms",
      fleetManagement: "Locations",
      hardwareOrders: "Hardware orders",
      management: "Management",
      settings: "Settings",
      PRODUCT_CATALOG: "Catalog",
      INVENTORY_MANAGEMENT: "Inventory Management",
      productCatalog: "Catalog",
      inventoryManagement: "Inventory Management",
      inventory: "Inventory",
      reports: "Reports",
      importData: "Bulk Operations",
      productClasses: "Groups",
      productTags: "Tags",
    },
  },
  errors: {
    fieldRequired: "This is a required field",
    maxCharLimit: "Max {0} characters",
    email: "Invalid email",
    name: "Name cannot contain any special characters",
    password: "Password must be at least 8 characters long",
    agree: "You must agree to continue",
    matchingPasswords: "Both passwords must match",
    authName: "A full name must be provided",
    required: "Required",
    number: "Input must be a number.",
    minValue: "Input must be at least {0}",
    maxValue: "Input must be at most {0}",
    loginEmailNotVerified:
      "The email is not verified, check you inbox we send the verification again",
    emailExists: "Email already exist",
    refundMoreThan: "Refund cannot be more than ",
    unauthenticated: "User not authenticated",
    refundExceed: "Amount can't be more than ${0}",
    numberRange: "Simulated Quantity must be between 1 and 99",
    url: "Invalid URL",
    quantity: "Quantity must be greater than 0",
    characterLimit: "Limit must be greater than 0",
    nameRequired: "Please provide a name",
    provideConfirmationPageUrl: "Please provide a URL",
    httpsRequired: "URL must start with 'https://'",
    customMessageCannotBeEmpty: "Custom message cannot be empty",
    defaultError: "An error occurred. Please try again.",
    credentialsProblem: "There was a problem with your credentials. Please log in again.",
    networkRequestFailed:
      "We could not reach the authentication service. Check your connection and try again.",
  },
  navBar: {
    login: "Login",
    register: "Register",
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    invite: "Invite",
    dashboard: "Dashboard",
    accountSetup: "Account Setup",
    billingPlan: "Billing and Plan",
    users: "User Management",
    readers: "Locations",
    readerDetail: "Locations",
    emailRedirect: "Email Redirect",
    location: "Location",
    payments: "Payments",
    createPayment: "Create Payment",
    processPayment: "Process Payment",
    paymentDetails: "Payment Details",
    account: "Account",
    resetPassword: "Reset Password",
    noTerminal: "Add a terminal to enable payments",
    customers: "Customers",
    customerDetails: "Customer Details",
    products: "Products",
    updateProduct: "Update Product",
    retrieveProduct: "Product Details",
    paymentLinks: "Payment Links",
    createProduct: "Create Product",
    paymentLinksDetail: "Payment Link Details",
    createPaymentLink: "Create Payment Link",
    productDetails: "Product Details",
    updatePaymentLink: "Update Payment Link",
    terminalForms: "Terminal Forms",
    terminalFormDetail: "Terminal Form Details",
    currentAccount: "Current Account",
    settings: "Settings",
    inventoryManagement: "Inventory Management",
    inventory: "Inventory",
    inventoryLog: "Inventory Log",
    reports: "Reports",
    importData: "Bulk Operations",
    importDataDetails: "Bulk Operation Details",
    scanner: "Scanner",
    kioskPinLogin: "Kiosk Login",
    kioskContext: "Kiosk Context",
    productClasses: "Groups",
    createProductClass: "Create Product Group",
    productClassDetails: "Product Group Details",
    productTags: "Tags",
    createProductTag: "Create Product Tag",
    productTagDetails: "Product Tag Details",
    updateProductTag: "Update Product Tag",
    updateProductClass: "Update Product Group",
  },
  page: {
    hardwareOrders: {
      title: "Hardware orders",
      shop: "Shop",
      shopTitle: "Hardware shop",
      loadError: "Unable to load Stripe hardware ordering. Please try again.",
    },
    signUp: {
      signIn: "Sign In",
      signUp: "Sign Up",
      fullName: "Full Name",
      email: "Email",
      password: "Password",
      confirmPassword: "Confirm Password",
      name: "Name",
      emailAddress: "Email address",
      newPassword: "New Password",
      companyName: "Company Name",
      country: "Country",
      getStarted: "Get Started",
      continue: "Continue",
      resend: "Resend",
      details: "Details",
      verifyEmail: "Verify Email",
      company: "Company",
      welcomeBack: "Welcome Back",
      signInToContinue: "Sign in to continue to your dashboard",
      createAccount: "Create Account",
      reenterPassword: "Re-enter Password",
    },
    login: {
      inviteTitle: "You're invited",
      inviteSubtitle: "Sign in to accept your invite",
      success: "Login successful",
      rememberMe: "Remember me",
      continueMessage: "Or",
      forgotPassword: "Forgot password?",
      google: "Continue with Google",
      emailVerificationSent:
        "Email verification sent! Please check your email and follow the steps to verify your account",
      couldNotFindAccount: "Couldn't find your NectarPay account. Try again with a different email",
      wrongPassword: "Wrong password. Try again or click Forgot password to reset it",
      mfa: {
        title: "Two-factor authentication",
        subtitle: "Enter the 6-digit code from your authenticator app",
        invalidCode: "Invalid verification code. Try again",
        unsupportedFactor: "This account uses an unsupported second factor",
      },
    },
    inviteAcceptance: {
      title: "You're invited",
      description:
        "Confirm that you want to accept this invite and switch into the invited account.",
      account: "Account",
      email: "Email",
      role: "Role",
      acceptInvite: "Accept invite",
      switchAccount: "Switch account",
      alreadyAccepted: "This invite has already been accepted.",
      anotherEmail: "This invite is for another email address. Sign out to accept it.",
      invalidLink: "Invalid invite link.",
      invalidOrExpired: "This invite is invalid or expired.",
      invalid: "This invite is invalid.",
      unableToAccept: "Unable to accept invite.",
    },
    kiosk: {
      shell: {
        eyebrow: "Kiosk",
        title: "Browse Catalog",
      },
      login: {
        title: "Enter Kiosk PIN",
        subtitle: "Use the 6-digit kiosk PIN to unlock this device.",
        pinLabel: "Kiosk PIN",
        pinPlaceholder: "Enter 6-digit PIN",
        submit: "Unlock Kiosk",
        installApp: "Install Kiosk App",
        expiredSession:
          "Your kiosk session expired or was invalidated. Enter the PIN again to continue.",
        genericError: "Kiosk login failed. Try again.",
      },
      launcher: {
        title: "Opening Kiosk",
        loading: "Restoring this kiosk on the device...",
        unpairedTitle: "Set up this kiosk",
        unpairedBody:
          "This device is not linked to a kiosk yet. Open the kiosk public URL from settings on this device to finish setup, then install the app.",
        errorTitle: "Unable to open kiosk",
        errorBody:
          "We couldn't restore the kiosk right now. Try again or reopen the kiosk public URL on this device.",
      },
      splash: {
        eyebrow: "NectarPay Kiosk Experience",
        title: "Touch to Start",
        subtitle: "Browse, compare, and build your cart at your own pace.",
        cta: "Touch to start",
        scanBarcodes: "Scan Barcodes",
      },
      catalog: {
        title: "Catalog",
        subtitle: "Choose a product, then pick the variant you want to add.",
        searchLabel: "Search",
        searchPlaceholder: "Search",
        empty: "No kiosk-visible products are available right now.",
        noSearchResults: "No matching products found.",
        noDescription: "No description available.",
        noSku: "No SKU",
        classes: "classes",
        backToTags: "Back",
        allClasses: "All Products",
        filterByClassTag: "Filter by category",
        classTagFilterSubtitle: "Use tags to narrow the product groups shown below.",
        shopByClassTag: "Shop by category",
        classTagLandingSubtitle:
          "Choose a category to quickly browse the products available in this kiosk catalog.",
        seeAllVariants: "See all",
      },
      detail: {
        title: "Product Details",
        back: "Back",
        addToCart: "Add to Cart",
        noDescription: "No description available.",
        noAdditionalStock: "No additional stock is available for {productName}.",
        notFoundTitle: "Product not available",
        notFoundBody: "This product is not visible for the current kiosk session.",
      },
      cart: {
        title: "Cart",
        clear: "Clear",
        empty: "Your cart is empty.",
        checkout: "Checkout",
        maxStock: "Max stock",
      },
      checkout: {
        eyebrow: "Review Order",
        title: "Checkout",
        subtitle: "Confirm your order, choose a receipt option, and send payment to the terminal.",
        loading: "Preparing your checkout...",
        orderSummary: "Order Summary",
        noItems: "Your cart is empty.",
        noImageAvailable: "No image available",
        quantity: "Qty {quantity}",
        unitAmount: "{amount} ea.",
        tax: "Tax",
        total: "Total",
        receiptTitle: "Receipt Preference",
        receiptCaption: "Choose how to receive your receipt",
        receiptPrint: "Print",
        receiptEmail: "Email",
        receiptBoth: "Print + Email",
        receiptNone: "None",
        receiptPrintDescription: "Print at the kiosk",
        receiptEmailDescription: "Email it to the customer",
        receiptBothDescription: "Print and email the receipt",
        receiptNoneDescription: "No receipt",
        receiptHelper: "Choose whether to print the receipt, send it by email, or both.",
        receiptPrintError: "Receipt could not be printed. Please ask a team member for assistance.",
        receiptDialogTitle: "How would you like your receipt?",
        receiptDialogSubtitle: "Choose a receipt option after reviewing your order.",
        receiptDialogConfirm: "Continue to Payment",
        editOrder: "Edit Order",
        editOrderHelper:
          "Need to change an item or quantity? Go back to update your order before paying.",
        cancelCheckout: "Cancel Checkout",
        pay: "Pay",
        processing: "Payment is being sent to the terminal",
        conflict: "Unable to update checkout. Please try again.",
        unavailable: "This cart is no longer available. Please start a new order.",
        canceled: "Checkout was canceled. Clear the checkout to rebuild the order.",
        transactionCanceled: "Transaction canceled.",
        failed: "Payment did not complete. Please try again or use another payment method.",
        emailLabel: "Receipt Email",
        emailRequired: "Required",
        emailPlaceholder: "Email address",
        done: "Done",
        backToCatalog: "Back to Catalog",
        totalPaid: "Total Paid",
        successEyebrow: "Payment Complete",
        successTitle: "Payment Successful",
        successBody:
          "The kiosk will return to the start screen in a moment, or you can go back to the catalog now.",
        successReceiptPrint: "Your receipt is printing.",
        successReceiptEmail: "Your receipt will be sent by email.",
        successReceiptBoth: "Your receipt is printing and will be sent by email.",
        successReceiptNone: "No receipt selected.",
        successReceiptEmailAddress: "Email: {email}",
      },
      session: {
        title: "Still there?",
        body: "Touch continue to keep browsing the catalog.",
        countdown: "Session resets in {seconds}s.",
        continue: "Continue",
        scanLoading: "Looking up scanned item...",
        scanAddedToCartMessage: "{productName} added to your cart.",
        scanAddedToCartSubtitle: "{productGroupName} · Added to your cart",
        scanInvalidResponse: "Scanned item is unavailable for purchase.",
        scanNotFound: "Item not found",
      },
      context: {
        title: "Kiosk Context",
        loading: "Loading kiosk context...",
        logout: "Log out",
        genericError: "Unable to load kiosk context.",
        kioskId: "Kiosk ID",
        accountId: "Account ID",
        locationId: "Location ID",
        terminalId: "Terminal ID",
        receiptPrinterId: "Receipt Printer ID",
        allowedPublicIp: "Allowed Public IP",
        confirmationTimeout: "Confirmation Timeout (seconds)",
        sessionTimeout: "Session Timeout (seconds)",
        catalogLandingMode: "Catalog Landing Mode",
        catalogOrdering: "Catalog Ordering",
        catalogOrderingAlphabetical: "Alphabetical",
        catalogOrderingDefined: "Defined Sort",
        jwtExpiryDays: "JWT Expiry Days",
        sessionExpiresAt: "Session Expires At",
      },
      unavailable: {
        title: "Kiosk unavailable",
        body: "This kiosk is unavailable or unauthorized right now. Please contact staff for assistance.",
      },
    },
    resetPassword: {
      saveNewPassword: "Save New Password",
      successResetPassword: "New password has been reset successfully",
      EMAIL_NOT_FOUND: "Email not found",
      errorResetPassword: "There was a problem resetting the new password. Try later",
      newPasswordNote: "Your new password must be different from previously used passwords.",
      recoverPasswordNote: "We have sent password recovery instructions to your email.",
      checkSpam: "If you don't see the email in your inbox, please check your spam folder.",
      error:
        "This email address is not associated with an account. Please check your email address or sign up for a new account.",
      resetPassConfirm:
        "You are resetting the password for this User. A temporary password will be generated and sent to their email address. Please ensure that they change their password upon logging in for security reasons.",
    },
    users: {
      error: {
        user_00: "The user already belong to the account",
        user_01: "You cannot delete yourself",
        user_02: "Owner cannot be deleted",
        user_03: "User does not belong to account",
        user_04: "UID or Email required",
        user_05: "Admins can adjust all roles on everyone except Owner",
        user_06: "Must be only one Owner per account",
        user_07: "Invalid Role or Account",
        user_08: "Owner role cannot be changed",
        user_09: "Email has not been previously invited",
        user_10: "User doesn't exists",
        user_11: "You cannot deactivate yourself",
        user_12: "Owner cannot be deactivated",
      },
      title: {
        allUser: "All Users",
        total: "total",
        inactive: "inactive",
        active: "active",
        invited: "invited",
        addUser: " Add User",
        name: "Name",
        accessLevel: "Access Level",
        assignedLocations: "Assigned Locations",
        itemSelected: "Items Selected",
        activeStatus: "Active Status",
        twoFactor: "2FA",
      },
      invite: {
        add: "Invitation email was sent successfully",
        reinvite: "Invitation email was resent successfully",
      },
      userRoles: {
        owner: "Owner",
        admin: "Admin",
        staff: "Staff",
      },
      activate: "Activate User",
      deactivate: "Deactivate User",
    },
    locations: {
      locationName: "Location Name",
      location: "Location",
      locations: "Locations",
      sectionHint:
        "Utilize locations to oversee your readers and their activities by linking them to a specific physical operating site.",
      country: "Country",
      city: "City",
      addressLine1: "Address line 1",
      addressLine2: "Address Line 2",
      state: "State",
      province: "Province",
      postalCode: "Postal Code",
      address: "Address",
      terminals: "Terminals",
      zip: "ZIP",
      zipOrPostalCode: "ZIP / Postal Code",
      deleteLocationConfirm:
        "Are you sure you want to delete this location? This action cannot be undone.",
      howToSetUp: "Configure Your Location: Customize Terminal Background & Set Up Tipping",
      setUpGuide:
        "With a few simple steps, you can tailor your terminal backgrounds to match your brand and set up a tipping feature that encourages a seamless checkout experience for your customers.",
      noLocation: "Set up your first location and reader to start taking payments",
      configureSettings: "Tipping, backgrounds & more",

      configuration: {
        dialog: {
          error: {
            conf_04:
              "Invalid param: wisepos_e, found: Splashscreen exceeds maximum dimensions for this device type: 720 x 1280, Invalid param wisepos_e",
          },
          title: "Location Configuration",
          success: "Configuration {0} successfully",
          tipping: {
            title: "Tipping ",
            amount: {
              title: "Amount ",
            },
            percentage: {
              title: "Percentage ",
            },
            smartTip: {
              title: "Smart Tip ",
            },
          },
          background: {
            title: "Background ",
            subtitle: "Set location splash screen",
            header: "This image is shown on each WisePOS E at this location when idle.",
            bulletTitle: "The image must be:",
            bullet1: "720W X 1280H",
            bullet2: "JPG, PNG, or GIF format",
            bullet3: "Less than 2MB for JPG and PNG",
            bullet4: "Less than 4MB for GIF",
            footer: "After uploading, it may take several minutes for the splash screen to appear.",
          },
          deleteConfigurationHint:
            "Configuration changes are not immediate, and could take a few minutes to propagate",
          removeAllConfigurations: "Remove All Configurations",
          smartTipHint:
            "Below this amount, fixed amounts will be displayed; above it, percentages will be displayed",
        },
      },
    },
    terminals: {
      error: {
        fav_00: "This terminal is already added to favorites.",
        fav_01: "Cannot remove from favorites because this terminal is not in your favorites list.",
        fav_02:
          "You can only add up to 5 terminals to your favorites. Please remove one from your favorites before adding a new one.",
        fullTerminalUsage:
          "You can't add a new terminal, please upgrade the plan or increase the quantity.",
        receiptPrinterAssignmentForbidden:
          "Only owners or admins can change receipt printer assignment.",
        receiptPrinterAssignmentMissing:
          "That receipt printer no longer exists. Refresh and choose another printer.",
      },
      terminal: "Terminal",
      terminals: "Terminals",
      terminalId: "Terminal ID",
      activeStatus: "Active Status",
      readerId: "Reader Id",
      model: "Model",
      serialNumber: "Serial Number",
      lastSeen: "Last seen",
      offline: "Offline",
      active: "Active",
      inactive: "Inactive",
      activate: "Activate",
      deactivate: "Deactivate",
      planUsage: "Plan usage",
      addedFav: "Added to Favorite",
      removedFav: "Removed from Favorite",
      order: {
        orderTerminal: "Order Terminals",
        followInstruction: "Please follow instructions to order",
        bbpos: "BBPOS WisePOS E",
        orderingInstructions: "Ordering Instructions",
        loginToDashboard: "Login to Dashboard",
        goToTerminalOrderPage: "Go to Terminal order page",
        placeOrder: "Place Order",
      },
      zeroTerminals: "0 Terminals",
      register: {
        registerTerminal: "Register Terminal",
        upgradeYourPlan: "Upgrade your plan to register a new terminal",
        editTerminal: "Edit Terminal",
        code: "Registration Code",
        terminalName: "Terminal Name",
        simulatedQuantity: "Simulated Quantity",
        receiptPrinter: "Receipt Printer",
        receiptPrinterUnassigned: "Unassigned",
        unknownReceiptPrinter: "Unknown printer (deleted)",
        assignedReceiptPrinterUnavailable: "Assigned printer unavailable",
        assignedPrinterDisplay: "Printer: {0}",
        hint: "Trouble finding your registration code? ",
        hint2:
          "To generate a new one, swipe right from the left edge of the reader screen to reveal a Settings button. Tap the Settings button and enter the admin PIN. From here, you can select the option to generate a new pairing code.",
        label: "apple-grape-orange",
        deleteConfirm:
          "Are you sure you want to delete this terminal? This action cannot be undone",
        noTerminal:
          "Please configure your terminal to commence the acceptance of payments at your specified location",
      },
    },
    payment: {
      metadata: {
        customerName: "Customer Name",
        customerEmail: "Customer Email",
        customer: "Customer",
      },
      filtersError: {
        pay_04: "search paymentIntents error",
      },
      payment: "Payment",
      amount: "Amount",
      amountPreTax: "Amount (pre-tax)",
      subtotal: "Subtotal",
      taxes: "Taxes",
      total: "Total",
      totalExcludingTax: "Total Excluding Tax",
      taxesInclusive: "Taxes Inclusive",
      taxesExclusive: "Taxes Exclusive",
      description: "Description",
      last4: "Last 4",
      paymentFailed: "Payment Failed",
      paymentSucceeded: "Payment Succeeded",
      paymentFailedMeg:
        "We're sorry, but it seems that your payment was not successful. Do you want to retry the payment? ",
      paymentSucceededMeg: "Congratulation! Your payment has been successfully processed!",
      motoEnabled: "MOTO Enabled",
      motoDisabled: "MOTO Disabled",
      motoHint: "Mail/telephone order — enter card details on device.",
      preAuthLabel: "Pre-authorization",
      preAuthHint: "Authorize now and capture the authorized amount later.",
      sendToTerminal: "Send Payment to Terminal",
      confirmOrder: "Confirm Order",
      sendOnlinePayment: "Send Online Payment",
      onlinePaymentEmailSent: "Online payment email sent.",
      onlinePaymentReceiptEmailRequired: "Receipt email is required for online payments.",
      onlinePaymentCreateFailed: "Unable to create online payment.",
      onlinePaymentUpdateFailed: "Unable to update online payment.",
      onlinePaymentExistingRequired: "Existing payment is required.",
      onlinePaymentSendFailed: "Unable to send online payment. Please try again.",
      publicPayment: {
        fallbackBusinessName: "NectarPay",
        requestingFor: "{businessName} is requesting payment for:",
        requesting: "{businessName} is requesting payment",
        loading: "Loading payment...",
        unavailableTitle: "Payment Unavailable",
        unavailableMessage: "This online payment is no longer available.",
        succeededTitle: "Payment Succeeded",
        succeededMessage: "Receipt has been emailed.",
        authorizationNotice:
          "This authorizes your card now. The merchant will capture the payment separately.",
        authorizeCta: "Authorize {amount}",
        authorizedTitle: "Authorization completed",
        authorizedMessage:
          "Your card is authorized and awaiting capture by the merchant. This is not a completed payment.",
        authorizationProcessingTitle: "Authorization processing",
        authorizationProcessingMessage: "Your authorization is processing. Do not submit it again.",
        payCta: "Pay {amount}",
        loadPaymentError: "Unable to load payment form. Please try again.",
        submitPaymentError: "Unable to complete payment. Please try again.",
        stripeKeyMissing: "Stripe publishable key is not configured.",
        stripeLoadFailed: "Failed to load Stripe.js",
        stripeUnavailable: "Stripe.js is unavailable.",
      },
      devPresentPayment: "[DEV] Simulate Payment",
      simulatePresentingPayment: "Simulate Presenting Payment",
      simulateMethodCard: "Card",
      simulateMethodInterac: "Interac",
      sendAgain: "Send Again",
      card: "card",
      cardPresent: "card_present",
      interacPresent: "interac_present",
      rawData: "Raw Data",
      reconciliation: "Reconciliation",
      selectSimulateCardToPay: "Select Simulated Card To Pay",
      reportsButtonTooltip: "Reconciliation report is now our payment summary report.",
      tipAmountLabel: "Tip Amount",
      tippingNotSupported: "Tipping has not been configured for this location / currency",
      filter: {
        applyFilter: "Apply Filter",
        clearFilters: "Clear Filters",
        noResultsFound: "No Results Found",
        filterByMetadata: "Filter By Metadata",
        filterByAmount: "Filter By Amount",
        filterByPaymentStatue: "Filter By Payment Status",
        filterByCreationDate: "Filter By Creation Date",
        startDate: "Start Date",
        endDate: "End Date",
        timeZone: "Time Zone",
        est: "EST",
        utc: "UTC",
        minAmount: "Min Amount",
        maxAmount: "Max Amount",
        isEqualTo: "is equal To",
        isGreatThan: "is greater than",
        isLessThan: "is less than",
        isBeforeOrOn: "is before or on",
        isOnOrAfter: "is on or after",
        isBetween: "is between",
        product: "Product",
        price: "Price",
        filterByCustomer: "Filter by Customer",
      },
      deletedHint: {
        location: "This location no longer exists",
        reader: "This reader no longer exists",
        locationAndReader: "This reader & location no longer exist",
      },
      processPayment: {
        selectFromFav: "Select Terminal from Favorite",
        selectLocation: "Select Location",
        selectTerminal: "Select Terminal",
        customerSelected: "Customer on file",
        customerHint: "Search or link a customer",
        enterAmount: "Enter Amount",
        receiptEmailLabel: "RECEIPT EMAIL",
        receiptAutoEmailMessage: "Receipt will be emailed to {email}.",
        printReceiptLabel: "PRINT RECEIPT",
        printReceiptToggleOn: "Print Receipt",
        printReceiptToggleOff: "No Receipt",
        printReceiptAssignedPrinter: "Printer: {printer}",
        printReceiptAssignedPrinterPending: "Printer assigned",
        printReceiptVerifoneTerminal: "Printer: Verifone v660p terminal",
        printReceiptNoPrinterAssigned: "No printer assigned",
        showTipping: "Tipping Displayed",
        hideTipping: "Tipping Hidden",
        tippingToggleHint: "Let customers add a tip directly from the reader",
        cancelPayment: "Cancel Payment",
        finalizeTransaction: "Finalize",
        clearScreen: "Clear Terminal",
        goBack: "Go Back",
        createNewPayment: "Create New Payment",
        createNewTransaction: "Create New Transaction",
        showAllUpdates: "Show All Updates",
        locationAndTerminal: "Location & Terminal",
        summaryCardTitle: "Summary & totals",
        summaryHelper: "Review calculated totals before you send anything to the reader.",
        formSectionTitle: "Terminal Form",
        formSectionSubtitle: "Send custom forms to the reader to collect additional info.",
        formSubmissionsTitle: "Form Submissions",
        formSubmissionTitle: "Form Submission",
        selectFormToSendHint: "Choose a form to enable sending to the terminal.",
        selectTerminalToSendHint: "Select a terminal to send this form.",
        createPaymentBeforeForm: "Create the payment first so the form can be linked to it.",
        formReadyToSend: "Everything looks good—send the form to the selected terminal.",
        sendFormToTerminal: "Send Form to Terminal",
        formSentSuccess: "Form sent to the terminal.",
        noFormsAvailable: "No terminal forms are available for this payment.",
        formSelected: "Form type: {type}",
        chooseForm: "Select the form you'd like to present.",
        locationInfo: "Location follows your current selection in the app bar.",
        noTerminalsForLocation: "No terminals available for this location.",
        transactionFinalized: "Transaction Finalized",
        printingReceipt: "Printing receipt...",
        reprintReceipt: "Reprint receipt",
      },
      timeline: {
        timeline: "Timeline",
        payment_intent_succeeded: "Payment Details",
        payment_intent_payment_failed: "Retry ",
        paymentDetails: "Payment Details",
        loadMore: "Load more",
        paymentCreated: " Created",
        paymentCanceled: "Payment Canceled",
        paymentFailed: "Payment failed",
        paymentFailureFallback: "The terminal could not process this payment.",
        paymentRetryUnavailable: "Unable to check whether this payment can be retried.",
        paymentRefunded: " Refunded",
        partially_refunded: " Partially Refunded",
        noteAdded: " Note Added",
        refundFailed: " Refund Failed",
        partialRefundFailed: " Partial Refund Failed",
        authorizationApproved: "Authorization approved",
        awaitingCapture: "Awaiting capture",
        paymentSucceeded: " Successful",
        requireAction: " Requires Action",
        noTimeLine: "No transaction history at this time",
        noTimeLineStatusHint:
          "Create a payment to see a detailed timeline of payment related events",
        paymentProcessing: " Processing",
        paymentUpdated: " Updated",
        formSubmitted: " Form Submitted",
        formFailed: " Form Failed",
        transactionCompleted: " Transaction Completed",
        paymentOnlinePaymentSent: " Online Payment Link Sent",
        onlinePaymentRecipient: "Recipient Email",
        onlinePaymentLink: "Payment Link",
        noteAndTimeline: "Notes & Timelines",
        note: {
          addNote: "Add Note",
          transactionNote: "Transaction Note",
          saveNote: "Save Note",
        },
      },
      tooltips: {
        cannotRemoveCustomer:
          "Customer cannot be removed from existing payment. Create a new payment if you would like to select a different customer.",
      },
    },
    accountSetup: {
      activateStripe: "Activate your new NectarPay affiliated Stripe account",
      activateStripeStepper: "Activate Stripe",

      addANewLocationDetails:
        "Before adding a terminal, add the location where the terminal will be used",
      addANewTerminalDetails: "Last step! Add a terminal to start collecting payments",
      skipAddingTerminal: "Skip for Now",
      setupStepSuccess: "Select next to continue setting up your Nectar account",
      setupCompleteStepper: "Setup Complete",
      setupComplete: "All done! You're ready to start accepting payments",
      goToDashboard: "Go to Dashboard",
      inactive: "Inactive",
      paymentsEnabled: "Payments Enabled",
      enablePayouts: "Enable Payouts",
      locationAdded: "Location Added",
      readerAdded: "Reader Added",
      complete: "Complete",
      stripeStatus: "Stripe Status:",
      continue: "Continue",
      inactiveDescription: "Inactive means that you cannot process payments",
      paymentsEnableDescription:
        "Payments Enabled allows you to process payments, but you are unable to receive payouts",
      completeDescription:
        "With status Complete, you are able to process payments and receive payouts",
      enablePayments: "Enable Payments",
      enablePayoutsDescriptor:
        "Stripe can take 1-3 business days to verify information collected for payouts.",
      ifInformationProvided: "If you have already provided this information, select continue.",
    },
    dashboard: {
      recentPayments: "Recent Payments",
      favoriteTerminals: "Favorite Terminals",
      noTerminals: "Looks like you have no favorite terminals, click here to get started.",
      addLocationAndTerminal: "With Stripe activated you can now add a location",
      addTerminalLandingCard: "Last step! Add a terminal to start collecting payments",
      noPayments: "It appears no payments have been processed yet.",
      initiatePayment: "Initiate a transaction to process your first payment.",
      addATerminal: "Add a terminal to your favorites for quick and easy access",
      help: {
        setupGuide: "How to Setup Guide",
        setupText: "New around here? Our guide will teach you everything you need to know!",
        orderTerminals: "Order Terminals",
        manageTeam: "Manage Team",
      },
      payments: {
        id: "Id",
        amount: "Amount",
        status: "Status",
        location: "Location",
        terminal: "Terminal",
        date: "Date",
        refund: "Refund",
        viewReceipt: "View Receipt",
        viewDetails: "View Details",
        sendToReader: "Send to Reader",
        cancelPayment: "Cancel Payment",
        cancelError: "Unable to cancel payment. Terminal information is missing.",
      },
      terminals: {
        confirmRemoveMessage: "Are you sure you want to remove this terminal from your Favorites?",
        removeTerminal: "Remove Terminal",
        addFavoriteTerminal: "Add Favorite Terminal",
        selectLocation: "Select Location",
        selectTerminal: "Select Terminal",
      },
    },
    account: {
      accountStatus: "Account Status",
      stripeAccount: "Stripe Account",
      accountStatusRequirements:
        "Visit your Stripe Onboarding to check for any incomplete requirements, or to keep track of your account review progress.",
      goToStripe: "Go To Stripe",
      completeOnboarding: "Stripe Onboarding",
      planDetails: "Plan Details",
      chargesEnabled: "Charges Enabled",
      payoutsEnabled: "Payouts Enabled",
      chargesDisabled: "Charges Disabled",
      payoutsDisabled: "Payouts Disabled",
      gotoDashboard: "Stripe Dashboard",
      manageBilling: "Manage Billing",
      paymentMethod: "Payment Method",
      successfulPurchase: "Success! Your subscription has been updated.",
      alreadyDowngraded:
        "Your subscription is already set to be canceled at the end of the billing period.",
      planOptions: "Plan Options",
      invoiceHistory: "Invoice History",
      viewAllInvoices: "View all Invoices",
      invoice: {
        subscribeMessage: "Subscribe to a paid plan to see invoice history",
      },
      payment: {
        contact: "Contact",
        subscribeMessage: "Subscribe to a paid plan to see payment method info",
        endingIn: "ending in",
      },
      plan: {
        plan: "Plan",
        billingCycle: "Billing cycle",
        cost: "Cost",
        planUsage: "Plan usage",
        readers: "readers",
        terminals: "terminals",
        oneFree: "1 Free",
        starter: "Starter",
        billedMonthly: "Billed monthly per reader",
        perTransaction: "Per transaction",
        starterFeature1: "1 user, 1 terminal",
        starterFeature2: "0.25% application fee",
        starterFeature3: "1-2 day support response",
        starterFeature4: "Payments",
        starterPlanFee: "Pay-as-you-go",
        liteFeature1: "Unlimited users",
        liteFeature2: "No application fee",
        liteFeature3: "1 hour support response",
        liteFeature4: "Payments & Upcoming Features: Product Catalogue, Payment Links",
        terminalNote:
          "1 Free Terminal included in plan. To add more terminals upgrade to Pro plan.",
        addTerminalNote: "Need additional Terminals? Customize your number here!",
        upgrade: "Upgrade",
        addTerminals: "Add Terminals",
        addMoreTerminals: "Add More Terminals",
        addTerminalMessage1:
          "We see that you're interested in expanding your terminal access. Adding more terminals can increase your productivity and make your operations even more efficient.",
        addTerminalMessage2:
          "Please note that each <b>additional terminal will cost $15 per month.</b> These charges will be added to your current subscription.",
        addTerminalMessage3:
          "The good news is that any changes you make will take effect immediately, allowing you to enjoy the benefits of expanded access without delay.",
        addTerminalMessage4:
          "Please be aware that you also have the option to decrease the number of terminals if necessary.",
        month: "Monthly",
        downgrade: "Downgrade",
        downgradeTitle: "Considering Downgrading to Our Starter Plan?",
        planIncludes: "Plan includes",
        downgradeExpect: "What to Expect with the Starter Plan",
        downgradeFeature1: "One Active Terminal",
        downgradeFeature1Text:
          "With the Starter plan, you will be able to keep only one active POS terminal. If you have multiple terminals on your Lite plan, you will need to select which one you wish to remain active.",
        downgradeFeature2: "Standard Transaction Fees",
        downgradeFeature2Text:
          "While the Lite plan offers a reduced transaction fee of 0.5%, the Starter plan comes with our standard 1% transaction fee.",
        downgradeFeature3: "Regular Support",
        downgradeFeature3Text:
          "While we always aim to assist you as promptly as possible, the response time for our support team is typically longer for Starter plan users compared to the priority support provided with the Lite plan.",
        downgradeMessage:
          "Remember, you can always upgrade back to the Lite plan whenever you're ready.",
        downgradeMessage2:
          "Before proceeding, please consider if the downgrade aligns with your current business needs. If you're unsure, our support team is always ready to assist you in understanding the best plan for your business situation.",
        readyToDowngrade: "Are You Ready to Downgrade?",
        updateTerminals: "Update Terminals",
        upgradeTitle: "Ready to Boost Your Experience?",
        upgradeSubtitle: "Upgrade to Our Lite Plan Today!",
        upgradeBenefits: "Benefits of Upgrading to Lite Plan*",
        upgradeFeature1: "Additional Terminals",
        upgradeFeature1Text:
          "With the Lite plan, you can get access to more terminals, helping you manage increased customer demand efficiently.",
        upgradeFeature2: "Priority Support",
        upgradeFeature2Text:
          "Enjoy our priority support! Our dedicated team will respond to your queries and issues within 2-3 business days, ensuring that you're never stuck waiting for long.",
        upgradeFeature3: "Lower Transaction Fees",
        upgradeFeature3Text:
          "Cut down your costs significantly with our lower transaction fees. By upgrading, your transaction fees will be reduced to just 0.5%!",
        upgradeFeature4: "Define Your Terminal Count",
        upgradeFeature4Text:
          "Your business, your choice. We empower you to customize your Lite plan according to your specific needs. Feel free to decide the number of terminals you want to integrate - it's all up to you.",
        upgradeMessage: "*Please note, with the Lite plan, there's a monthly fee per terminal.",
        upgradeMessage2:
          "Don't let the free Starter plan limit your business potential. Upgrade to the Lite plan today and unlock new heights of growth and efficiency.",
        selectPlan: "Select Plan",
        currentPlan: "Current Plan",
        cancelNotice: "*Access to your canceled subscription ends ",
        0: "Free",
        1500: "$15 / reader",
        1000: "$10 / reader",
        2000: "$20 / reader",
      },
      invoicesHistory: {
        viewUpcomingInvoice: "View upcoming invoice",
        viewInvoice: "View invoice",
        upcomingInvoices: "Upcoming Invoices",
        noUpcomingInvoices: "You do not have any upcoming invoices.",
        paidInvoices: "Paid Invoices",
        invoice: "Invoice",
      },
      statuses: {
        unknown: "Unknown",
        restricted: "Restricted",
        complete: "Complete",
        enabled: "Enabled",
        restricted_soon: "Restricted soon",
        rejected: "Rejected",
        pending: "Pending",
        pending_enabled: "Pending",
        pending_disabled: "Pending",
        paid: "Paid",
        draft: "Draft",
        past_due: "Past Due",
        scheduled: "Scheduled",
        void: "Void",
        open: "Open",
        failed: "Failed",
        uncollectible: "Uncollectible",
      },
    },
    refund: {
      reason: {
        reason: "Reason",
        selectAReason: "Select a reason",
        duplicate: "Duplicate",
        fraudulent: "Fraudulent",
        requestedByCustomer: "Requested by customer",
        addMoreDetails: "Add more details about this refund",
        whyFraudulent: "Why is this payment fraudulent?",
        addReason: "Add a reason for this refund.",
      },
      refund: "Refund",
      refundPayment: "Refund Payment",
      refundDetails: "Refund Details",
      refundAmount: "Refund Amount",
      maximumRefund: "Maximum refund",
      selectedItemsTotal: "Selected items total",
      refundTip: "Refund tip",
      refundTipHint: "Include the customer's tip in the refund total.",
      tipCollected: "Tip collected",
      restockingFee: "Restocking Fee",
      restockingFeeHint: "Automatically deducted from the refund total.",
      refundPaymentHint: "Payment has been partially refunded ({0} {1} refunded).",
      refundHint:
        "Refunds take 5-10 days to appear on a customer's statement. Stripe's fees for the original payment won't be returned, but there are no additional fees for the refund.",
      refundForDebit: "This payment must be refunded in person since it is Interact Debit",
      refundSuccess: "Refund successful",
      refundPending: "Refund submitted and awaiting confirmation",
      retryingRefund:
        "The previous refund attempt may still be processing. Review is locked; select Refund to safely retry it.",
      itemModeUnavailable:
        "Item refund values are unavailable for {items}. Enter a custom refund amount to continue.",
      refundTimeout: "Refund timed out. Please try again",
      refundError: "Error processing refund",
      listenerError: "Error monitoring refund status. Please check Dashboard for status.",
      clearReader: "Clear Reader",
      clearReaderHint: "If the reader is not responding, you can clear it and try again.",
      readerCleared: "Reader cleared successfully",
      clearReaderError: "Failed to clear reader",
      returnItems: "Number of items returned",
      adjustReturnQuantities: "Total number of items returned",
      unitPriceWithTax: "Unit Price + Tax",
      returnQuantity: "Return Quantity",
      maxQuantity: "Max",
      previouslyRefunded: "previously refunded",
      restock: "Restock",
      returnStatus: "Return Status",
      noItemsSelected: "Please select items to return",
      amountMismatch:
        "Return items total is $${0}. You may want to match this amount for accurate inventory tracking.",
      itemDidNotUseInventory: "This item did not use any inventory",
    },
    usageStatus: {
      usageStatue: "Usage Status",
      totalTerminals: "Total Terminals",
      planUsage: "Plan usage",
      needMore: "Need additional Terminals? Add here!",
      free: {
        title: "1 Free Terminal included in plan. To add more terminals upgrade to Pro plan.",
      },
    },
    paymentDetails: {
      authorization: {
        capture: "Capture",
        cancel: "Cancel authorization",
        capturePrompt: "Capture the full authorized amount of {amount}?",
        cancelPrompt:
          "Cancel this authorization and release the remaining hold? Your customer's bank determines when the hold disappears. Once canceled, this payment can no longer be captured.",
        amountChanged:
          "The capturable amount or currency changed. Review the updated amount and confirm again.",
        captureAcknowledged: "Payment captured",
        captureProcessing: "Capture processing",
        cancelAcknowledged: "Payment canceled",
        actionFailed:
          "The payment action could not be completed. Refresh the payment before trying again.",
        refreshUnavailable:
          "Fresh payment details are unavailable. Refresh the payment before taking further action.",
        refresh: "Refresh payment",
        amountCapturable: "Amount capturable",
        captureBefore: "Capture before",
        captureBeforeValue: "Capture before: {date}",
        deadlineUnavailable: "Capture deadline unavailable",
        unavailable: "Unavailable",
      },
      createdBy: "Created By",
      cartDetails: "Cart Details",
      transactionDetails: "Transaction Details",
      applicationFee: "Application Fee",
      stripeFee: "Stripe Fee",
      refundsIssued: "Refunds issued",
      net: "Net",
      refundReason: "Refund Reason",
      viewReceipt: "View Receipt",
      product: "Product",
      price: "Price",
      sendReceipt: "Send Receipt",
      receiptSentSuccess: "Receipts sent",
      submitForm: "Submit Form",
      submitFormDescription:
        "Select a terminal form and terminal to collect information after this payment is complete.",
      submitFormLoadError: "Unable to load terminal forms for this payment.",
      submitFormMissingPayment: "Payment information is required before submitting a form.",
      submitFormSendError: "Unable to submit the form. Please try again.",
      terminalReceipt: {
        printTitle: "Print Terminal Receipt",
        selectTerminal: "Select a terminal at {location} to print this receipt.",
        thisLocation: "this location",
        loadingTerminals: "Loading terminals...",
        noTerminals: "No terminals found for this location.",
        unsupportedDevice: "Device doesn't support receipt printing",
        supportedDevice: "{device} • Supports receipt printing",
        printSuccess: "Receipt printed.",
        printError: "Receipt could not be printed. Check the terminal and try again.",
        unknownDevice: "Unknown device",
        terminal: "Terminal",
      },
      additionalEmail: "Additional Email",
      additionalPhoneNumber: "Additional Phone Number",
      tip: "Tip",
      tax: "Tax",
      total: "Total",
    },
    customer: {
      noCustomerMessage:
        "It appears no customers have been created yet. Add customers or create customers during payment processing to see a list of customers.",
      createYourFirstCustomer: "Create your first customer",
      createNewCustomer: "Create New Customer",
      allCustomers: "All Customers",
      noCustomers: "No customers yet",
      deleteCustomerMessage:
        "Are you sure you want to delete this customer? This action cannot be undone.",
      cusId: "ID",
      notes: "Notes",
      noNotesMessage: "No notes available",
      addNote: "Add Note",
      editCustomer: "Edit Customer",
      search: "Search",
      filterBySearch: "Filter customers",
      searchPlaceholder: "Name, Email, Phone",
      noCustomersFound: "No customers found.",
      searchError: "Unable to search customers right now. Please try again.",
      searchPage: "Page {page}",
      taxExempt: "Tax Exempt Status",
      taxExemptOptions: {
        none: "None (Standard tax applies)",
        exempt: "Exempt (No tax charged)",
        reverse: "Reverse Charge (VAT)",
      },
      import: {
        downloadTitle: "Download the customer template CSV",
        downloadDescription:
          "Download our template to ensure your customer data is formatted correctly for import.",
        populateTitle: "Populate the CSV with your customer details",
        populateDescription:
          "Fill in the template with the customer information you want to create. Name is required on every row.",
        fieldsTitle: "Customer Field Details",
        requiredLegend: "Must be provided on every row.",
        optionalLegend: "Safe to leave blank.",
        createOnlyNotice: "This import creates new customers only.",
        noUpdatesNotice: "Existing customers are not updated.",
        noDedupNotice: "Imports are not deduplicated.",
        validationNotice: "The file is validated before import starts.",
        atomicNotice: "If validation fails, no customers are created.",
        maxRowsNotice: "Maximum rows per import: 10,000.",
        uploadDescription: "Select your completed CSV file to import your customers.",
        success: "Imported {count} customer successfully.|Imported {count} customers successfully.",
        failed: "Failed to import customers.",
        fieldDescriptions: {
          name: "Required customer name.",
          email: "Optional customer email address.",
          phone: "Optional customer phone number.",
          addressLine1: "Optional first line of the street address.",
          addressLine2: "Optional second line of the street address, apartment, or suite.",
          addressCity: "Optional city for the customer address.",
          addressPostalCode: "Optional ZIP or postal code for the customer address.",
          addressCountry: "Optional 2-letter ISO country code (for example, CA or US).",
          addressState: "Optional state, province, or region for the customer address.",
          taxExempt: "Optional tax exemption status. Valid values: none, exempt, reverse.",
        },
      },
      sendToCustomer: {
        loadMoreAndContinue: "Load More & Search Again",
        allPaymentLinksLoaded: "All Payment Links Loaded",
        searchLinks: "Search Links",
      },
    },
    paymentLinks: {
      message: {
        created: "Payment link created successfully",
        updated: "Payment link updated successfully",
        activated: "Payment link activated successfully",
        deactivated: "Payment link deactivated successfully",
        send: "Payment link sent successfully",
        customerCreated: "New customer created",
      },
      upcomingFeatures: {
        inventorySupport:
          "Inventory support for payment links coming soon! Stay tuned for future updates.",
      },
      createACheckoutPageInstantly: "Create a checkout page instantly",
      createPaymentLink: "Create Payment Link",
      linkUrl: "Link URL",
      link: "Link",
      price: "Price",
      urlCopied: "Url copied to clipboard!",
      changeName: "Change Name",
      paymentLinkName: "Payment Link Name",
      pre_tax_range: "Pre-tax price range",
      quantityAvailable: "Available now: {range}",
      quantityDesired: "Desired range: {range}",
      scanToPay: "Scan to Pay",
      editLink: "Edit Link",
      copyLink: "Copy Link",
      searchLinks: "Search Links",
      filterByStatus: "Filter Payment Links by status",
      nameHint: "This name is customer facing",
      qrCode: {
        qrCodeCopied: "QR code copied to clipboard!",
        downloadQrCode: "Download QR Code",
        qrCodeError: "Error downloading QR code",
      },
      addNewCustomer: "Add New Customer",
      updatingCustomerMessage: "Customer will be updated upon send",
      create: {
        selected: "Selected",
        inventory: {
          title: "Inventory and tax",
          useInventory: "Use location inventory",
          keepInactive: "Keep inactive after restocking",
          manuallyInactive: "You disabled this link. Restocking will not reactivate it.",
          awaitingStock:
            "This link is paused for inventory. Stock updates will restore your saved limits and reactivate it automatically.",
          invalidConfiguration:
            "This link has an invalid configuration. Review its products, prices, and location before enabling it.",
          lifecycleHint:
            "Stock updates automatically adjust this link. Required items without enough stock pause it; restocking restores your saved limits and reactivates it unless you disabled it manually. Simultaneous checkouts can oversell and leave negative stock.",
          immutableHint:
            "Inventory mode, location, products, prices, and required/optional choices are fixed after creation. Create a new link to change them.",
          addRequiredHint:
            "Add at least one required product. Optional products are removed from checkout when unavailable and restored after restocking.",
          linksLoadError: "Payment Links could not be loaded.",
          selectLocationFirst: "Select a location before searching for products.",
          locationDeleted: "Location deleted. This Payment Link cannot be re-enabled.",
          optional: "Optional",
          optionalItem: "Offer this item as optional",
          automaticTax: "Use automatic tax",
          automaticTaxHeadOffice:
            "Automatic tax uses your Stripe Tax head-office address, not this Payment Link's inventory location.",
        },
        product: "Product",
        selectProductsAndPrices: "Select Products & Prices",
        option: "Option",
        searchProducts: "Search Products",
        searchPlaceholder: "Beekeeper Suit - Medium",
        searchByKeywords: "Search by keywords",
        noPrice: "- No Price -",
        loadMore: "Load More",
        quantity: "Quantity",
        unitPrice: "Unit Price",
        quantityHint: "Let customers adjust quantity",
        between: "between",
        and: "and",
        removeTheProduct: "Remove the product",
        options: "Options",
        productTaxCode: "Product tax code:",
        quantityValidation: {
          notBlank: "Required",
          moreThanZero: "Must be more than zero",
          minMoreThanMax: "Minimum cannot be more than maximum",
        },
        customFields: {
          customFields: "Custom Fields",
          selected: "Selected",
          addAnotherOption: "Add Another Option",
          setLimits: "Set Limits",
          markAsOptional: "Mark as Optional",
          characters: "characters",
          addAnotherField: "Add Another Field",
          text: "Text",
          numbersOnly: "Numbers Only",
          dropdown: "Dropdown",
          atMost: "At most",
          atLeast: "At least",
          between: "Between",
          exactly: "Exactly",
          labelRequired: "Label is required",
          optionRequired: "Option is required",
        },
        callToAction: {
          callToAction: "Call to Action",
          asTheCallToAction: "As the call to action",
          pay: "Pay",
          donate: "Donate",
          book: "Book",
        },
        confirmation: {
          confirmationPage: "Confirmation Page",
          show: "Show",
          dontShow: "Don't Show",
          showConfirmationPage: "Show Confirmation Page",
          replaceDefaultWithCustomMessage: "Replace default with custom message",
          messagePlaceHolder: "Include any details you see fit, such as delivery information.",
          message: "Message",
          dontShowConfirmationPage: "Don't Show Confirmation Page",
          websiteURL: "Website URL",
          websiteUrlPlaceholder: "https://nectarpay.app.com",
          pleaseFillInTheRequiredFields: "Please fill in the required fields",
        },
        otherOptions: {
          otherOptions: "Other Options",
          limitTheNumberOfPayments: "Limit the number of payments",
          totalPayments: "Total Payments",
          changeDefaultMessage: "Change Default Message",
          addYourCustomMessage: "Add your custom message",
          MessageIsRequired: "Message is required",
          savePaymentDetailsForFutureUse: "Save payment details for future use",
          messageRequired: "Message is required",
          limitPayments: "Limit Payments",
          savePaymentDetails: "Save Payment Details",
          and: " and ",
          paymentsLimitedTo: "Payments limited to {0} payment{1}",
          customMessageApplied: "custom message set",
          limitAndCustomMessage: "Payments limited to {0} payment{1}, custom message applied",
        },

        summaryAndTotal: "Summary & Total",
        youHaveSelected: "You've selected {0} items",
        noPricesAvailable: "No prices available",
        error: {
          unableToCreatePaymentLink: "Unable to create payment link",
        },
      },
    },
    product: {
      productName: "Product Name",
      productDescription: "Product Description",
      minimumThreeCharacters: "Minimum 3 characters",
      enableInventory: "Enable Inventory",
      inventoryEnabled: "Inventory Enabled",
      inventoryDisabled: "Inventory Disabled",
      hasInventory: "Has Inventory",
      lowStockThreshold: "Low Stock Threshold",
      lowStockThresholdHint: "You'll be notified when stock falls below this number",
      negativeThresholdError: "Threshold cannot be negative",
      productClass: "Product Group",
      selectProductClass: "Select a Product Group",
      product_class: "Product Group ID",
      defaultPrice: "Default Price",
      useDefaultImage: "Use Default Image",
      idGeneratedHint: "Leave blank to auto-generate.",
      filter: {
        filterByStatus: "Filter by Product Status",
        filterByDescription: "Filter by Product Description",
        filterByName: "Filter by Product Name",
        filterByTags: "Filter by Product Tags",
      },
      usingDefaultThreshold: "Using Default Threshold",
      resetToDefault: "Reset to Default",
      additionalInformation: "Additional Information",
      additionalFieldsLater: "You can add more product details after creation.",
      identifiers: {
        title: "Identifiers",
        description:
          "Add unique product identifiers like GTIN, UPC, EAN, or ISBN to make your products easier to find.",
        add: "Add an identifier",
        ean: {
          label: "EAN",
          description:
            "European Article Number (EAN) consisting of 8 or 13 digits and optional dashes. You may optionally provide a leading 0 for a total of 14 digits. The final digit is a validated check digit.",
          placeholder: "e.g. 12345678 or 1234567890123",
        },
        gtin: {
          label: "GTIN",
          description:
            "Global Trade Item Number (GTIN) consisting of 8, 12, 13, or 14 digits and optional dashes. The final digit is a validated check digit.",
          placeholder: "e.g. 123456789012",
        },
        isbn: {
          label: "ISBN",
          description:
            "International Standard Book Number (ISBN) consisting of 10 or 13 digits and optional dashes. The final digit is a validated check digit. For ISBN-10, the final digit may be a X.",
          placeholder: "e.g. 978-3-16-148410-0",
        },
        jan: {
          label: "JAN",
          description:
            "Japanese Article Number (JAN) consisting of 13 digits and optional dashes. The first two digits must either be 45 or 49. The final digit is a validated check digit.",
          placeholder: "e.g. 4501234567895",
        },
        mpn: {
          label: "MPN",
          description:
            "Manufacturer Part Number (MPN). May include up to 70 alphanumeric characters and dashes.",
          placeholder: "e.g. F-150-2023-XL",
        },
        nsn: {
          label: "NSN",
          description:
            "National Stock Number (NSN) consisting of 13 digits and optional dashes. The seventh character may also be alphanumeric.",
          placeholder: "e.g. 1234-56-789-0123",
        },
        upc: {
          label: "UPC",
          description:
            "Universal Product Code (UPC) consisting of 12 digits and optional dashes. The final digit is a validated check digit.",
          placeholder: "e.g. 123456789012",
        },
      },
    },
    createProduct: {
      pleaseEnterProductName: "Please enter a product name",
    },
    productDetails: {
      noResultsAndWaitMessage: "No results found",
      paymentLinks: "Payment Links",
      defaultPriceWarningTitle: "Existing Payment Links",
      defaultPriceWarning:
        "Updating the default price does not change the price of existing Payment Links.",
      filterByNickname: "Filter by Price Nickname",
      filterBySku: "Filter by Price SKU",
      priceNickname: "Price Nickname",
      filterByStatus: "Filter by Price Status",
      priceAddedSuccess: "Price successfully added!",
      defaultPriceAddedSuccess:
        "Default price successfully added! It may take a moment for the price table to update",
      priceUpdatedSuccess: "Price successfully updated!",
      productUpdated: "Product updated!",
      productCreated: "Product created!",
      payloadFiltered: "Empty values were filtered from request",
    },
    productTagDetails: {
      productTagCreated: "Product tag created successfully",
      productTagUpdated: "Product tag updated successfully",
      removeFromAllProductsConfirm:
        "Are you sure you want to remove this tag from all products? This action cannot be undone.",
      removeFromAllProductClassesConfirm:
        "Are you sure you want to remove this tag from all product groups? This action cannot be undone.",
      tagRemovedFromAllProducts: "Product tag removed from all products successfully",
      tagRemovedFromAllProductClasses: "Product tag removed from all product groups successfully",
      bulkStatusTitle: "Bulk Actions",
      bulkStatusPreview:
        "This will {action} {changedCount} of {matchingCount} associated {target}.",
      bulkStatusNoChanges: "No associated {target} need to be updated.",
      bulkStatusSuccess: "Successfully {action}d {count} {target}.",
    },
    terminalForm: {
      addTerminalForm: "Add Terminal Form",
      title: "Title",
      submitButton: "Submit Button",
      skipButton: "Skip Button",
      signature: "Signature",
      buttonStyle: "Button Style",
      choice: "Choice",
      createTerminalForm: "Create Terminal Form",
      selectYourStep: "Select your step Type",
      fiveSteps: "5 Steps",
      addStep: "Add Step",
      setFinishAction: "Set Finish Action",
      primary: "Primary",
      secondary: "Secondary",
      submissionCount: "# Submissions",
      detailCardTitle: "Terminal Form Overview",
      detailPlaceholder: "Select a form to load its details.",
      detailLabels: {
        steps: "Steps",
        type: "Type",
        created: "Created",
        updated: "Last Updated",
      },
      submissions: {
        title: "Completed Submissions",
        empty: "No submissions have been recorded for this form yet.",
        loadError: "We couldn't load submissions right now. Please try again.",
        table: {
          submittedAt: "Submitted",
          terminal: "Terminal",
          location: "Location",
          paymentIntent: "Payment Intent",
          responses: "Responses",
        },
      },
    },
    profile: {
      title: "My Profile",
      details: "Profile",
      name: "Name",
      security: "Security",
    },
    settings: {
      general: {
        title: "General",
        displayName: "Account display name",
        notice:
          "Only changes how this account is identified in NectarPay. It does not update your Stripe business name or receipt settings.",
        required: "Account display name is required.",
        saved: "Account display name saved.",
        discardChangesTitle: "Discard account display name changes?",
        discardChangesMessage:
          "You have unsaved account display name changes. If you leave this tab or page now, those changes will be lost.",
      },
      payments: {
        title: "Payments",
        allowMoto: "Allow mail/telephone orders (MOTO)",
        motoDescription:
          "Allow card details to be entered on a reader for mail or telephone orders.",
        allowPreAuth: "Allow pre-authorization",
        preAuthDescription:
          "Allow Terminal and online payments to authorize funds first and be captured later. Select pre-authorization when creating a payment; enabling this setting does not select it automatically.",
        allowExtendedAuthorization: "Allow extended authorization",
        extendedAuthorizationHint:
          "Automatically request a longer authorization window whenever pre-authorization is selected.",
        extendedAuthorizationNotice:
          "Availability depends on {applicableMccs} (MCCs), card network, and Stripe eligibility. A request does not guarantee approval or a specific authorization window.",
        extendedAuthorizationApplicableMccs: "applicable Merchant Category Codes",
        extendedAuthorizationHelp: "About extended authorization",
        saved: "Payment settings saved.",
      },
      security: {
        title: "Security",
        require2fa: "Require two-factor authentication",
        require2faDescription:
          "All users of this account must set up an authenticator app to sign in",
        require2faActiveHint:
          "Users without two-factor authentication will be required to set it up before they can continue using NectarPay. Turning this off does not remove authenticators already set up by users.",
        enrolledSummary: "{enrolled} of {total} users have two-factor authentication enabled",
        enrollFirstTitle: "Set up your authenticator first",
        enrollFirstMessage:
          "Before requiring two-factor authentication for all users, you need to set it up for your own account.",
        saved: "Security settings saved",
        saveError: "Failed to save security settings",
        loadError: "Failed to load security settings",
      },
      products: {
        title: "Product",
        metadataTitle: "Metadata",
        metadataTab: "Metadata",
        imageUploadingTab: "Image Upload",
        imageUploadingTitle: "Image Uploader",
        imageUploadingHint:
          "Upload image files with a mapping CSV that identifies the product, tag, or group each image belongs to.",
        imageType: "Image Type",
        chooseImages: "Choose Images",
        chooseMappingCsv: "Choose Mapping CSV",
        exportImageMappingCsv: "Export CSV",
        mappingCsvNotice:
          "The CSV must include item id, type, and file name columns. Exported CSVs also include item name for reference. Blank file names are ignored.",
        itemId: "Item ID",
        fileName: "File Name",
        message: "Message",
        oneFileSelected: "1 file selected",
        filesSelected: "{0} files selected",
        defaultImageNotice:
          "Uploaded images will be added to the selected item and set as the default image.",
        validationTitle: "Validation ({0} rows)",
        noImagesSelected: "Choose images to validate them.",
        noMappingSelected: "Choose images and a mapping CSV to validate them.",
        manuallyMatch: "Manually Match",
        matchImage: "Match Image",
        matched: "matched",
        manuallyMatched: "manually matched",
        duplicate: "duplicate",
        noMatch: "no match",
        confirmImages: "Confirm Images",
        confirmMatched: "{0} images will be uploaded",
        confirmDuplicates: "{0} duplicate images will be ignored",
        confirmNoMatches: "{0} images have no match and will be ignored",
        confirmValidMappings: "{0} mapped images will be uploaded",
        confirmIgnoredMappings: "{0} rows with blank file names will be ignored",
        confirmInvalidMappings: "{0} invalid or duplicate rows will be rejected",
        proceedWithImages: "Proceed with {0} Images",
        imagesUploaded: "{0} images uploaded successfully",
        bulkImageStatus: {
          valid: "valid",
          ignored: "ignored",
          invalid: "invalid",
          duplicate: "duplicate",
          uploaded: "uploaded",
          failed: "failed",
        },
        metadataKeyLabel: "Metadata {0} Key",
        addMetadata: "Add Metadata",
        duplicateError: "Keys must be unique",
        metadataSaved: "Product metadata settings saved",
        catalogTitle: "Catalog",
        catalogRebuildDescription:
          "Rebuild the product catalog bundle used by product and product group search.",
        rebuildCatalog: "Rebuild catalog",
        catalogRebuildComplete: "Catalog rebuild complete",
        catalogRebuildFailed: "Catalog rebuild failed",
      },
      taxes: {
        title: "Taxes",
        enableHintText: "Confirm the acknowledgement below before enabling taxes.",
        acknowledgementLabel:
          "I understand and accept responsibility for configuring and remitting taxes as described above.",
        buttonText: "Enable Taxes",
        disclaimers: {
          line1:
            "Stripe Tax powers these calculations for your Connect account and is governed by Stripe's own pricing, policies, and availability.",
          line2:
            "You are solely responsible for registering in each applicable tax jurisdiction and maintaining accurate business and tax profile information.",
          line3:
            "Review and confirm that the rates, rules, and thresholds configured in Stripe Tax meet your obligations before collecting any payments.",
          line4:
            "NectarPay does not provide tax or legal advice and are not liable for any misconfigured, miscalculated, or unremitted taxes.",
        },
        taxSettingsTitle: "Tax Settings",
        taxRegistrationsTitle: "Tax Registrations",
        defaultLocationHint: "Default end-customer address",
        defaultHeadOffice: "Default to Head Office",
        defaultTerminalLocation: "Default to Terminal Location",
        failedToLoadComponent: "Failed to load component:",
        taxSettingsSaved: "Saved",
        taxRegistrationsSaved: "Successfully added tax registration",
        defaultTaxBehaviorHint: "Default tax behavior",
        failedToEnableTaxes: "Failed to enable taxes",
      },
      inventory: {
        title: "Inventory",
        locationBased: {
          label: "Enable location-based inventory",
          description:
            "Track inventory per location and enable stock adjustments, low stock alerts, and inventory logs.",
          disclaimerTitle: "Before you enable location-based inventory",
          disclaimerCannotUndo:
            "This changes how stock is tracked for your products. You can update this setting later.",
          disclaimerStockCounts:
            "You will need to maintain stock counts for products at each location.",
          disclaimerGlobalProducts:
            "Products are still managed globally (name, description, tags, prices, etc.).",
          disclaimerAssignProducts:
            "You may need to assign products to locations before adjusting stock.",
          disclaimerOnlyStockCounts: "Only stock counts become location-based.",
          confirmEnable: "I understand, enable inventory",
          disableDisclaimerTitle: "Before you disable location-based inventory",
          disableDisclaimerLocationStockUnavailable:
            "Location-specific stock counts will no longer be available while this is disabled.",
          disableDisclaimerGlobalCounts:
            "Stock will be tracked at a global level instead of per location.",
          disableDisclaimerReenableNote:
            "If you re-enable location-based inventory later, review your location stock counts before making adjustments.",
          disableDisclaimerPriceDefaults:
            "Location-specific price defaults will be permanently cleared and products will use their global default prices.",
          confirmDisable: "I understand, disable inventory",
          saved: "Inventory settings saved",
        },
      },
      emailReceipts: {
        title: "Email Receipts",
        description: "Configure custom receipt settings for emailed receipts.",
        enableLabel: "Enable custom emailed receipts",
        enableHint: "Store custom emailed receipt settings for future receipt delivery.",
        tabs: {
          config: "Config",
          lookAndFeel: "Look and Feel",
        },
        contactInformation: "Contact Information",
        supportAddress: "Support Address",
        customLines: "Custom Lines",
        merchantName: "Merchant Name",
        taxDisplay: "Tax Display",
        taxDisplayHint: "Choose how taxes appear in the itemized receipt totals.",
        mergeTaxLines: "Merge Tax Lines",
        mergeTaxLinesHint: "Show all taxes as one combined tax line.",
        showTaxPercent: "Show Tax %",
        showTaxPercentHint: "Include the tax percent next to tax amounts.",
        supportEmail: "Support Email",
        supportPhone: "Support Phone",
        supportUrl: "Support Website URL",
        addressLine1: "Address Line 1",
        addressLine2: "Address Line 2",
        city: "City",
        state: "State/Province",
        postalCode: "Postal Code",
        country: "Country",
        headerLines: "Header Lines",
        footerLines: "Footer Lines",
        branding: "Branding",
        brandingHint: "Match the visual style used by the emailed receipt template.",
        fromStripe: "From Stripe",
        logo: "Logo",
        logoSection: "Logo",
        colorSection: "Colors",
        uploadLogo: "Upload Logo",
        logoPlaceholder: "No logo selected",
        logoHint: "Upload a logo to use in custom emailed receipts.",
        logoStripeHint: "No custom logo is set, so the Stripe account logo will be used.",
        merchantNameStripeHint:
          "No custom merchant name is set, so the Stripe account business name will be used.",
        primaryColor: "Primary Color",
        primaryColorStripeHint:
          "No custom primary color is set, so the Stripe primary branding color will be used.",
        accentColor: "Accent Color",
        accentColorStripeHint:
          "No custom accent color is set, so the Stripe secondary branding color will be used.",
        backgroundColor: "Background Color",
        backgroundColorHint: "Defaults to the receipt template background color if left unchanged.",
        colorHint: "Use a six-digit hex color value.",
        colorPlaceholder: "#fe6f00",
        colorValidationMessage: "Enter a valid hex color, such as #fe6f00.",
        emailValidationMessage: "Enter a valid email address.",
        urlValidationMessage: "Enter a valid http or https URL.",
        logoUploadFailed: "Unable to upload email receipt logo.",
        saved: "Email receipt settings saved.",
        enableNoticeTitle: "Custom emailed receipts enabled",
        enableNoticeMessage:
          "Custom emailed receipts are enabled. To avoid duplicate receipts, turn off Stripe emailed receipts in the Stripe Dashboard.",
        disableNoticeTitle: "Custom emailed receipts disabled",
        disableNoticeMessage:
          "Custom emailed receipts are disabled. If you want Stripe’s default receipt emails again, re-enable them in the Stripe Dashboard.",
        noticeSubtitle: "Review your Stripe Customer Emails settings",
        noticeStepsTitle: "Stripe Dashboard steps",
        noticeStepDashboard: "Go to Settings → Business → Customer Emails.",
        openStripeEmailSettings: "Open Stripe email settings",
        noticeStepDisableStripeToggles:
          "Under Payments, disable the toggles for successful payments and refunds.",
        noticeStepEnableStripeToggles:
          "Under Payments, enable the toggles for successful payments and refunds.",
        noticeWaitCountdown: "You can close this notice in {seconds} seconds.",
        sendTestEmail: "Send Test Email",
        testDialogTitle: "Send Test Email",
        testDialogSubtitle: "Send a sample itemized receipt to verify your settings.",
        testEmailLabel: "Recipient Email",
        testLocationLabel: "Tax Location",
        testProductLabel: "Product",
        testQuantityLabel: "Qty",
        testDiscountTypeLabel: "Discount type",
        testDiscountValueLabel: "Discount value",
        discountPercentage: "Percentage",
        discountFixed: "Fixed amount",
        testCustomAmountLabel: "Payment amount",
        testCustomAmountName: "Payment",
        testEmailSent: "Test receipt email sent.",
      },
      receiptPrinters: {
        title: "Receipt Printers",
        assignmentNote: "Printers can be assigned to a terminal in Fleet Management.",
        tabs: {
          setup: "Setup",
          configure: "Configure",
        },
        receiptTitle: "Title on Receipt",
        receiptTitleHint: "Leave blank to use the account business name.",
        contactEmail: "Contact Email",
        contactTelephone: "Contact Telephone",
        displayTaxRate: "Display Tax Rate",
      },
      webhooks: {
        title: "Webhooks",
        description: "Configure endpoints, send test events, and review recent webhook deliveries.",
        addEndpoint: "Add Endpoint",
        limit: "You can configure up to {limit} webhook endpoints.",
        loading: "Loading webhook endpoints...",
        empty: "No webhook endpoints have been configured yet.",
        secret: "Secret",
        name: "Name",
        eventsEnabled: "Events enabled",
        sendTest: "Send test",
        enable: "Enable",
        disable: "Disable",
        delete: "Delete",
        rollSecret: "Roll secret",
        viewDeliveries: "View deliveries",
        viewAllDeliveries: "View all deliveries",
        deliveriesTitle: "Deliveries",
        deliveryDetailsTitle: "Delivery details",
        attemptsTitle: "Attempts",
        attemptDetailsTitle: "Attempt details",
        requestBody: "Request body",
        responseBody: "Response body",
        attempt: "Attempt",
        viewAttempts: "View attempts",
        noAttempts: "No attempts found.",
        allDeliveries: "All webhook deliveries",
        deliveriesForEndpoint: "Deliveries for {endpoint}",
        backToWebhooks: "Back to Webhooks",
        refresh: "Refresh",
        deliveryStatus: "Status",
        event: "Event",
        endpoint: "Endpoint",
        idTooltip: "ID: {id}",
        response: "Response",
        attempts: "Attempts",
        created: "Created",
        actions: "Actions",
        deliveriesLoading: "Loading webhook deliveries...",
        noDeliveries: "No webhook deliveries found.",
        retry: "Retry",
        previous: "Previous",
        next: "Next",
        createTitle: "Create webhook endpoint",
        url: "Endpoint URL",
        descriptionLabel: "Description",
        events: "Events",
        testEvent: "Test event",
        create: "Create endpoint",
        secretTitle: "Save your webhook secret",
        secretWarning:
          "This secret is shown only once. Copy it now and use it to validate NectarPay webhook signatures.",
        secretRolledTitle: "Save your new webhook secret",
        secretRolledWarning:
          "Your webhook secret has been rolled and is shown only once. Update your endpoint implementation before sending more events.",
        deleteConfirmTitle: "Delete webhook endpoint?",
        deleteConfirmMessage:
          "This will stop all future deliveries for this endpoint and cancel any pending retries. The endpoint will be removed from this list, but its history will be retained.",
        deleteConfirmAction: "Delete endpoint",
        rollSecretConfirmTitle: "Roll webhook secret?",
        rollSecretConfirmMessage:
          "Rolling the secret will immediately break existing signature verification until your implementation is updated to use the new secret.",
        rollSecretConfirmAction: "Roll secret",
        copySecret: "Copy webhook secret",
        copyUrl: "Copy webhook URL",
        done: "Done",
        listError: "Failed to load webhook endpoints",
        createSuccess: "Webhook endpoint created",
        createError: "Failed to create webhook endpoint",
        testQueued: "Test webhook event queued",
        testError: "Failed to queue test webhook event",
        enableSuccess: "Webhook endpoint enabled",
        disableSuccess: "Webhook endpoint disabled",
        updateError: "Failed to update webhook endpoint",
        deleteSuccess: "Webhook endpoint deleted",
        deleteError: "Failed to delete webhook endpoint",
        rollSecretSuccess: "Webhook secret rolled",
        rollSecretError: "Failed to roll webhook secret",
        deliveryListError: "Failed to load webhook deliveries",
        deliveryDetailsError: "Failed to load webhook delivery details",
        retryQueued: "Webhook delivery retry queued",
        retryError: "Failed to retry webhook delivery",
        endpointStatuses: {
          enabled: "Enabled",
          warning: "Warning",
          disabled_by_failures: "Disabled by failures",
          disabled_manually: "Disabled manually",
        },
        deliveryStatuses: {
          pending: "Pending",
          retrying: "Retrying",
          delivered: "Delivered",
          failed: "Failed",
          skipped: "Skipped",
        },
        eventTypes: {
          "webhook.test": "Test event",
          "report.generated": "Report generated",
          "report.failed": "Report failed",
        },
        schedules: {
          title: "Scheduled reports",
          description:
            "Generate CSV reports automatically and deliver them to selected webhook endpoints.",
          add: "Add schedule",
          createTitle: "Create report schedule",
          editTitle: "Edit report schedule",
          save: "Save schedule",
          name: "Name",
          reportType: "Report type",
          cadence: "Cadence",
          weekStartsOn: "Week starts on",
          endpoints: "Webhook endpoints",
          nextRunAt: "Next run",
          status: "Status",
          enabled: "Enabled",
          disabled: "Disabled",
          loading: "Loading report schedules...",
          empty: "No scheduled reports have been configured yet.",
          runTimeHint:
            "Reports run at 06:00 in your account timezone ({timezone}) and cover the previous completed calendar period.",
          listError: "Failed to load report schedules",
          createSuccess: "Report schedule created",
          createError: "Failed to create report schedule",
          updateSuccess: "Report schedule updated",
          updateError: "Failed to update report schedule",
          deleteSuccess: "Report schedule deleted",
          deleteError: "Failed to delete report schedule",
          deleteConfirmTitle: "Delete report schedule?",
          deleteConfirmMessage:
            "This will stop future report generation for this schedule. Existing generated reports and webhook delivery logs will be retained.",
          deleteConfirmAction: "Delete schedule",
          reportTypes: {
            purchase_summary: "Purchase summary",
            purchase_itemized: "Purchase itemized",
            return_summary: "Return summary",
            return_itemized: "Return itemized",
          },
          cadences: {
            daily: "Daily",
            weekly: "Weekly",
            monthly: "Monthly",
          },
          weekStarts: {
            monday: "Monday",
            sunday: "Sunday",
          },
        },
        filters: {
          eventType: "Event type",
          filterByEventType: "Filter by event type",
          status: "Status",
          filterByStatus: "Filter by status",
          created: "Created",
          filterByCreated: "Filter by creation date",
        },
      },
      kiosk: {
        title: "Kiosk",
        general: "General",
        lookAndFeel: "Look & Feel",
        accessAndPairing: "Access & Pairing",
        deviceAssignment: "Device Assignment",
        branding: "Branding",
        runtimeBehavior: "Runtime Behavior",
        receiptPreferences: "Receipt Preferences",
        statusEnabled: "Enabled",
        statusDisabled: "Disabled",
        publicUrl: "Public URL",
        publicUrlPlaceholder: "Available after kiosk setup",
        copyPublicUrl: "Copy kiosk URL",
        showPublicUrlQrCode: "Show kiosk URL QR code",
        qrCodeTitle: "Kiosk QR Code",
        regenerate: "Regenerate",
        regenerateUrl: "Regenerate URL",
        regeneratePin: "Regenerate PIN",
        resetPin: "Reset PIN",
        pinStatus: "PIN Set",
        pinTimeToLive: "PIN Time to Live",
        pinTimeToLiveDays: "{0} days",
        pinExpiry: "PIN Expiry",
        location: "Location",
        terminal: "Terminal",
        receiptPrinter: "Receipt Printer",
        receiptPrinterPlaceholder: "Lobby Printer",
        receiptPrinterUnassigned: "No printer assigned",
        verifoneBuiltInPrinter: "Verifone v660p built-in printer",
        receiptPrinterUnavailable: "Assigned printer unavailable",
        receiptPrinterAssignmentNote: "Printers can be assigned to a terminal in Fleet Management.",
        logo: "Logo",
        uploadLogo: "Upload Logo",
        logoPlaceholder: "Upload a kiosk logo to replace the default brand artwork.",
        logoFallbackNote:
          "If no kiosk logo is set, the logo from your Stripe branding settings will be used.",
        logoUploadFailed: "Unable to upload the kiosk logo right now.",
        primaryColor: "Primary Color",
        secondaryColor: "Secondary Color",
        colorPlaceholder: "#FF6F00",
        colorHint: "Optional. Leave blank to use your default kiosk branding colors.",
        colorValidationMessage: "Enter a valid hex color like #FF6F00.",
        kioskTitle: "Title",
        kioskTitlePlaceholder: "Optional kiosk title",
        kioskSubtitle: "Subtitle",
        kioskSubtitlePlaceholder: "Optional kiosk subtitle",
        catalogLandingMode: "Catalog Landing Page",
        catalogLandingModeHint:
          "Choose whether the kiosk starts by showing product groups directly or by showing tags first, then the matching product groups.",
        catalogLandingModeProducts: "Products",
        catalogLandingModeProductClasses: "Product Groups",
        catalogLandingModeProductClassTags: "Show Tags First",
        catalogLandingModeProductTags: "Product Tags",
        catalogOrdering: "Catalog Ordering",
        catalogOrderingHint:
          "Choose alphabetical ordering or use the ranks defined in catalog CSV imports.",
        catalogOrderingAlphabetical: "Alphabetical",
        catalogOrderingDefined: "Defined Sort",
        receiptModePrint: "Print",
        receiptModePrintDescription: "Offer a printed receipt at the kiosk.",
        receiptModeEmail: "Email",
        receiptModeEmailDescription: "Offer an emailed receipt option.",
        receiptModeBoth: "Both",
        receiptModeBothDescription: "Offer a combined print and email receipt option.",
        receiptModeRequired: "Enable at least one receipt option.",
        sessionTimeout: "Session Timeout (seconds)",
        confirmationTimeout: "Confirmation Timeout (seconds)",
        timeoutPlaceholder: "Optional",
        sessionTimeoutHint:
          "Optional. Leave blank to use the default 120-second kiosk session timeout.",
        confirmationTimeoutHint:
          "Optional. Leave blank to use the default 15-second confirmation screen timeout.",
        timeoutValidationMessage: "Enter a whole number greater than 0.",
        pin: "PIN",
        pinPlaceholder: "Enter 6-digit kiosk PIN",
        pinRequiredToProceed:
          "A 6-digit kiosk PIN is required before you can enable and save kiosk settings.",
        configured: "Configured",
        notConfigured: "Not configured",
        saved: "Kiosk settings saved",
        pinResetSaved: "Kiosk PIN updated",
        tokenRegenerated: "Kiosk URL updated",
        resetPinWarning: "If you regenerate your PIN, all active sessions will be invalidated",
        confirmResetPinTitle: "Confirm PIN reset",
        confirmResetPinMessage:
          "Regenerating the kiosk PIN will invalidate all active sessions. Do you want to continue?",
        regenerateTokenWarning:
          "If you regenerate your URL, all active sessions will be invalidated",
        confirmRegenerateTokenTitle: "Confirm URL regeneration",
        confirmRegenerateTokenMessage:
          "Regenerating the kiosk URL will invalidate all active sessions. Do you want to continue?",
        discardChangesTitle: "Discard kiosk changes?",
        discardChangesMessage:
          "You have unsaved kiosk settings changes. If you leave this tab or page now, those changes will be lost.",
        stayHere: "Stay on Kiosk",
        discardChanges: "Discard Changes",
      },
    },
    productClassDetails: {
      noResultsAndWaitMessage: "No results found",
      filterByStatus: "Filter by Product Group Status",
      productClassUpdated: "Product group updated!",
      productClassCreated: "Product group created!",
      payloadFiltered: "Empty values were filtered from request",
      removeFromAllProductsConfirm:
        "Are you sure you want to remove this product group from all products? This action cannot be undone.",
      productClassRemovedFromAllProducts: "Product group removed from all products successfully",
    },
  },
  legal: {
    terms: {
      title: "NectarPay Terms of Service",
      effectiveDate: "Effective date: June 29, 2026",
      contact: "Questions about these Terms may be sent to",
      contactEmail: "legal{'@'}hiveway.com",
      address:
        "Hiveway Inc., 4145 North Service Road, Suite 200, Burlington, Ontario L7L 6A3, Canada.",
      sections: [
        {
          title: "1. Agreement to these Terms",
          paragraphs: [
            "These Terms of Service govern access to and use of NectarPay, a payment and point-of-sale software product provided by Hiveway Inc. By creating an account, accessing NectarPay, or using the service on behalf of a business, you agree to these Terms for yourself and for the business you represent.",
            "If you are using NectarPay on behalf of a company, organization, or other legal entity, you represent and warrant that you have authority to bind that entity to these Terms. If you do not agree to these Terms, do not create an account or use NectarPay.",
          ],
        },
        {
          title: "2. About NectarPay",
          paragraphs: [
            "NectarPay provides software and related services for payment, point-of-sale, reporting, catalog, customer, terminal, receipt, tax, webhook, scheduled report, and related business workflows. NectarPay is intended for business use only.",
            "Hiveway Inc. is not a bank, card network, payment processor, money transmitter, or financial institution. Payment processing and related financial services are provided by third-party providers, including Stripe or other processors that may be made available through NectarPay.",
          ],
        },
        {
          title: "3. Eligibility and third-party processor requirements",
          paragraphs: [
            "To use payment-related NectarPay features, you must maintain any required payment-processor accounts in good standing and comply with the applicable provider terms, policies, technical requirements, card-network rules, and payment-method rules.",
            "Your use of third-party payment processing services is governed by your agreement with those providers, not these Terms. Some NectarPay functionality may depend on processor availability, processor permissions, account configuration, geography, hardware, or other operational requirements.",
          ],
        },
        {
          title: "4. License",
          paragraphs: [
            "Subject to these Terms, Hiveway Inc. grants you a limited, non-exclusive, non-transferable, non-sublicensable, revocable license to access and use NectarPay for your internal business purposes.",
            "This license is provided only in accordance with these Terms and any applicable plan, subscription, documentation, or written agreement with Hiveway Inc.",
          ],
        },
        {
          title: "5. Restrictions",
          paragraphs: ["You may not, and may not permit any third party to:"],
          items: [
            "copy, modify, translate, or create derivative works of NectarPay except as expressly permitted by Hiveway Inc.",
            "reverse engineer, decompile, disassemble, or otherwise attempt to discover source code or underlying components, except where prohibited by law",
            "sell, resell, license, sublicense, distribute, or commercially exploit NectarPay except as expressly permitted by Hiveway Inc.",
            "use NectarPay to violate law, infringe rights, process fraudulent transactions, or support prohibited businesses",
            "bypass or attempt to bypass technical limitations, entitlements, usage restrictions, security controls, or plan limits",
            "interfere with, overload, probe, scan, or attempt unauthorized access to NectarPay, Hiveway Inc., payment processors, or third-party systems",
          ],
        },
        {
          title: "6. Merchant responsibilities",
          paragraphs: ["You are responsible for:"],
          items: [
            "your products, services, business operations, transactions, customers, taxes, refunds, returns, chargebacks, disputes, fulfillment, and receipts",
            "the accuracy of account, business, location, product, tax, customer, terminal, reporting, webhook, and transaction information entered into NectarPay",
            "your personnel, contractors, administrators, employees, and other authorized users who access NectarPay",
            "reviewing payment, refund, authorization, capture, tax, receipt, report, and processor outcomes",
            "complying with applicable payment, tax, privacy, consumer protection, recordkeeping, and other laws that apply to your business",
            "maintaining appropriate internal controls over devices, networks, terminals, integrations, credentials, and account access",
          ],
        },
        {
          title: "7. Fees, subscriptions, cancellations, and refunds",
          paragraphs: [
            "Fees, subscription plans, processor charges, hardware costs, and other charges may apply to your use of NectarPay. You authorize charges and subscription billing in accordance with the pricing and plan you select or otherwise agree to.",
            "You may cancel a subscription at any time, but unless otherwise stated in a separate written agreement, cancellation takes effect at the end of the then-current billing period. Fees already paid are non-refundable except where required by law or expressly agreed by Hiveway Inc.",
            "You remain responsible for fees incurred before cancellation, processor fees, chargebacks, disputes, refunds owed to your own customers, and other obligations arising from your use of NectarPay before cancellation. Hiveway Inc. may change pricing or plan structure prospectively as permitted by law and your subscription terms.",
          ],
        },
        {
          title: "8. Third-party services",
          paragraphs: [
            "NectarPay may rely on third-party services, including payment processors, cloud hosting, authentication, analytics, communications, email, support, monitoring, storage, security, and integration providers.",
            "Hiveway Inc. is not responsible for the availability, performance, acts, omissions, changes, restrictions, or termination of third-party services. If a third-party service is unavailable, changed, restricted, or terminated, some or all NectarPay functionality may be unavailable or affected.",
          ],
        },
        {
          title: "9. Data and privacy",
          paragraphs: [
            "Our collection and use of personal information is described in the NectarPay Privacy Policy. By using NectarPay, you acknowledge that business, user, customer, transaction, device, support, and usage information may be processed to provide, secure, support, and improve the service.",
            "Hiveway Inc. does not collect or store full payment card numbers or CVV codes through NectarPay. Payment processing and sensitive card data handling are performed by payment processors such as Stripe.",
            "You represent and warrant that you have all necessary rights, permissions, notices, consents, and legal bases to provide information to NectarPay, including information about your customers, personnel, and business contacts.",
          ],
        },
        {
          title: "10. Intellectual property and feedback",
          paragraphs: [
            "Hiveway Inc. and its licensors own NectarPay, including the software, design, interfaces, documentation, trademarks, and related intellectual property. These Terms do not transfer ownership of NectarPay to you.",
            "You retain ownership of your business data. You grant Hiveway Inc. the rights necessary to host, process, transmit, display, and use that data to provide, secure, support, and improve NectarPay. If you provide feedback or suggestions, Hiveway Inc. may use them without restriction or compensation.",
          ],
        },
        {
          title: "11. Service availability and changes",
          paragraphs: [
            "Hiveway Inc. may update, improve, modify, suspend, or discontinue NectarPay or any feature at any time, with or without notice. We aim to provide reliable service, but NectarPay may be unavailable due to maintenance, outages, third-party service issues, or events beyond our control.",
            "We do not guarantee that NectarPay will always be available, uninterrupted, error-free, or compatible with all processors, reader hardware, workflows, account configurations, integrations, or business requirements.",
          ],
        },
        {
          title: "12. Support",
          paragraphs: [
            "Hiveway Inc. may provide support for NectarPay through documentation, support portals, or direct assistance, but we are not obligated to provide any particular level of support unless separately agreed in writing. Support response times, hours, and channels may vary.",
          ],
        },
        {
          title: "13. Beta, preview, or experimental features",
          paragraphs: [
            "From time to time, Hiveway Inc. may offer features identified as beta, preview, early access, or experimental. Those features may be incomplete, changed, unreliable, or discontinued at any time and may be subject to additional terms.",
            "Hiveway Inc. makes no commitments regarding the continued availability, final form, or production readiness of beta, preview, or experimental features.",
          ],
        },
        {
          title: "14. Disclaimer of warranties",
          paragraphs: [
            "NECTARPAY IS PROVIDED “AS IS” AND “AS AVAILABLE.” TO THE MAXIMUM EXTENT PERMITTED BY LAW, HIVEWAY INC. DISCLAIMS ALL WARRANTIES, EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE, INCLUDING IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, NON-INFRINGEMENT, QUIET ENJOYMENT, ACCURACY, OR THAT NECTARPAY WILL BE UNINTERRUPTED, SECURE, OR ERROR-FREE.",
            "HIVEWAY INC. DOES NOT WARRANT THAT NECTARPAY WILL MEET YOUR REQUIREMENTS, PRODUCE ANY PARTICULAR BUSINESS RESULT, OR PREVENT PAYMENT ERRORS, READER FAILURES, TAX ERRORS, BILLING ISSUES, CHARGEBACKS, CUSTOMER DISPUTES, FRAUD, OR REGULATORY NON-COMPLIANCE.",
          ],
        },
        {
          title: "15. Limitation of liability",
          paragraphs: [
            "TO THE MAXIMUM EXTENT PERMITTED BY LAW, HIVEWAY INC. AND ITS AFFILIATES, OFFICERS, DIRECTORS, EMPLOYEES, CONTRACTORS, SERVICE PROVIDERS, AND LICENSORS WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE DAMAGES, OR FOR ANY LOSS OF PROFITS, REVENUE, BUSINESS, GOODWILL, DATA, OR USE, ARISING OUT OF OR RELATED TO NECTARPAY OR THESE TERMS, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.",
            "TO THE MAXIMUM EXTENT PERMITTED BY LAW, HIVEWAY INC.’S TOTAL AGGREGATE LIABILITY ARISING OUT OF OR RELATING TO NECTARPAY OR THESE TERMS WILL NOT EXCEED THE GREATER OF THE AMOUNT YOU PAID TO HIVEWAY INC. FOR NECTARPAY IN THE 12 MONTHS BEFORE THE EVENT GIVING RISE TO THE CLAIM OR CAD 100.",
            "Some jurisdictions do not allow certain disclaimers or limitations, so some of the above may not apply to you to the extent prohibited by law.",
          ],
        },
        {
          title: "16. Indemnification",
          paragraphs: [
            "You will defend, indemnify, and hold harmless Hiveway Inc. and its affiliates, directors, officers, employees, contractors, service providers, licensors, and representatives from and against third-party claims, losses, liabilities, damages, costs, and reasonable legal fees arising out of or related to your use of NectarPay, your violation of these Terms, your violation of applicable law, your business operations, products, services, payments, refunds, taxes, customer interactions, submitted data, infringement or violation of third-party rights, illegal use, or violation of processor or card-network rules.",
          ],
        },
        {
          title: "17. Suspension and termination",
          paragraphs: [
            "Hiveway Inc. may suspend or terminate access to NectarPay at any time, with or without notice, if you violate these Terms, create security, legal, operational, or reputational risk, fail to pay applicable fees, violate law or processor rules, if a processor suspends or restricts relevant services, or if Hiveway Inc. decides to discontinue NectarPay or a related offering.",
            "You may stop using NectarPay at any time and may cancel any subscription in accordance with the applicable billing flow. Upon termination, the license granted under these Terms ends immediately, but sections that by their nature should survive will survive, including those related to fees owed, data, intellectual property, disclaimers, liability limits, indemnification, governing law, and dispute terms.",
          ],
        },
        {
          title: "18. Governing law",
          paragraphs: [
            "These Terms are governed by the laws of the Province of Ontario and the federal laws of Canada applicable therein, without regard to conflict-of-law principles. Subject to applicable law, courts located in Ontario, Canada will have exclusive jurisdiction over disputes arising out of or relating to these Terms or NectarPay, and you consent to that jurisdiction and venue.",
          ],
        },
        {
          title: "19. Changes to these Terms",
          paragraphs: [
            "Hiveway Inc. may update these Terms from time to time. If we make material changes, we may provide notice by updating the effective date, through NectarPay, by email, or by other reasonable means. Your continued use of NectarPay after updated Terms become effective constitutes acceptance of the updated Terms.",
          ],
        },
        {
          title: "20. General",
          paragraphs: [
            "These Terms constitute the entire agreement between you and Hiveway Inc. regarding NectarPay unless you and Hiveway Inc. have entered into a separate written agreement covering the service. If any provision of these Terms is found unenforceable, the remaining provisions will remain in full force and effect.",
            "Hiveway Inc.’s failure to enforce any provision of these Terms is not a waiver of that provision. You may not assign or transfer these Terms without Hiveway Inc.’s prior written consent. Hiveway Inc. may assign these Terms in connection with a merger, acquisition, reorganization, financing, or sale of assets.",
          ],
        },
      ],
    },
    privacy: {
      title: "NectarPay Privacy Policy",
      effectiveDate: "Effective date: June 29, 2026",
      contact: "Privacy questions or requests may be sent to",
      contactEmail: "privacy{'@'}hiveway.com",
      address:
        "Hiveway Inc., 4145 North Service Road, Suite 200, Burlington, Ontario L7L 6A3, Canada.",
      sections: [
        {
          title: "1. Scope",
          paragraphs: [
            "Hiveway Inc. provides NectarPay, a payment and point-of-sale software product for merchants. This Privacy Policy explains how Hiveway Inc. collects, uses, stores, discloses, and protects personal information in connection with NectarPay.",
            "NectarPay is used by businesses. When a merchant enters or processes information about its customers, personnel, or business contacts, the merchant is responsible for ensuring it has authority to provide that information to NectarPay. Payment processors and other third parties may also collect, use, and process information under their own privacy policies and terms.",
          ],
        },
        {
          title: "2. Information we collect",
          paragraphs: [
            "We collect and process information needed to provide, secure, support, and improve NectarPay. The information collected depends on how a merchant configures and uses the service.",
          ],
          subsections: [
            {
              title: "a. Account, administrator, and user information",
              paragraphs: [
                "We may collect names, email addresses, authentication identifiers, roles, permissions, account status, subscription status, business names, business contact details, and account settings for owners, administrators, employees, contractors, invited users, and other authorized users.",
              ],
            },
            {
              title: "b. Merchant business and configuration information",
              paragraphs: [
                "We may collect business information entered into NectarPay, including locations, terminals, catalog items, prices, product groups, product tags, taxes, customers, receipts, reports, scheduled reports, webhook settings, integrations, and other configuration or operational data.",
              ],
            },
            {
              title: "c. Customer, receipt, transaction, and payment metadata",
              paragraphs: [
                "We may collect transaction and payment-related metadata, such as payment identifiers, amounts, currency, timestamps, locations, terminals, cart details, receipt information, refund and dispute metadata, customer contact details supplied for receipts or records, and processor status information.",
                "Full payment card numbers and CVV codes are handled by payment processors such as Stripe and are not stored by Hiveway Inc.",
              ],
            },
            {
              title: "d. Support communications",
              paragraphs: [
                "If you contact us for support or use a support channel, we may receive the information submitted through that process, including your name, email address, company information, support request details, attachments, screenshots, diagnostic information, and correspondence history.",
              ],
            },
            {
              title: "e. Device, usage, log, and security information",
              paragraphs: [
                "We may collect device and browser information, IP addresses, usage events, diagnostic data, error reports, logs, security events, authentication events, terminal/device metadata, and similar technical information needed to operate, secure, troubleshoot, and improve NectarPay.",
              ],
            },
            {
              title: "f. Information from processors and integrations",
              paragraphs: [
                "To provide NectarPay, we may receive information from payment processors, cloud services, authentication providers, email providers, webhook endpoints, and other integrations configured by a merchant or used to operate the service. This may include processor record identifiers, operational metadata, account status information, and data needed to complete payment, receipt, reporting, support, or integration workflows.",
              ],
            },
          ],
        },
        {
          title: "3. How we use information",
          paragraphs: ["We use information collected through NectarPay to:"],
          items: [
            "provide, operate, maintain, authenticate, and improve NectarPay",
            "support payment, refund, catalog, cart, receipt, customer, terminal, tax, reporting, webhook, scheduled report, and account workflows",
            "process account administration, subscriptions, settings, and user access",
            "respond to support requests, troubleshoot issues, and communicate with users",
            "monitor reliability, diagnose errors, secure the service, and protect against misuse, abuse, fraud, or unauthorized access",
            "comply with legal, regulatory, contractual, accounting, tax, security, and recordkeeping obligations",
            "enforce our terms, policies, and agreements",
            "create aggregated or de-identified information to understand service performance and improve product features, provided it does not identify an individual or merchant customer",
          ],
        },
        {
          title: "4. How we share information",
          paragraphs: [
            "We do not sell personal information in the ordinary meaning of selling customer lists for money. We may share information in the following circumstances:",
          ],
          items: [
            "with authorized users of the merchant account according to their roles and permissions",
            "with payment processors and integration providers where needed to provide NectarPay functionality",
            "with service providers that help us host, operate, secure, monitor, support, communicate, analyze, or improve NectarPay",
            "with professional advisors, insurers, auditors, and legal representatives where reasonably necessary",
            "when required or permitted by law, regulation, legal process, governmental request, or to protect rights, safety, security, or property",
            "in connection with a merger, acquisition, financing, reorganization, asset sale, or similar business transaction",
          ],
        },
        {
          title: "5. Service providers and third parties",
          paragraphs: [
            "We use third-party service providers to help deliver NectarPay. These may include payment processors such as Stripe, cloud hosting and storage providers, authentication providers, analytics and monitoring tools, communications and email providers, support systems, security tools, and other vendors or integrations used to operate the service.",
            "These providers may process information on our behalf or under their own terms and privacy practices. We limit vendor access to information needed for their services and require appropriate safeguards where applicable.",
          ],
        },
        {
          title: "6. Data retention",
          paragraphs: [
            "We retain information for as long as reasonably necessary to provide NectarPay, maintain merchant account continuity, support returning users, resolve disputes, enforce agreements, comply with legal, tax, accounting, security, and contractual obligations, and support legitimate business purposes.",
            "Because merchants may need transaction, receipt, report, tax, customer, and account records for business and legal purposes, some records may be retained after active use of the service ends unless deletion is requested and deletion is legally, technically, and contractually permitted. Support records may also be retained to manage ongoing customer relationships and document prior interactions.",
          ],
        },
        {
          title: "7. Data security",
          paragraphs: [
            "We use reasonable administrative, technical, and organizational safeguards designed to protect information processed through NectarPay against unauthorized access, loss, misuse, alteration, or disclosure.",
            "No method of transmission over the internet or method of storage is completely secure, and we cannot guarantee absolute security. Merchants are responsible for protecting their own devices, users, networks, credentials, terminals, integrations, and account access.",
          ],
        },
        {
          title: "8. International data transfers",
          paragraphs: [
            "Hiveway Inc. is based in Ontario, Canada. Information may be processed or stored in Canada, the United States, or other jurisdictions where Hiveway Inc., payment processors, service providers, or merchant-configured integrations operate.",
            "As a result, information may be subject to laws of jurisdictions different from your own.",
          ],
        },
        {
          title: "9. Your choices and privacy rights",
          paragraphs: [
            "Subject to legal, contractual, security, and business limits, individuals may request access to or correction of their personal information, ask questions about our privacy practices, or withdraw consent where processing is based on consent. Withdrawal of consent may affect the ability to use NectarPay or provide requested services.",
            "Depending on your location and applicable law, you may have additional privacy rights, including rights to request deletion of certain personal information. We may need to verify your identity and authority before responding to a privacy request.",
            "If your information was provided to NectarPay by a merchant, or if the request relates to records controlled by a merchant account, we may direct you to that merchant or work with the merchant to respond. Some information may also need to be accessed, corrected, deleted, or managed through the merchant account administrator, payment processor, or relevant integration provider.",
            "If you have a privacy concern or complaint, contact privacy{'@'}hiveway.com. We will review and respond in accordance with applicable Canadian privacy laws, including PIPEDA where applicable, and other laws that may apply.",
          ],
        },
        {
          title: "10. Children’s privacy",
          paragraphs: [
            "NectarPay is intended for business use and is not directed to children. We do not knowingly collect personal information from children through NectarPay. Do not use NectarPay to knowingly submit personal information from children unless you have all required authority and consent under applicable law.",
          ],
        },
        {
          title: "11. Changes to this Privacy Policy",
          paragraphs: [
            "We may update this Privacy Policy from time to time. If we make material changes, we may provide notice by updating the effective date, through NectarPay, by email, or by other reasonable means. Continued use of NectarPay after an updated Privacy Policy becomes effective means the updated policy applies going forward.",
          ],
        },
        {
          title: "12. Contact us",
          paragraphs: [
            "If you have questions about this Privacy Policy or want to make a privacy-related request, contact Hiveway Inc. at privacy{'@'}hiveway.com or at the mailing address below.",
          ],
        },
      ],
    },
  },
  accounts: {
    accountCreated: "Account Created",
    agreementText: "I agree to the",
    acknowledgementText: "and acknowledge the",
    loginLegalPrefix: "By using NectarPay, you agree to the",
    loginLegalJoin: "and acknowledge the",
    tos: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    newAccount: "New Account",
    noAccountsAvailable: "No Accounts Available",
    otherAccounts: "Other Accounts",
    switchAccount: "Switch Account",
    currentAccount: "Current Account",
    addNewAccount: {
      title: "New Account",
      companyName: "Company Name",
      country: "Country",
      email: "Email",
    },
  },
  status: {
    online: "Online",
    offline: "Offline",
    succeeded: "Succeeded",
    canceled: "Canceled",
    failed: "Failed",
    requires_payment_method: "Requires Payment Method",
    requires_action: "Requires Action",
    processing: "Processing",
    refunded: "Refunded",
    partially_refunded: "Partially Refunded",
    Active: "Active",
    Inactive: "Inactive",
    Invited: "Invited",
    incomplete: "Incomplete",
    requires_confirmation: "Requires Confirmation",
    requires_capture: "Awaiting capture",
    archived: "Archived",
    active: "Active",
    complete: "Form Completed",
  },
  toolTipsMessage: {
    succeeded: "This payment is complete",
    canceled: "This payment is canceled",
    refunded: "This refund has been initiated",
    requires_action:
      "An additional action is required to complete this payment; Customer may be required to authenticate using 3D Secure",
    requires_payment_method: "The payment failed on checkout page",
    processing: "The payment was submitted to Stripe successfully",
    partially_refunded: "refund was initiated",
    incomplete: "The payment has not completed",
    formCompleted: "The form has been completed",
    formOpen:
      "Forms for this transaction have been captured. Finalize the transaction to complete it.",
    requires_confirmation: "The payment requires confirmation",
    restricted_feature_message: "Upgrade to the lite plan to gain access to these features",
  },
  inventory: {
    hold: "Hold",
    adjustInventory: "Adjust Inventory",
    currentStock: "Current Stock",
    adjustmentType: "Adjustment Type",
    adjustmentAmount: "Adjustment Amount",
    referenceNumber: "Reference Number",
    referenceId: "Reference ID",
    memo: "Memo",
    memoPlaceholder: "Optional memo about this inventory adjustment",
    add: "Add Stock",
    remove: "Remove Stock",
    setTo: "Set Stock To",
    newStockWillBe: "New stock will be",
    amountMustBePositive: "Amount must be greater than zero",
    amountGreaterThanEqualToZero: "Amount must be greater than or equal to zero",
    invalidAmount: "Enter a valid amount",
    cannotRemoveMoreThanStock: "Cannot remove more than current stock",
    adjustmentSuccessful: "Inventory adjusted successfully",
    adjustmentFailed: "Failed to adjust inventory",
    stockHeader: "Stock",
    stock: "Inventory",
    checkout: "Checkout",
    hasInventory: "Has Inventory",
    lowStockThreshold: "Low Stock Threshold",
    threshold: "Threshold",
    filterByStock: "Filter by Stock",
    lowStock: "Low Stock",
    outOfStock: "Out of Stock",
    notEnabled: "Inventory not enabled",
    stockWarning: "Stock Warning",
    noWarning: "No Warning",
    stockRange: "Stock Range",
    stockRangeDisabledForOutOfStock: "Stock range is disabled for out of stock items",
    min: "Min",
    max: "Max",
    overselling: "Overselling",
    noOverselling: "Do not allow overselling",
    hardLowerBound: "Allow overselling to a hard lower bound",
    noLowerBound: "Allow overselling with no lower bound",
    oversellLimit: "Oversell limit",
    oversellQuantity: "Oversell Quantity",
    oversellQuantityHint:
      "Enter how many units can be oversold. This is saved as a negative stock floor.",
    minimumStock: "Minimum Stock",
    minimumStockHint: "Stock cannot be reduced below this value.",
    negativeValueError: "Value cannot be negative",
    minGreaterThanMaxError: "Min cannot be greater than Max",
    management: {
      title: "Inventory",
      description: "Manage your product inventory, track stock levels, and view inventory history.",
    },
    lowStockAlert: "You have items with low stock levels",
    outOfStockAlert: "You have items that are out of stock",
    viewLowStockItems: "View Low Stock Items",
    viewOutOfStockItems: "View Out of Stock Items",
    lowStockItemsTitle: "Low Stock",
    outOfStockItemsTitle: "Out of Stock",
    product: "Product",
    price: "Price",
    filterByProduct: "Filter by Product",
    productSearch: "Search Products",
    productAndPrice: "Product & Price",
    productSlashPrice: "Product/Price",
    productClass: "Product Group",
    location: "Location",
    locationsAndStock: "Locations & Stock",
    filterByProductAndPrice: "Filter by Product & Price",
    viewPriceLog: "View Price Log",
    viewProductLog: "View Product Log",
    viewInventoryLog: "View Inventory Log",
    logTitle: "Inventory Log",
    priceLogTitle: "Price Inventory Log",
    productLogTitle: "Product Inventory Log",
    action: "Action",
    user: "User",
    details: "Details",
    amount: "Amount",
    dateRange: "Date Range",
    filterByDate: "Filter by Date",
    filterByUser: "Filter by User",
    selectUser: "Select User",
    filterByReference: "Filter by Reference ID",
    referenceSearch: "Search Reference IDs",
    filterByAction: "Filter by Action",
    selectAction: "Select Action",
    dateUser: "Date & User",
    initialStock: "Initial Stock",
    sku: "SKU",
    manageInventory: "Manage Inventory",
    inventorySettings: "Inventory Settings",
    exportDateRangeRequired:
      "A date range is required to export inventory logs. Please set a date range filter.",
    exportDateRangeTooLarge: "Date range cannot exceed 30 days. Please adjust your date range.",
    exportSuccessful: "Inventory log export completed successfully",
    inventoryChanges: "Inventory Changes",
    stockTooltip: "Physical inventory in stock",
    checkoutTooltip: "Items in checkout process but not yet purchased",
    flowDescriptionPurchase: "Items moved from stock to checkout",
    flowDescriptionRelease: "Items moved from checkout to finalized sale",
    flowDescriptionGeneric: "Both stock and checkout changed",
    from: "From",
    to: "To",
    notTracked: "Not tracked",
    inventoryNotTracked: "Inventory is not tracked for this product",
    locationBased: "Location based",
    locationBasedInventory: "Inventory is tracked per location. Select a location to view stock.",
  },
  reports: {
    description: "Generate and download reports about your business activities.",
    timezoneNotice: "Your report will be generated in the {timezone} timezone.",
    timezoneChangeNote: "To change your timezone settings, please visit your Stripe Dashboard.",
    paymentsReport: {
      description: "View itemized payments and payment summaries.",
    },
    purchaseReport: {
      title: "Purchases Report",
      description: "View and analyze purchases made through the NectarPay cart.",
      dateRange: "Date Range",
      today: "Today",
      yesterday: "Yesterday",
      thisWeek: "This Week",
      lastWeek: "Last Week",
      thisMonth: "This Month",
      lastMonth: "Last Month",
      thisYear: "This Year",
      customRange: "Custom Range",
      fromDate: "From Date",
      toDate: "To Date",
      reportMode: "Report Mode",
      includeItemDetails: "Include detailed item information",
      includeCanceledTransactions: "Include canceled transactions",
      generate: "Generate Report",
      success: "Report generated successfully!",
      error: "Failed to generate report",
    },
    returnsReport: {
      title: "Returns Report",
      description:
        "View and analyze customer returns and refunds processed with details about returned cart items.",
      dateRange: "Date Range",
      fromDate: "From Date",
      toDate: "To Date",
      reportMode: "Report Mode",
      generate: "Generate Report",
      success: "Returns report generated successfully!",
      error: "Failed to generate returns report",
      itemOptions: "Item Return Options",
      includeItemQuantities: "Include item quantities in report",
      includeReturnStatuses: "Include return statuses for items",
      returnStatuses: "Select return statuses to include",
      itemQuantity: "Item Quantity",
      returnStatus: "Return Status",
      statusOptions: {
        returned: "Returned",
        damaged: "Damaged",
        resalable: "Resalable",
        restocked: "Restocked",
        pending: "Pending Review",
      },
    },
    stripeFinancials: {
      title: "Financial Reports",
      description:
        "Access detailed financial reports, analytics, and insights on your Stripe dashboard.",
      viewButton: "View on Stripe",
    },
    inventorySnapshot: {
      title: "Inventory Snapshot",
      description: "View current stock and checkout hold quantities across your product locations.",
    },
    inventoryLog: {
      title: "Inventory Log",
      description:
        "View a detailed history of all inventory changes, adjustments, and transactions.",
      viewButton: "View Logs",
    },
    generated: {
      title: "Generated Reports",
      description: "View generated reports, download completed files, and rerun failed reports.",
      viewReports: "View Reports",
      view: "View",
      createReport: "Create Report",
      schedules: "Schedules",
      backToGenerated: "Back to Generated Reports",
      createSuccess: "Report queued successfully.",
      createError: "Failed to create report",
      listError: "Failed to load reports",
      download: "Download",
      downloadError: "Failed to download report",
      rerun: "Rerun",
      rerunSuccess: "Report queued to rerun.",
      rerunError: "Failed to rerun report",
      noReports: "No reports found",
      unknownError: "Unknown error",
      category: "Report Category",
      mode: "Report Mode",
      allLocations: "All Locations",
      locations: "Locations",
      allLocationsHint: "All active locations are selected by default.",
      productStatuses: "Product Statuses",
      pointInTime: "Point in time",
      invalidDateRange: "Invalid date range",
      oneYearMax: "Date range must be one year or less",
      categories: {
        payments: "Payments",
        purchase: "Purchases",
        return: "Returns",
        inventory: "Inventory Snapshot",
      },
      modes: {
        itemized: "Itemized",
        summary: "Summary",
      },
      filters: {
        type: "Type",
        status: "Status",
        filterByType: "Filter by type",
        filterByStatus: "Filter by status",
        multipleSelected: "{count} selected",
      },
      table: {
        type: "Type",
        dateRange: "Date Range",
        status: "Status",
        created: "Created",
        error: "Error",
      },
      types: {
        purchase_summary: "Summary Purchases",
        purchase_itemized: "Itemized Purchases",
        return_summary: "Summary Returns",
        return_itemized: "Itemized Returns",
        payments_summary: "Payments Summary",
        payments_itemized: "Payments Itemized",
        inventory_snapshot: "Inventory Snapshot",
      },
      statuses: {
        queued: "queued",
        running: "running",
        succeeded: "succeeded",
        failed: "failed",
      },
    },
  },
  product: {
    productName: "Product Name",
    productClass: "Product Group",
    productTags: "Product Tags",
    metadataValues: "Metadata Values",
    selectProductTags: "Select Tags",
    maxTags: "Maximum 10 tags allowed",
    productGroupHint:
      "Group related variants together for kiosk browsing, such as a hoodie with multiple sizes or colors.",
    productGroupSetupHint:
      'Product groups are customer-facing families of related sellable items. For example, create "Shirt" as the group, then add variants based on size, color, or other options as products inside it.',
    productTagsHint:
      "Maximum 10 tags allowed. Use tags for filters, reporting, collections, or kiosk browse groups—not for required variant choices like size/color.",
    tagSetupHint:
      "Tags are reusable markers for filtering, reporting, collections, or kiosk browse groups. Do not use tags for required variant choices like size or color.",
    tagIdHint: "If not provided, a random tag ID will be generated.",
    defaultPrice: "Default Price",
    idGeneratedHint: "Leave blank to auto-generate.",
    skuValidationError: "SKU may contain letters, numbers, hyphens, and underscores",
    selectProductClass: "Select a Product Group",
    lowStockThresholdHint: "Notify when stock falls below this number",
    taxInformation: "Tax Information",
    taxCodeDefaultHint: "This is the default tax code for your account",
    taxCode: "Tax Code",
    productCode: "Product Code",
    taxReferenceTitle: "Tax Reference",
    taxReferencePlaceholder: "eg. GL code",
    taxReferenceDescription:
      "Use Tax Reference to link this product to your general ledger or project code.",
    taxCodeSearch: "Search tax codes...",
    taxBehaviorTitle: "Tax Behavior",
    taxBehavior: {
      inclusive: {
        label: "Inclusive",
        description: "Tax is included in the price.",
      },
      exclusive: {
        label: "Exclusive",
        description: "Tax is not included in the price.",
      },
      unspecified: {
        label: "Unspecified",
        description: "Default Tax Settings will be used.",
      },
      inferredByCurrency: {
        label: "Inferred by Currency",
        description: "Tax is inferred by the currency.",
      },
    },
  },
  productTag: {
    removeTag: "Remove Tag",
  },
  scanner: {
    requestPermission: "Request Permission",
    cameraMessage: "Camera access is required.",
    cameraAccessError: "Error accessing camera",
    productFound: "Product found",
    productHasNoDefaultPrice: "Product found, but has no default price",
    productAddedToCart: "Product added to cart",
    productOutOfStock: "Product out of stock",
    productNotFound: "Product not found",
    productNotFoundForIdentifier: "No product found for identifier: {identifier}",
    productNotFoundAtLocation:
      "No product found for identifier: {identifier}, at location: {location}",
    processQRCodeError: "Error processing QR code",
    startScan: "Start Scan",
    stopScan: "Stop Scan",
    scanning: "Scanning",
    autoSelectDefaultLabel: "Auto-select default price",
    manualSelectLabel: "Manually select price",
    selectPriceTitle: "Select a price for {name}",
    selectPriceDescription: "Choose which price to add to the cart.",
    noPricesAvailable: "No prices available for selection",
    skuLabel: "SKU: {sku}",
    unnamedPrice: "Unnamed price",
  },
  qrCodeGeneration: {
    success: "Product QR codes generated successfully",
    error: "Failed to generate product QR codes",
  },
  taxcode: {
    default: {
      description: "Default tax code for your account",
      name: "Account Default",
    },
    txcd_99999999: {
      description:
        "A physical good that can be moved or touched. Also known as tangible personal property.",
      name: "General - Tangible Goods",
    },
    txcd_20030000: {
      description:
        "General category for services. It should be used only when there is no more specific services category. In the European Union, the default rule for business-to-consumer sales (B2C) is the location of the seller, whereas for business-to-business sales (B2B) - the location of the buyer.",
      name: "General - Services",
    },
    txcd_10000000: {
      description:
        "A digital service provided mainly through the internet with minimal human involvement, relying on information technology. Consider more specific categories like software, digital goods, cloud services, or website services for your product (especially if you sell in the US). If you stay with this category, taxes will be similar to those for a generic digital item like downloaded music.",
      name: "General - Electronically Supplied Services",
    },
    txcd_00000000: {
      description:
        "Any nontaxable good or service which can be used to ensure no tax is applied, even for jurisdictions that impose a tax.",
      name: "Nontaxable",
    },
    txcd_10010001: {
      description:
        "Cloud service offering infrastructure resources (specifically server storage, RAM, and CPU usage) over the internet. This offering is intended for personal use, rather than for use by a commercial enterprise.  Note: The distinction between business use and personal use for this product tax category is relevant only if you have sales in the US.",
      name: "Infrastructure as a service (IaaS) - personal use",
    },
    txcd_10101000: {
      description:
        "Cloud service offering infrastructure resources (specifically server storage, RAM, and CPU usage) over the internet. This offering is intended for use by a commercial enterprise.  Note: The distinction between business use and personal use for this product tax category is relevant only if you have sales in the US.",
      name: "Infrastructure as a service (IaaS) - business use",
    },
    txcd_10102000: {
      description:
        "Cloud service providing a platform for users to develop, run, and manage applications. This offering is intended for use by a commercial enterprise.  Note: The distinction between business use and personal use for this product tax category is relevant only if you have sales in the US.",
      name: "Platform as a service (PaaS) - business use",
    },
    txcd_10102001: {
      description:
        "Cloud service providing a platform for users to develop, run, and manage applications. This offering is intended for personal use, rather than for use by a commercial enterprise.  Note: The distinction between business use and personal use for this product tax category is relevant only if you have sales in the US.",
      name: "Platform as a Service (PaaS) - personal use",
    },
    txcd_10103000: {
      description:
        "Cloud services software delivered over the internet. The software isn't customized for a specific buyer and they don't download anything. The software is intended for personal use, rather than for use by a commercial enterprise.  Note: The distinction between business use and personal use for this product tax category is relevant only if you have sales in the US.",
      name: "Software as a service (SaaS) - personal use",
    },
    txcd_10103001: {
      description:
        "Cloud services software delivered over the internet. The software isn't customized for a specific buyer and they don't download anything. The software is intended for use by a commercial enterprise.  Note: The distinction between business use and personal use for this product tax category is relevant only if you have sales in the US.",
      name: "Software as a service (SaaS) - business use",
    },
    txcd_10103100: {
      description:
        "Cloud services software delivered over the internet. The software isn't customized for a specific buyer and this model assumes an electronic transfer to the buyer, such as an app download.  The software is intended for personal use, rather than for use by a commercial enterprise.  Note: The distinction between business use and personal use for this product tax category is relevant only if you have sales in the US.",
      name: "Software as a service (SaaS) - electronic download - personal use",
    },
    txcd_10103101: {
      description:
        "Cloud services software delivered over the internet. The software isn't customized for a specific buyer and this model assumes an electronic transfer to the buyer, such as an app download.  The software is intended for use by a commercial enterprise. Note: The distinction between business use and personal use for this product tax category is relevant only if you have sales in the US.",
      name: "Software as a service (SaaS) - electronic download - business use",
    },
    txcd_10104001: {
      description:
        "Cloud service providing business process outsourcing services over the internet.",
      name: "Cloud-based business process as a service",
    },
    txcd_10201000: {
      description:
        "Video or electronic games in the common sense that are transferred electronically. These goods are downloaded to a device with permanent access granted. This does not include games that are considered betting, gambling, lottery, etc.",
      name: "Video Games - downloaded - non subscription - with permanent rights",
    },
    txcd_10201001: {
      description:
        "Video or electronic games in the common sense that are transferred electronically. These goods are downloaded to a device with access that expires after a stated period of time. This does not include games that are considered betting, gambling, lottery, etc.",
      name: "Video Games - downloaded - non subscription - with limited rights",
    },
    txcd_10201002: {
      description:
        "Video or electronic games in the common sense that are transferred electronically. These goods are downloaded to a device with access that is conditioned upon continued subscription payment. This does not include games that are considered betting, gambling, lottery, etc.",
      name: "Video Games - downloaded - subscription - with conditional rights",
    },
    txcd_10201003: {
      description:
        "Video or electronic games in the common sense that are transferred electronically. These goods are streamed to a device with access that expires after a stated period of time. This does not include games that are considered betting, gambling, lottery, etc.",
      name: "Video Games - streamed - non subscription - with limited rights",
    },
    txcd_10201004: {
      description:
        "Video or electronic games in the common sense that are transferred electronically. These goods are streamed to a device with access that is conditioned upon continued subscription payment. This does not include games that are considered betting, gambling, lottery, etc.",
      name: "Video Games - streamed - subscription - with conditional rights",
    },
    txcd_10202000: {
      description:
        'Prewritten ("canned") software that the buyer downloads. The software is intended for personal use, rather than for use by a commercial enterprise.  Note: The distinction between business use and personal use for this product tax category is relevant only if you have sales in the US.',
      name: "Downloadable Software - personal use",
    },
    txcd_10202001: {
      description:
        'Prewritten ("canned") software that the buyer downloads used for non-recreational purposes, such as antivirus, database, educational, financial, word processing, etc. The software is intended for personal use, rather than for consumption in a commercial enterprise.  Note: The distinction between business use and personal use for this tax code is relevant only if you are transacting business in the US.',
      name: "Downloadable Software - non-recreational - personal use",
    },
    txcd_10202003: {
      description:
        'Prewritten ("canned") software that the buyer downloads. The software is intended for use by a commercial enterprise.  Note: The distinction between business use and personal use for this product tax category is relevant only if you have sales in the US.',
      name: "Downloadable Software - business use",
    },
    txcd_10203000: {
      description:
        "Custom software that the buyer downloads. The software is intended for personal use, rather than for use by a commercial enterprise.  Note: The distinction between business use and personal use for this product tax category is relevant only if you have sales in the US.",
      name: "Downloadable Software - custom - personal use",
    },
    txcd_10203001: {
      description:
        "Custom software that the buyer downloads. The software is intended for use by a commercial enterprise.  Note: The distinction between business use and personal use for this product tax category is relevant only if you have sales in the US.",
      name: "Downloadable Software - custom - business use",
    },
    txcd_10301000: {
      description:
        "The recording of a book read aloud and sold with unlimited usage (e.g., a downloaded audio copy of The High Growth Handbook).",
      name: "Audiobook",
    },
    txcd_10302000: {
      description:
        "Works that are generally recognized in the ordinary and usual sense as books and are transferred electronically. These goods are downloaded to a device with permanent access granted. These goods include novels, autobiographies, encyclopedias, dictionaries, repair manuals, phone directories, business directories, zip code directories, cookbooks, etc.",
      name: "Digital Books - downloaded - non subscription - with permanent rights",
    },
    txcd_10302001: {
      description:
        "Works that are generally recognized in the ordinary and usual sense as books and are transferred electronically.  These goods are downloaded to a device with access that expires after a stated period of time.  These goods include novels, autobiographies, encyclopedias, dictionaries, repair manuals, phone directories, business directories, zip code directories, cookbooks, etc.",
      name: "Digital Books - downloaded - non subscription - with limited rights",
    },
    txcd_10302002: {
      description:
        "Works that are generally recognized in the ordinary and usual sense as books and are transferred electronically. These goods are downloaded to a device with access that is conditioned upon continued subscription payment. These goods include novels, autobiographies, encyclopedias, dictionaries, repair manuals, phone directories, business directories, zip code directories, cookbooks, etc.",
      name: "Digital Books - downloaded - subscription - with conditional rights",
    },
    txcd_10302003: {
      description:
        "Works that are generally recognized in the ordinary and usual sense as books and are transferred electronically. These goods are viewable (but not downloadable) on a device with access that is conditioned upon continued subscription payment. These goods include novels, autobiographies, encyclopedias, dictionaries, repair manuals, phone directories, business directories, zip code directories, cookbooks, etc.",
      name: "Digital Books - viewable only - subscription - with conditional rights",
    },
    txcd_10303000: {
      description:
        "A digital version of a traditional periodical published at regular intervals with the entire publication or individual articles downloaded to a device with access that is conditioned upon continued subscription payment.",
      name: "Digital Magazines/Periodicals - downloadable - subscription - with conditional rights",
    },
    txcd_10303001: {
      description:
        "A digital version of a traditional magazine published at regular intervals. The publication is accessed via a subscription which also entitles the purchaser to physical copies of the media.",
      name: "Digital Magazines/Periodicals - subscription tangible and digital",
    },
    txcd_10303002: {
      description:
        "A digital version of a traditional periodical published at regular intervals with the entire publication or individual articles viewable (but not downloadable) on a device with access that is conditioned upon continued subscription payment.",
      name: "Digital Magazines/Periodicals - viewable only - subscription - with conditional rights",
    },
    txcd_10303100: {
      description:
        "A digital version of a traditional periodical published at regular intervals with the entire publication or individual articles downloaded to a device with permanent access granted. The publication is accessed without a subscription.",
      name: "Digital Magazines/Periodicals - downloadable - non subscription - with permanent rights",
    },
    txcd_10303101: {
      description:
        "A digital version of a traditional periodical published at regular intervals with the entire publication or individual articles viewable (but not downloadable) on a device with access that expires after a stated period of time. The publication is accessed without a subscription.",
      name: "Digital Magazines/Periodicals - viewable only - non subscription - with limited rights",
    },
    txcd_10303102: {
      description:
        "A digital version of a traditional periodical published at regular intervals with the entire publication or individual articles viewable (but not downloadable) on a device with permanent access granted. The publication is accessed without a subscription.",
      name: "Digital Magazines/Periodicals - viewable only - non subscription - with permanent rights",
    },
    txcd_10303104: {
      description:
        "A digital version of a traditional periodical published at regular intervals with the entire publication or individual articles downloaded to a device with access that expires after a stated period of time. The publication is accessed without a subscription.",
      name: "Digital Magazines/Periodicals - downloadable - non subscription - with limited rights",
    },
    txcd_10304000: {
      description:
        "A digital version of a traditional newspaper published at regular intervals with the entire publication or individual articles downloaded to a device with permanent access granted. The publication is accessed without a subscription.",
      name: "Digital Newspapers - downloadable - non subscription - with permanent rights",
    },
    txcd_10304001: {
      description:
        "A digital version of a traditional newspaper published at regular intervals with the entire publication or individual articles viewable (but not downloadable) on a device with access that expires after a stated period of time. The publication is accessed without a subscription.",
      name: "Digital Newspapers - viewable only - non subscription - with limited rights",
    },
    txcd_10304002: {
      description:
        "A digital version of a traditional newspaper published at regular intervals with the entire publication or individual articles viewable (but not downloadable) on a device with permanent access granted.  The publication is accessed without a subscription.",
      name: "Digital Newspapers - viewable only - non subscription - with permanent rights",
    },
    txcd_10304003: {
      description:
        "A digital version of a traditional newspaper published at regular intervals with the entire publication or individual articles downloaded to a device with access that expires after a stated period of time.  The publication is accessed without a subscription.",
      name: "Digital Newspapers - downloadable - non subscription - with limited rights",
    },
    txcd_10304100: {
      description:
        "A digital version of a traditional newspaper published at regular intervals with the entire publication or individual articles downloaded to a device with access that is conditioned upon continued subscription payment.",
      name: "Digital Newspapers - downloadable - subscription - with conditional rights",
    },
    txcd_10304101: {
      description:
        "A digital version of a traditional newspaper published at regular intervals. The publication is accessed via a subscription which also entitles the purchaser to physical copies of the media.",
      name: "Digital Newspapers - subscription tangible and digital",
    },
    txcd_10304102: {
      description:
        "A digital version of a traditional newspaper published at regular intervals with the entire publication or individual articles viewable (but not downloadable) on a device with access that is conditioned upon continued subscription payment.",
      name: "Digital Newspapers - viewable only - subscription - with conditional rights",
    },
    txcd_10305000: {
      description:
        "Works that are required as part of a formal academic education program and are transferred electronically. These goods are downloaded to a device with access that expires after a stated period of time.",
      name: "Digital School Textbooks - downloaded - non subscription - with limited rights",
    },
    txcd_10305001: {
      description:
        "Works that are required as part of a formal academic education program and are transferred electronically. These goods are downloaded to a device with permanent access granted.",
      name: "Digital School Textbooks - downloaded - non subscription - with permanent rights",
    },
    txcd_10401000: {
      description:
        "Works that result from the fixation of a series of musical, spoken, or other sounds that are transferred electronically.  These goods are streamed to a device with access that expires after a stated period of time.  These goods include prerecorded or live music, prerecorded or live readings of books or other written materials, prerecorded or live speeches, ringtones, or other sound recordings, but not including audio greeting cards.",
      name: "Digital Audio Works - streamed - non subscription - with limited rights",
    },
    txcd_10401001: {
      description:
        "Works that result from the fixation of a series of musical, spoken, or other sounds that are transferred electronically.  These goods are downloaded to a device with access that expires after a stated period of time.  These goods include prerecorded or live music, prerecorded or live readings of books or other written materials, prerecorded or live speeches, ringtones, or other sound recordings, but not including audio greeting cards.  Note the presence of PTC 10301000 (Audiobook), a more granular option for downloaded audiobooks.",
      name: "Digital Audio Works - downloaded - non subscription - with limited rights",
    },
    txcd_10401100: {
      description:
        "Works that result from the fixation of a series of musical, spoken, or other sounds that are transferred electronically. These goods are downloaded to a device with permanent access granted. These goods include prerecorded or live music, prerecorded or live readings of books or other written materials, prerecorded or live speeches, ringtones, or other sound recordings, but not including audio greeting cards.  Note the presence of PTC 10301000 (Audiobook), a more granular option for downloaded audiobooks.",
      name: "Digital Audio Works - downloaded - non subscription - with permanent rights",
    },
    txcd_10401200: {
      description:
        "Works that result from the fixation of a series of musical, spoken, or other sounds that are transferred electronically. These goods are streamed to a device with access that is conditioned upon continued subscription payment. These goods include prerecorded or live music, prerecorded or live readings of books or other written materials, prerecorded or live speeches, ringtones, or other sound recordings, but not including audio greeting cards.",
      name: "Digital Audio Works - streamed - subscription - with conditional rights",
    },
    txcd_10402000: {
      description:
        "A series of related images which, when shown in succession, impart an impression of motion, together with accompanying sounds, if any.  These goods are streamed to a device with access that expires after a stated period of time.  These goods include motion pictures, music videos, animations, news and entertainment programs, and live events, but do not include video greeting cards or video or electronic games.",
      name: "Digital Audio Visual Works - streamed - non subscription - with limited rights",
    },
    txcd_10402100: {
      description:
        "A series of related images which, when shown in succession, impart an impression of motion, together with accompanying sounds, if any.  These goods are downloaded to a device with permanent access granted.  These goods include motion pictures, music videos, animations, news and entertainment programs, and live events, but do not include video greeting cards or video or electronic games.",
      name: "Digital Audio Visual Works - downloaded - non subscription - with permanent rights",
    },
    txcd_10402110: {
      description:
        "A series of related images which, when shown in succession, impart an impression of motion, together with accompanying sounds, if any. These goods are downloaded to a device with access that expires after a stated period of time. These goods include motion pictures, music videos, animations, news and entertainment programs, and live events, but do not include video greeting cards or video or electronic games.",
      name: "Digital Audio Visual Works - downloaded - non subscription - with limited rights",
    },
    txcd_10402200: {
      description:
        "A series of related images which, when shown in succession, impart an impression of motion, together with accompanying sounds, if any.  These goods are streamed to a device with access that is conditioned upon continued subscription payment.  These goods include motion pictures, music videos, animations, news and entertainment programs, and live events, but do not include video greeting cards or video or electronic games.",
      name: "Digital Audio Visual Works - streamed - subscription - with conditional rights",
    },
    txcd_10402300: {
      description:
        "An audio visual work of a live performance streamed over the internet that you can only access for a limited time during the performance (e.g., a live concert stream).",
      name: "Digital Video Streaming - live events - limited use",
    },
    txcd_10501000: {
      description: "Digital images that are downloaded to a device with permanent access granted.",
      name: "Digital Photographs/Images - downloaded - non subscription - with permanent rights",
    },
    txcd_10502000: {
      description:
        "Gift card or gift certificate that you purchase and receive electronically and assumed to be multi-purpose.",
      name: "Gift Card",
    },
    txcd_10503000: {
      description:
        "Individual digital news articles, newsletters, and other stand-alone documents.  These goods are downloaded to a device with permanent access granted.  These publications are accessed without a subscription.",
      name: "Digital other news or documents - downloadable - non subscription - with permanent rights",
    },
    txcd_10503001: {
      description:
        "Individual digital news articles, newsletters, and other stand-alone documents. These goods are downloaded to a device with access that expires after a stated period of time.",
      name: "Digital other news or documents - downloadable - non subscription - with limited rights",
    },
    txcd_10503002: {
      description:
        "Individual digital news articles, newsletters, and other stand-alone documents. These goods are downloaded to a device with access that is conditioned upon continued subscription payment.",
      name: "Digital other news or documents - downloadable - subscription - with conditional rights",
    },
    txcd_10503003: {
      description:
        "Individual digital news articles, newsletters, and other stand-alone documents. These goods are viewable (but not downloadable) on a device with access that expires after a stated period of time.",
      name: "Digital other news or documents - viewable only - non subscription - with limited rights",
    },
    txcd_10503004: {
      description:
        "Individual digital news articles, newsletters, and other stand-alone documents. These goods are viewable (but not downloadable) on a device with permanent access granted.",
      name: "Digital other news or documents - viewable only - non subscription - with permanent rights",
    },
    txcd_10503005: {
      description:
        "Individual digital news articles, newsletters, and other stand-alone documents. These goods are viewable (but not downloadable) on a device with access that is conditioned upon continued subscription payment.",
      name: "Digital other news or documents - viewable only - subscription - with conditional rights",
    },
    txcd_10504000: {
      description:
        "Electronic software documentation or user manuals - For custom software & delivered electronically.",
      name: "Electronic software documentation or user manuals - Custom, electronic delivery",
    },
    txcd_10504003: {
      description:
        "Electronic software documentation or user manuals - For prewritten software & delivered electronically.",
      name: "Electronic software documentation or user manuals - Prewritten, electronic delivery",
    },
    txcd_10505000: {
      description:
        "The final art used for actual reproduction by photomechanical or other processes or for display purposes, but does not include website or home page design, and that is transferred electronically. These goods are downloaded to a device with access that expires after a stated period of time. These goods include drawings, paintings, designs, photographs, lettering, paste-ups, mechanicals, assemblies, charts, graphs, illustrative materials, etc.",
      name: "Digital Finished Artwork - downloaded - non subscription - with limited rights",
    },
    txcd_10505001: {
      description:
        "The final art used for actual reproduction by photomechanical or other processes or for display purposes, but does not include website or home page design, and that is transferred electronically. These goods are downloaded to a device with permanent access granted. These goods include drawings, paintings, designs, photographs, lettering, paste-ups, mechanicals, assemblies, charts, graphs, illustrative materials, etc.",
      name: "Digital Finished Artwork - downloaded - non subscription - with permanent rights",
    },
    txcd_10505002: {
      description:
        "The final art used for actual reproduction by photomechanical or other processes or for display purposes, but does not include website or home page design, and that is transferred electronically. These goods are downloaded to a device with access that is conditioned upon continued subscription payment. These goods include drawings, paintings, designs, photographs, lettering, paste-ups, mechanicals, assemblies, charts, graphs, illustrative materials, etc.",
      name: "Digital Finished Artwork - downloaded - subscription - with conditional rights",
    },
    txcd_10506000: {
      description:
        'An electronic greeting "card" typically sent via email that contains an audio only message.',
      name: "Digital Greeting Cards - Audio Only",
    },
    txcd_10506001: {
      description:
        'An electronic greeting "card" typically sent via email that contains a series of related images which, when shown in succession, impart an impression of motion, together with accompanying sounds, if any.',
      name: "Digital Greeting Cards - Audio Visual",
    },
    txcd_10506002: {
      description:
        'An electronic greeting "card" typically sent via email that contains only static images or text, rather than an audio visual or audio only experience.',
      name: "Digital Greeting Cards - Static text and/or images only",
    },
    txcd_10701000: {
      description:
        "Online advertising services such as creating and uploading advertisements on the internet. This is a standalone service that doesn't involve the sale of tangible personal property.",
      name: "Website Advertising",
    },
    txcd_10701100: {
      description: "A service to enable a customer's website to be accessible on the internet.",
      name: "Website Hosting",
    },
    txcd_10701200: {
      description: "A service to design a website or webpage.",
      name: "Website Design",
    },
    txcd_10701300: {
      description:
        "An online service that allows a customer to create, transform, process or access data electronically.",
      name: "Website Data Processing",
    },
    txcd_10701400: {
      description:
        "An online service furnishing information to customers, including online search and data comparison. This PTC involves the customer utilizing a SaaS program to access the information content. This offering is intended for use by a commercial enterprise.  Note: The distinction between business use and personal use for this product tax category is relevant only if you have sales in the US.",
      name: "Website Information Services - Business Use",
    },
    txcd_10701401: {
      description:
        "An online service furnishing information to customers, including online search and data comparison. This PTC involves the customer utilizing a SaaS program to access the information content.  This offering is intended for personal use, rather than for use by a commercial enterprise.  Note: The distinction between business use and personal use for this product tax category is relevant only if you have sales in the U.S.",
      name: "Website Information Services -  Personal Use",
    },
    txcd_10701410: {
      description:
        "The furnishing of information of any kind by electronic means. This PTC does not involve the customer utilizing a SaaS program to access the information content. This offering is intended for use by a commercial enterprise. Note: The distinction between business use and personal use for this PTC is relevant only if you have sales in the US.",
      name: "Electronically Delivered Information Services - Business Use",
    },
    txcd_10701411: {
      description:
        "The furnishing of information of any kind by electronic means. This PTC does not involve the customer utilizing a SaaS program to access the information content.  This offering is intended for personal use, rather than for use by a commercial enterprise. Note: The distinction between business use and personal use for this product tax category is relevant only if you have sales in the US.",
      name: "Electronically Delivered Information Services - Personal Use",
    },
    txcd_10702000: {
      description: "A subscription service for membership to an online dating platform.",
      name: "Online Dating Services",
    },
    txcd_10804001: {
      description:
        "A series of related images which, when shown in succession, impart an impression of motion, together with accompanying sounds, if any. These goods are streamed and/or downloaded to a device with access that is conditioned upon continued subscription payment.  Any downloads received while under subscription remain the permanent property of the subscriber.  These goods include motion pictures, music videos, animations, news and entertainment programs, and live events, but do not include video greeting cards or video or electronic games.  These goods further include self-study web based training services that impart content via audio visual goods described here.",
      name: "Digital Audio Visual Works - bundle - downloaded with permanent rights and streamed - subscription - with conditional rights",
    },
    txcd_10804002: {
      description:
        "A series of related images which, when shown in succession, impart an impression of motion, together with accompanying sounds, if any. These goods can be streamed and/or downloaded to a device with access that expires after a stated period of time. These goods include motion pictures, music videos, animations, news and entertainment programs, and live events, but do not include video greeting cards or video or electronic games.",
      name: "Digital Audio Visual Works - bundle - downloaded with limited rights and streamed - non subscription",
    },
    txcd_10804003: {
      description:
        "A series of related images which, when shown in succession, impart an impression of motion, together with accompanying sounds, if any. These goods can be streamed and/or downloaded to a device with permanent access granted. These goods include motion pictures, music videos, animations, news and entertainment programs, and live events, but do not include video greeting cards or video or electronic games.",
      name: "Digital Audio Visual Works - bundle - downloaded with permanent rights and streamed - non subscription",
    },
    txcd_10804010: {
      description:
        "Works that result from the fixation of a series of musical, spoken, or other sounds that are transferred electronically. These goods are streamed and/or downloaded to a device with access that is conditioned upon continued subscription payment.  Any downloads received while under subscription remain the permanent property of the subscriber.  These goods include prerecorded or live music, prerecorded or live readings of books or other written materials, prerecorded or live speeches, ringtones, or other sound recordings, but not including audio greeting cards.   These goods further include self-study web based training services that impart content via audio goods described here.  Note the presence of PTC 10301000 (Audiobook), a more granular option for downloaded audiobooks.",
      name: "Digital Audio Works - bundle - downloaded with permanent rights and streamed - subscription - with conditional rights",
    },
    txcd_20010001: {
      description:
        "A charge to clean, wash or wax a motor vehicle, other than a self-service coin (or credit card) operated washing station. This a labor charge, with any non-separately stated property transferred in performing the service considered inconsequential.",
      name: "Car Washing",
    },
    txcd_20010003: {
      description:
        "A charge for the cleaning of tangible personal property, other than motor vehicles or clothing.",
      name: "Cleaning of Tangible Personal Property",
    },
    txcd_20010004: {
      description:
        "A charge for janitorial services to commercial buildings, including the cleaning of floors, carpets, walls, windows, fixtures, exterior cleaning, etc.",
      name: "Commercial Cleaning Services",
    },
    txcd_20010006: {
      description:
        "A charge for custodial services to residential structures, including the cleaning of floors, carpets, walls, windows, appliances, furniture, fixtures, exterior cleaning, etc. No Tangible Personal Property is transferred.",
      name: "Residential Cleaning Services",
    },
    txcd_20010007: {
      description:
        "A charge for the service to maintain the proper operation of home or building gutters through cleaning out debris that could otherwise affect the proper water flow through the gutter system.",
      name: "Gutter Cleaning Services",
    },
    txcd_20020009: {
      description:
        "A labor charge to install hardware where the installed property isn't considered permanently attached to the real property.",
      name: "Installation of Hardware - Nonpermanent",
    },
    txcd_20020010: {
      description:
        "A labor charge to install hardware where the installed property is permanently attached to the real property.",
      name: "Installation of Hardware - Permanent",
    },
    txcd_20020018: {
      description:
        "A charge separately stated from any sale of the product itself for the installation of tangible personal property. This is a labor charge, with any non-separately stated property transferred in performing the service considered inconsequential.",
      name: "Installation of Tangible Personal Property",
    },
    txcd_20030002: {
      description:
        "Services provided by a facility for overnight care of an animal not related to veterinary care.",
      name: "Pet Boarding",
    },
    txcd_20030003: {
      description:
        "Grooming services for an animal such as haircuts, bathing, nail trimming, and flea dips.",
      name: "Pet Grooming",
    },
    txcd_20030004: {
      description: "A charge for providing usage of a parking space.",
      name: "Parking Services",
    },
    txcd_20030005: {
      description: "Service to train an animal to obey certain commands.",
      name: "Pet Services - Obedience Training",
    },
    txcd_20040001: {
      description:
        "Services provided by beauty shops and barber shops, including but not limited to haircutting, hair coloring, shampooing, blow drying, permanents, hair extensions, hair straightening, and hair restorations.",
      name: "Hairdressing Services",
    },
    txcd_20040002: {
      description:
        "A charge for personal care services.  Please select a more granular product tax category where appropriate.",
      name: "Personal Care Services",
    },
    txcd_20040003: {
      description:
        "A charge for the puncturing or penetration of the skin of a person and the insertion of jewelry or other adornment into the opening.",
      name: "Body Piercing",
    },
    txcd_20040004: {
      description:
        "Services that provide non-medical care and supervision for infant to school-age children or senior citizens.",
      name: "Childcare Services / Adultcare",
    },
    txcd_20040005: {
      description:
        "A service that arranges introductions, for a fee, for strangers seeking romantic partners or friends. This excludes online dating services.",
      name: "Dating Services",
    },
    txcd_20040006: {
      description:
        "Services provided by employment agencies to match employees to employers and employers to employees.",
      name: "Employment Services",
    },
    txcd_20040007: {
      description:
        "A charge for the cosmetic beauty treatment for the fingernails and toenails, including filing, cutting, shaping and the application of polish.",
      name: "Manicure Services",
    },
    txcd_20040008: {
      description:
        "Services where the use of structured touch, include holding, applying pressure, positioning, and mobilizing soft tissue of the body by manual technique. Note: This does not include medical massage prescribed by a physician.",
      name: "Massage Services",
    },
    txcd_20040009: {
      description:
        "Personal services typically with the purpose of improving health, beauty and relaxation through treatments such as hair, massages and facials.",
      name: "Spa Services",
    },
    txcd_20040010: {
      description: "Services for artificial tanning and skin beautification.",
      name: "Tanning Services",
    },
    txcd_20040011: {
      description:
        "A charge for the process that uses needles and colored ink to permanently put a mark or design on a person’s skin. Also applying permanent make-up, such as eyelining and other permanent colors to enhance the skin of the face, lips, eyelids, and eyebrows.",
      name: "Tattooing Services",
    },
    txcd_20060000: {
      description:
        "A charge for a service performed by providers considered professionals due to the extensive initial and continuing education and/or training requirements, and the likelihood of state or federal licensing requirements. Choose this product tax code for any professional service offering in which a more detailed code is not available.",
      name: "Professional Services",
    },
    txcd_20060001: {
      description:
        "The measurement, processing and communication of financial information about economic entities including, but is not limited to, financial accounting, management accounting, auditing, cost containment and auditing services, taxation and accounting information systems; excluding general bookkeeping service.",
      name: "Accounting Services",
    },
    txcd_20060002: {
      description:
        "Services rendered for advertising which do not include the exchange of tangible personal property.",
      name: "Advertising Services",
    },
    txcd_20060008: {
      description:
        "Services rendered for the compiling and relating of information regarding the history of financial transactions of a person or entity.",
      name: "Credit Reporting Services",
    },
    txcd_20060009: {
      description:
        'A service that allows data to be created, transformed, where the service is not performed online. Select "Website data processing" if the service is performed online and data is accessed by the customer electronically.',
      name: "Data Processing",
    },
    txcd_20060010: {
      description: "Services performed to collect or adjust past-due debt from borrowers.",
      name: "Debt Collection Services",
    },
    txcd_20060013: {
      description:
        "Services provided by a professional trained to apply physical laws and principles of engineering in the design, development, and utilization of machines, materials, instruments, structures, processes, and systems. The services involve any of the following activities: provision of advice, preparation of feasibility studies, preparation of preliminary and final plans and designs, provision of technical services during the construction or installation phase, inspection and evaluation of engineering projects, and related services.",
      name: "Engineering Services",
    },
    txcd_20060017: {
      description:
        "Charges for installing, configuring, debugging, modifying, testing, or troubleshooting computer hardware, networks, programs or software. Labor only charge.",
      name: "Technical Support Services",
    },
    txcd_20060021: {
      description:
        "Charges associated loss or damage appraisals, inspections, actuarial services, claims adjustment or processing.  Investigations as excluded from this definition.",
      name: "Insurance Services",
    },
    txcd_20060022: {
      description:
        "Planning and design of interior spaces, including preparation of layout drawings, furniture arranging, design planning and purchasing of furniture, fixtures, and cabinetry, staging, lighting and sound design.",
      name: "Interior Decorating",
    },
    txcd_20060026: {
      description:
        "Services relating to advocating for the passage or defeat of legislation to members or staff of the government.",
      name: "Lobbying Services",
    },
    txcd_20060027: {
      description:
        "Services provided by a licensed or registered professional in the medical field.  Examples: Doctor, dentist, nurse, optometrist, etc.",
      name: "Medical Professional Services",
    },
    txcd_20060029: {
      description:
        "Services to process employee payroll, including wages, withholding taxes, benefits. etc.",
      name: "Payroll Services",
    },
    txcd_20060030: {
      description:
        "Services providing a systematic inquiry, examination, or analysis of people, events or documents through surveillance, background checks, computer searches, fingerprinting, lie detector services, interviews, etc.",
      name: "Private Investigator Services",
    },
    txcd_20060035: {
      description:
        "Services which include, but are not limited to, editing, letter writing, proofreading, resume writing, typing or word processing. Doesn't include court reporting and stenographic services.",
      name: "Secretarial/Editing Services",
    },
    txcd_20060040: {
      description:
        "Charges to electronically file a tax return on behalf of the taxpayer.  This does not include manual preparation of tax returns.",
      name: "Electronic Filing Service",
    },
    txcd_20060042: {
      description:
        "Services relating to providing personnel, on a temporary basis, to perform work or labor under the supervision or control of another.",
      name: "Temporary Help Services",
    },
    txcd_20060044: {
      description:
        "A charge for training sessions which provide instruction to the buyer. This includes education sessions or workshops but excludes physical exercise or workouts.",
      name: "Training",
    },
    txcd_20060045: {
      description:
        "Live web based training. This does not include video replays of the instruction or course.  This service allows for a level of participation that is substantially similar to an in-person training on the same subject matter.",
      name: "Training Services - Live Virtual",
    },
    txcd_20060047: {
      description:
        "Services related to the art and science of designing and building structures for human habitation or use and includes planning, providing preliminary studies, designs, specifications, working drawings and providing for general administration of construction contracts.",
      name: "Architectural Services",
    },
    txcd_20060048: {
      description:
        "The provision of expertise or strategic advice that is presented for consideration and decision-making.",
      name: "Consulting Services",
    },
    txcd_20060049: {
      description:
        "Medical procedure performed on an individual that is directed at improving the individual's appearance and that does not meaningfully promote the proper function of the body or prevent or treat illness or disease.",
      name: "Cosmetic Medical Procedure",
    },
    txcd_20060050: {
      description:
        "Services to track one's credit reports and provide notifications of activity with the intent of avoiding fraud.",
      name: "Credit Monitoring Services",
    },
    txcd_20060051: {
      description:
        "A service that allows merchants to accept credit cards as well as send credit card payment details to the credit card network. It then forwards the payment authorization back to the acquiring bank.",
      name: "Credit Card Processing Services",
    },
    txcd_20060052: {
      description:
        "Academic classes provided by traditional private education establishments and organizations.",
      name: "Educational Services",
    },
    txcd_20060053: {
      description:
        "A charge for an objective visual examination of a house’s systems and physical structure. The charge includes a report of the inspector's findings including pictures, analysis, and recommendations.",
      name: "Home Inspection Services",
    },
    txcd_20060054: {
      description:
        "Services relating to or concerned with the law. Such services include, but are not limited to, representation by an attorney (or other person, when permitted) in an administrative or legal proceeding, legal drafting, paralegal services, legal research services, arbitration, mediation, and court reporting services.",
      name: "Legal Services",
    },
    txcd_20060055: {
      description:
        "Services for consumer research and testing in connection with the development of particular products or services that the client sells to consumers in the regular course of business.",
      name: "Marketing Services",
    },
    txcd_20060056: {
      description:
        "Services to provide outreach designed to influence the general public or other groups by promoting the interests of a service recipient.",
      name: "Public Relations",
    },
    txcd_20060057: {
      description:
        "Services that include typing, taking shorthand, and taking and transcribing dictation for others for a consideration.",
      name: "Stenographic Services",
    },
    txcd_20060058: {
      description:
        "Self Study web based training, not instructor led. This does not include downloads or streaming of video replays.",
      name: "Training Services - Self-study Web-based",
    },
    txcd_20060059: {
      description:
        "Personal or small group teaching, designed to help people who need extra help with their studies.",
      name: "Tutoring",
    },
    txcd_20070001: {
      description:
        "A charge for monitoring an electronically controlled alarm system for residential or commercial properties to minimize or prevent loss or damage to life, limb, or property.",
      name: "Security - Alarm Services",
    },
    txcd_20070006: {
      description:
        "A charge for services related to the eradication of insects, rodents, and other pests.",
      name: "Extermination Services",
    },
    txcd_20070007: {
      description: "A charge for services related to the maintenance of grounds.",
      name: "Landscaping",
    },
    txcd_20070008: {
      description:
        "A charge for services of general lawn and grounds maintenance, including lawn cutting, weeding, yard clean-up, shrub and tree trimming, periodic seeding or aeration, etc. This a labor charge, with any non-separately stated property transferred in performing the service considered inconsequential.",
      name: "Lawn Maintenance Services",
    },
    txcd_20070010: {
      description:
        "A charge for services related to the painting of surfaces or the application of wallpaper.",
      name: "Painting & Wallpapering Services",
    },
    txcd_20070013: {
      description:
        "Services related to protecting persons or their property, preventing the theft of goods, merchandise, or money. Responding to alarm signal device, burglar alarm, television camera, still camera, or a mechanical or electronic device installed or used to prevent or detect burglary, theft, shoplifting, pilferage, losses, or other security measures. Providing management and control of crowds for safety and protection.",
      name: "Security - Guard Services",
    },
    txcd_20070016: {
      description:
        "Services mapping, detecting or establishing the relative position of points at, above, or below the surface of the earth. These services may include surveying and mapping of areas above or below the surface of the earth, such as the creation of view easements or segregating rights in parcels of land by creating underground utility easements.",
      name: "Property Surveying Services",
    },
    txcd_20080003: {
      description:
        "A charge to repair or restore to operating condition a motor vehicle that was broken, worn, damaged, defective, or malfunctioning. This a labor charge, with any non-separately stated property transferred in performing the service considered inconsequential.",
      name: "Motor Vehicle Repair",
    },
    txcd_20080004: {
      description:
        "A charge to repair or restore footwear was broken, worn, damaged, defective, or malfunctioning. This a labor charge, with any non-separately stated property transferred in performing the service considered inconsequential.",
      name: "Shoe Repair",
    },
    txcd_20080005: {
      description:
        "A charge to repair or restore tangible personal property that was broken, worn, damaged, defective, or malfunctioning. This a labor charge, with any non-separately stated property transferred in performing the service considered inconsequential.",
      name: "Repair of Tangible Personal Property",
    },
    txcd_20080007: {
      description:
        "A charge to repair or maintain real property including repairs to HVAC, electrical, flooring, etc.",
      name: "Repairs to Real Property",
    },
    txcd_20080008: {
      description:
        "A charge to repair or restore to operating condition an aircraft that was broken, worn, damaged, defective, or malfunctioning. This a labor charge, with any non-separately stated property transferred in performing the service considered inconsequential. Commercial aircraft is excluded.",
      name: "Aircraft Repair",
    },
    txcd_20080009: {
      description:
        "A charge to repair or restore to operating condition an appliance (dishwasher, washing machine, refrigerator, etc.) that was broken, worn, damaged, defective, or malfunctioning. This a labor charge, with any non-separately stated property transferred in performing the service considered inconsequential.",
      name: "Appliance Repair",
    },
    txcd_20080010: {
      description:
        "A charge to repair or restore to operating condition computer hardware that was broken, worn, damaged, defective, or malfunctioning. This a labor charge, with any non-separately stated property transferred in performing the service considered inconsequential.",
      name: "Computer Repair",
    },
    txcd_20080011: {
      description:
        "A separately stated labor charge to cover a piece of furniture previously owned by the customer with new fabric coverings. Any materials transferred as part of the service are separately stated.",
      name: "Furniture Reupholstering",
    },
    txcd_20080012: {
      description:
        "A charge to repair or restore jewelry that was broken, worn, damaged, defective, or malfunctioning. This a labor charge, with any non-separately stated property transferred in performing the service considered inconsequential.",
      name: "Jewelry Repair",
    },
    txcd_20080013: {
      description:
        "A charge to repair or restore to operating condition a machine that was broken, worn, damaged, defective, or malfunctioning. This a labor charge, with any non-separately stated property transferred in performing the service considered inconsequential.",
      name: "Machine Repair",
    },
    txcd_20090001: {
      description:
        "A charge to perform an alteration on a item of clothing by the vendor of the article. The alteration is separately stated from the clothing, but contracted for at the time of the clothing purchase. Alterations could include hemming of a dress, shortening of pants, adjusting the waistline of a garment, etc.",
      name: "Garment Alterations - in conjunction with purchase of garment",
    },
    txcd_20090002: {
      description:
        "A charge to perform an alteration on a item of clothing by a service provider other than vendor of the article. The alteration is not linked to the clothing purchase. Alterations could include hemming of a dress, shortening of pants, adjusting the waistline of a garment, etc.",
      name: "Garment Alterations - separate from purchase of garment",
    },
    txcd_20090003: {
      description: "A charge to have files or documents shredded either onsite or offsite.",
      name: "Shredding Service",
    },
    txcd_20090004: {
      description:
        "A charge to a non-commercial customer for the cleaning or renovating clothing by immersion and agitation, spraying, vaporization, or immersion only, in a volatile, commercially moisture-free solvent or by the use of a volatile or inflammable product. This does not include the use of a self-service coin (or credit card) operated cleaning machine.",
      name: "Dry Cleaning",
    },
    txcd_20090006: {
      description:
        "A charge to create a finished good from materials supplied by the customer. This is a labor only charge to transform a customer's existing property.",
      name: "Fabrication",
    },
    txcd_20090010: {
      description:
        "A charge for the wrapping of articles in a box or bag with paper and other decorative additions. The charge is separately stated from the article.  This is not relevant for non-US countries where packaging is added to the price of the product.",
      name: "Gift Wrapping - in conjunction with purchase of article",
    },
    txcd_20090012: {
      description:
        "A charge to provide laundry services to clothing. The business customer is the owner of the items being cleaned.",
      name: "Linen Services - Laundry only",
    },
    txcd_20090015: {
      description:
        "A charge separately stated from the sale of the product itself that entitles the purchaser to future repair and labor services to return the defective item of tangible personal property to its original state. The warranty contract is mandatory and is required to be purchased on conjunction with the purchased tangible personal property. Motor vehicle warranties are excluded.",
      name: "Warranty - Mandatory",
    },
    txcd_20090018: {
      description:
        "A charge separately stated from the sale of the product itself that entitles the purchaser to future repair and labor services to return the defective item of tangible personal property to its original state. The warranty contract is optional to the purchaser. Motor vehicle warranties are excluded.",
      name: "Warranty - Optional",
    },
    txcd_20090022: {
      description:
        "A charge separately stated from the sale of the product itself to bring the article to its finished state and in the condition specified by the buyer.",
      name: "Assembly - in conjunction with final purchase of article",
    },
    txcd_20090023: {
      description:
        "A charge to assemble goods for a purchaser who will later sell the assembled goods to end consumers.",
      name: "Assembly - prior to final purchase of article",
    },
    txcd_20090024: {
      description:
        "A charge to a non-commercial customer for the cleaning or renovating items other than clothing by immersion and agitation, spraying, vaporization, or immersion only, in a volatile, commercially moisture-free solvent or by the use of a volatile or inflammable product. This does not include the use of a self-service coin (or credit card) operated cleaning machine.",
      name: "Dry Cleaning - other than clothing",
    },
    txcd_20090025: {
      description:
        "A charge for the wrapping of article(s) in a box or bag with paper and other decorative additions. The wrapping is not linked to the purchase of the article(s) and is performed by a party other than the vendor of the article(s).",
      name: "Gift Wrapping - separate from purchase of article",
    },
    txcd_20090026: {
      description:
        "A charge to provide laundry services to linens and the like. This charge is not for clothing items. The business customer is the owner of the items being cleaned.",
      name: "Linen Services - Laundry only - other than clothing",
    },
    txcd_20090027: {
      description:
        "A charge to make customer provided meat suitable for human consumption, typically referred to a butcher or slaughter services.",
      name: "Meat Processing",
    },
    txcd_20090028: {
      description:
        "A charge for the printing, imprinting, lithographing, mimeographing, photocopying, and similar reproductions of various articles including mailers, catalogs, letterhead, envelopes, business cards, presentation folders, forms, signage, etc. The end result is the transfer of tangible personal property to the customer.",
      name: "Printing",
    },
    txcd_20090029: {
      description:
        "A charge for the printing, imprinting, or lithographing on any article supplied by the customer. The customer owns the article throughout the process. This a labor charge, with any non-separately stated property transferred in performing the service considered inconsequential.",
      name: "Printing - customer supplied articles",
    },
    txcd_20090030: {
      description:
        "A charge to preserve an animal's body via mounting or stuffing, for the purpose of display or study. The customer provide the animal. This a labor charge, with any non-separately stated property transferred in performing the service considered inconsequential.",
      name: "Taxidermy Services",
    },
    txcd_20090031: {
      description:
        "A charge for engraving services performed on goods owned by the purchaser.  This is a standalone service not done in conjunction with the sale of the goods.",
      name: "Engraving Services -  separate from purchase of article",
    },
    txcd_20090032: {
      description:
        "A charge for engraving a good, such as jewelry, in conjunction with the retail purchase of that item. The charge for the engraving services is separately stated from the charge for the good being engraved.",
      name: "Engraving Services - in conjunction with purchase of article",
    },
    txcd_20091000: {
      description:
        "An agreement between a service contract provider and a customer where the service provider agrees to repair or replace certain parts on a motor vehicle that has had a failure after the original manufacturer’s warranty has expired. Commonly referred to as extended warranty or protection plan. Contract covers both parts and labor, and is made at the same time as Motor Vehicle purchase but is separately stated.",
      name: "Optional Extended Warranty Contract on Motor Vehicle",
    },
    txcd_20091001: {
      description:
        "An agreement between a service contract provider and a customer for prepaid routine maintenance (e.g. oil changes, tire rotations, air filter, spark plugs, transmission and transfer case fluid changes) for a motor vehicle. Contract covers both parts and labor and is made at the same time as Motor Vehicle purchase but is separately stated.",
      name: "Optional Maintenance Contract on Motor Vehicle",
    },
    txcd_20091002: {
      description:
        "An agreement between a service contract provider and a customer for prepaid routine maintenance (e.g. oil changes, tire rotations, air filter, spark plugs, transmission and transfer case fluid changes) of a leased motor vehicle. Contract covers both parts and labor.",
      name: "Optional Extended Warranty Contract on Leased Motor Vehicle",
    },
    txcd_20091003: {
      description:
        "An agreement between a service contract provider and a customer where the service provider agrees to repair or replace certain parts on a leased motor vehicle that has had a failure after the original manufacturer’s warranty has expired. Commonly referred to as extended warranty or protection plan. Contract covers both parts and labor.",
      name: "Optional Maintenance Contract on Leased Motor Vehicle",
    },
    txcd_20091004: {
      description:
        "An agreement between a service contract provider and a customer where the service provider agrees to repair or replace certain parts on a motor vehicle that has had a failure after the original manufacturer’s warranty has expired. Commonly referred to as extended warranty or protection plan. Contract covers both parts and labor and is made after the motor vehicle purchase.",
      name: "Optional Extended Warranty Contract on Motor Vehicle - After Market",
    },
    txcd_20091005: {
      description:
        "An agreement between a service contract provider and a customer for prepaid routine maintenance (e.g. oil changes, tire rotations, air filter, spark plugs, transmission and transfer case fluid changes) of a motor vehicle. Contract covers both parts and labor and is made after the motor vehicle purchase.",
      name: "Optional Maintenance Contract on Motor Vehicle - After Market",
    },
    txcd_20100001: {
      description:
        "Services under armed private security guard to transport from one place to another any currency, jewels, stocks, bonds, paintings, or other valuables of any kind in a specially equipped motor vehicle that offers a high degree of security.  It is assumed that the transport takes place within one country.",
      name: "Armored Car Services",
    },
    txcd_30011000: {
      description: "Apparel and footwear for people made for general use.",
      name: "Clothing & Footwear",
    },
    txcd_30011002: {
      description: "The clasp used to fasten a belt, sold separately from the belt.",
      name: "Belt Buckle",
    },
    txcd_30011003: {
      description:
        "A belt is band of flexible material worn around a person's waist for supporting clothing.  Suspenders are a pair of straps that pass over the shoulders and fasten to the waistband of a pair of trousers or a skirt at the front and back to hold it up.",
      name: "Belts or Suspenders",
    },
    txcd_30011015: {
      description:
        "A closed tube of fabric worn about the neck for warmth. It can be pulled over mouth and nose to protect against wind, dust, or other particles.",
      name: "Neck Gaiter",
    },
    txcd_30011020: {
      description:
        "A set of standardized clothes worn primarily during attendance at an educational institution.",
      name: "School Uniforms",
    },
    txcd_30011028: {
      description:
        "Clothing or footwear, such as coats, hats, ear muffs, gloves, etc. worn on the human body made of imitation fur materials.",
      name: "Fur Clothing - Synthetic",
    },
    txcd_30011034: {
      description:
        "A broad strip of cloth that covers the shoulders, neck, or head for warmth or appearance.",
      name: "Scarves",
    },
    txcd_30011045: {
      description:
        "A necktie, or simply a tie, is a piece of cloth worn by men and women for decorative purposes around the neck, resting under the shirt collar and knotted at the throat, and often draped down the chest.",
      name: "Neckties",
    },
    txcd_30011100: {
      description:
        "Clothing designed for, and not normally worn except while attending, a formal function, including tuxedos, bridal gowns, and evening gowns.",
      name: "Formal or Special Occasion Wear",
    },
    txcd_30011200: {
      description:
        "Children's clothing and footwear including general purpose articles intended to be worn by a person based on certain size or age requirements.",
      name: "Children's clothing and footwear",
    },
    txcd_30011201: {
      description:
        "Clothing or footwear, such as coats, hats, ear muffs, gloves, etc. worn on the human body made of the real pelt of an animal.",
      name: "Fur Clothing",
    },
    txcd_30021000: {
      description:
        "Clothing, footwear, and accessories worn on a person's body while participating in recreational or sporting activities, and which are not typical for everyday usage.  Please select a more granular product tax category where appropriate.",
      name: "Athletic Activity Clothing",
    },
    txcd_30021001: {
      description:
        "A band of absorbent material worn around the head or wrist to soak up sweat, especially by participants in physical activity.",
      name: "Sweat Bands",
    },
    txcd_30021200: {
      description:
        "Bathing suits, swim trunks, or bathing costumes meant to be worn in or near water.",
      name: "Swimsuits",
    },
    txcd_30030001: {
      description:
        "Clothing worn while performing an employment role, such as paramedic uniforms, firefighter uniforms, military uniforms, medical attire, law enforcement attire, etc.",
      name: "Occupational Uniforms",
    },
    txcd_30031004: {
      description:
        "Clothing and related covering material that is worn within cleanrooms, which require controlled low levels of environmental contaminants such as dusts, microbes, vapors, and aerosol particles.",
      name: "Cleanroom Apparel",
    },
    txcd_30031041: {
      description:
        "High-visibility warning clothing to signal the presence of the user in places and situations which may cause potential threats to their health and safety.",
      name: "Reflective Apparel",
    },
    txcd_30031404: {
      description:
        "Clothing for human wear and designed as protection of the wearer against injury or disease or as protections against damage or injury of other persons or property but not suitable for general use.",
      name: "Protective/Safety Clothing",
    },
    txcd_30031405: {
      description:
        "Clothing worn by an employee during the course of employment for protection against injury or disease or as protection against damage or injury of other persons or property.  Such clothing items are not suitable for general use.",
      name: "Protective/Safety Clothing - Occupational Use",
    },
    txcd_30031406: {
      description:
        "Footwear for human wear and designed as protection of the wearer against injury or disease or as protections against damage or injury of other persons or property but not suitable for general use.",
      name: "Protective/Safety Footwear",
    },
    txcd_30031407: {
      description:
        "Footwear worn by an employee during the course of employment for protection against injury or disease or as protection against damage or injury of other persons or property.  Such clothing items are not suitable for general use.",
      name: "Protective/Safety Footwear - Occupational Use",
    },
    txcd_30031408: {
      description:
        "Equipment type accessories (such as helmets, eyeshields, facemasks, pads, etc) for human wear and designed as protection of the wearer against injury or disease or as protections against damage or injury of other persons or property but not suitable for general use.",
      name: "Protective/Safety Equipment",
    },
    txcd_30031409: {
      description:
        "Equipment type accessories (such as helmets, eyeshields, facemasks, pads, etc) worn by an employee during the course of employment for protection against injury or disease or as protection against damage or injury of other persons or property.  Such clothing items are not suitable for general use.",
      name: "Protective/Safety Equipment - Occupational Use",
    },
    txcd_30040003: {
      description:
        "A reusable mask made of common fabrics worn over the mouth and nose to act as personal protection from airborne particles or pathogens.",
      name: "Cloth Face Masks",
    },
    txcd_30040005: {
      description:
        "Masks and accessories sold separately to be worn for costume purposes for seasonal or cultural holidays or celebrations.",
      name: "Costume Masks and Accessories",
    },
    txcd_30040006: {
      description:
        "Apparel worn by a person for seasonal or cultural holidays or celebrations, rather than for everyday wear.",
      name: "Costumes",
    },
    txcd_30051302: {
      description:
        "Gloves for general use (e.g. leather), but not gloves used for sporting (e.g., baseball, football gloves).",
      name: "Gloves (general use)",
    },
    txcd_30060001: {
      description:
        "Bags including handbags, purses, coin purses, fanny packs / bum bags, and diaper / nappy bags.",
      name: "Purses and Handbags",
    },
    txcd_30060004: {
      description:
        "A small usually square piece of cloth used for usually personal purposes (such as blowing the nose) or as a clothing accessory.",
      name: "Handkerchiefs",
    },
    txcd_30060005: {
      description: "Hair notions such as headbands, barrettes, bows, clips, and pins.",
      name: "Hair Accessories",
    },
    txcd_30060006: {
      description:
        "A shaped covering for the head worn for warmth, as a fashion item, or as part of a uniform.",
      name: "Hats",
    },
    txcd_30060007: {
      description: "Jewelry such as necklaces, earrings, rings, and more.",
      name: "Jewelry",
    },
    txcd_30060010: {
      description:
        "Articles, although worn on the body, which are not considered clothing or footwear.  Examples include armbands, pocket protectors, shoulder boards, sleep masks, etc.  Please select a more granular product tax category where appropriate.",
      name: "Non-Clothing Accessories",
    },
    txcd_30060011: {
      description: "A plastic cap worn in the shower to keep the hair dry.",
      name: "Shower Caps",
    },
    txcd_30060013: {
      description: "Umbrellas.",
      name: "Umbrellas",
    },
    txcd_30060014: {
      description: "Wigs, Hairpieces, Hair extensions.",
      name: "Wigs, Hairpieces, Hair extensions",
    },
    txcd_30060015: {
      description: "Suitcases and baggage typically used for transporting travellers' belongings.",
      name: "Luggage",
    },
    txcd_30060016: {
      description: "A small timepiece worn typically on a strap on one's wrist.",
      name: "Watches",
    },
    txcd_30060017: {
      description: "Sunglasses with a lens containing no lens powers to correct vision problems.",
      name: "Sunglasses - Non-prescription",
    },
    txcd_30060018: {
      description:
        "A digital wristwatch that provides many other features besides timekeeping. Like a smartphone, a smartwatch has a touchscreen display, which allows you to perform actions by tapping or swiping on the screen. Smartwatches include allow access to apps, similar to apps for smartphones and tablets.",
      name: "Watches - Smart",
    },
    txcd_30060019: {
      description:
        "A flat, rectangular case with a handle, often of leather, for carrying books, papers, etc.",
      name: "Briefcases",
    },
    txcd_30060020: {
      description:
        "A piece of clothing, such as a kitchen apron, that you wear over the front of other clothes to keep the clothes clean.",
      name: "Aprons",
    },
    txcd_30060021: {
      description:
        "A triangular or square piece of cloth tied around the head, face or neck for protective or decorative purposes.",
      name: "Bandannas",
    },
    txcd_30060101: {
      description:
        "A small folding case for carrying paper money, credit cards and other flat objects.",
      name: "Wallets",
    },
    txcd_30070001: {
      description: "A bicycle helmet that is NOT marketed and labeled as being intended for youth.",
      name: "Bicycle Helmets - Adult",
    },
    txcd_30070002: {
      description: "A bicycle helmet marketed and labeled as being intended for youth.",
      name: "Bicycle Helmets - Youth",
    },
    txcd_30070003: {
      description: "Footwear worn exclusively while participating in ballet or tap dancing.",
      name: "Ballet or Tap Shoes",
    },
    txcd_30070004: {
      description: "Gloves worn by baseball/softball participants while hitting.",
      name: "Baseball Batting Gloves",
    },
    txcd_30070005: {
      description:
        "Gloves worn while rolling a bowling ball to the support the muscles in the hand and wrist, and to provide extra padding or grip.",
      name: "Bowling Gloves",
    },
    txcd_30070006: {
      description:
        "Footwear uniquely designed to be worn while bowling, having a slick smooth sole meant for gliding.",
      name: "Bowling Shoes",
    },
    txcd_30070007: {
      description: "A heavily padded mitten worn in boxing.",
      name: "Boxing Gloves",
    },
    txcd_30070008: {
      description:
        "Athletic footwear having cleats or spikes to improve traction on various playing field surfaces.",
      name: "Cleated or Spiked Shoes",
    },
    txcd_30070009: {
      description:
        "Thin, lightweight gloves designed mainly for wide receivers in football to help with grip while catching.",
      name: "Football Receiver Gloves",
    },
    txcd_30070010: {
      description: "A glove worn by golfers to give a firm grip on the handle of the golf club.",
      name: "Golf Gloves",
    },
    txcd_30070011: {
      description:
        "Footwear designed for golf course play, usually spiked (featuring actual cleats on the outsole) or spikeless (featuring a flat outsole with rubber studs or dimples in place of spikes).",
      name: "Golf Shoes",
    },
    txcd_30070012: {
      description: "Ice Skates.",
      name: "Ice Skates",
    },
    txcd_30070013: {
      description:
        "A inflatable sleeveless jacket worn to keep a person afloat when in danger of drowning.",
      name: "Life Vests",
    },
    txcd_30070014: {
      description:
        "Clothing apparel/uniforms that are specific to the training and competition of various martial arts.",
      name: "Martial Arts Attire",
    },
    txcd_30070015: {
      description: "A helmet designed for used when operating a motorcycle, atv, snowmobile, etc.",
      name: "Motorcycle Helmets",
    },
    txcd_30070017: {
      description:
        "A protective device for the mouth that covers the teeth and gums to prevent and reduce injury to the teeth, arches, lips and gums.",
      name: "Mouth Guards",
    },
    txcd_30070018: {
      description: "Roller Skates or Roller Blades.",
      name: "Roller Skates or Roller Blades",
    },
    txcd_30070019: {
      description:
        "A stiff pad worn typically worn under socks to protect the shins when playing soccer, hockey, and other sports.",
      name: "Shin Guards",
    },
    txcd_30070020: {
      description:
        "A hard protective pad for the shoulders used in certain sports, such as ice hockey and football.",
      name: "Shoulder Pads for Sports",
    },
    txcd_30070021: {
      description:
        "A rigid padded shoe that extends above the ankle, is secured to the foot, and is locked into position in a ski binding.",
      name: "Ski Boots",
    },
    txcd_30070022: {
      description: "Athletic uniforms not containing protective padding or gear.",
      name: "Sport Uniforms",
    },
    txcd_30070023: {
      description:
        "Flippers on the foot or leg and made from rubber or plastic, to aid movement through the water in water sports.",
      name: "Swim Fins",
    },
    txcd_30070024: {
      description: "Goggles to protect the eyes from material in the water, while swimming.",
      name: "Swim Goggles",
    },
    txcd_30070025: {
      description:
        "A close-fitting garment  covering most of the body worn for warmth in water sports or diving.",
      name: "Wetsuit",
    },
    txcd_30070026: {
      description:
        "An elastic support for the male genitals, worn especially in athletic or other strenuous activity.",
      name: "Athletic Supporter",
    },
    txcd_30070028: {
      description:
        "Vests designed primarily for wear while hunting, but which are also adaptable to everyday use.",
      name: "Hunting Vests",
    },
    txcd_30070029: {
      description:
        "Clothing, footwear, and accessories for wear while hunting, but that are not adaptable to everyday use.",
      name: "Hunting Activity Clothing",
    },
    txcd_30071000: {
      description:
        "Protective gear worn about the human body while participating in athletic, recreational, or sporting activities, and which are not typical for everyday usage.   Please select a more granular product tax category where appropriate.",
      name: "Sports Activities Equipment",
    },
    txcd_30080001: {
      description:
        "Button covers are clothing accessories that slip over simple buttons for stylistic adornment.",
      name: "Button Covers",
    },
    txcd_30080002: {
      description:
        "Items  items used to make or repair clothing, including buttons, clasps, fabric, thread, yarn, snaps, hooks, zippers, sequins, fabric dye, and the like.",
      name: "Component Clothing Items",
    },
    txcd_30090005: {
      description: "Rubber boots worn over regular footwear to prevent them from wet or soiled.",
      name: "Overshoes",
    },
    txcd_30090009: {
      description: "Over the counter inserts or insoles for in-shoe foot comfort.",
      name: "Shoe Inserts",
    },
    txcd_30090010: {
      description: "Shoelaces.",
      name: "Shoelaces",
    },
    txcd_31020001: {
      description:
        "A piece of cloth or plastic fastened around a baby's neck to keep their clothes clean while eating.",
      name: "Bibs",
    },
    txcd_31020002: {
      description:
        "Blankets made to stretch to tightly around babies, and may have features like velcro or specially designed shapes or flaps to facilitate swaddle wrapping.",
      name: "Infant Swaddles",
    },
    txcd_31020003: {
      description: "A small lightweight blanket used to wrap an infant, eg. after bathing.",
      name: "Infant Receiving Blankets",
    },
    txcd_31030001: {
      description:
        'A skin cream forming a protective barrier to help heal and soothe diaper rash discomfort. These products contain a "drug facts" panel or a statement of active ingredients.',
      name: "Diaper Cream",
    },
    txcd_31030003: {
      description:
        'Non medicated disposable moistened cleansing wipes. These products do not contain a "drug facts" panel or a statement of active ingredients.',
      name: "Baby Wipes",
    },
    txcd_31031202: {
      description: "Disposable diapers for infants.",
      name: "Infant Diapers",
    },
    txcd_31031203: {
      description:
        "Absorbent single use underpants worn by children during potty training as a transition between diapers and cloth underwear.",
      name: "Disposable Toddler Training Pants",
    },
    txcd_31031204: {
      description: "One time use diaper liners for capturing solid waste for ease of disposal.",
      name: "Diaper Liners - Single Use",
    },
    txcd_31031205: {
      description: "Infant washable/reusable cloth diapers.",
      name: "Cloth Diapers",
    },
    txcd_31040001: {
      description: "A bottle with a teat or nipple made for babies to drink from.",
      name: "Baby Feeding Bottles/Nipples",
    },
    txcd_31040002: {
      description:
        "A mechanical device that lactating women use to extract milk from their breasts.",
      name: "Breast Pumps",
    },
    txcd_31070001: {
      description:
        "A portable seat that can be installed and removed from motor vehicles designed to protect infants and children through a certain age or weight (includes booster seats).",
      name: "Infant/Child Car Seat",
    },
    txcd_32010001: {
      description:
        "Devices used by diabetic individuals to monitor sugar levels in the blood, sold without prescription order of a licensed professional (e.g., blood sugar meters, glucose meters or glucometers).  This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Blood Glucose Monitoring Devices",
    },
    txcd_32010002: {
      description:
        "Single use supplies utilized by diabetics to monitor blood sugar or urine, including skin puncture lancets, test strips for blood glucose monitors, visual read test strips, and urine test strips, sold without prescription order of a licensed professional. This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Diabetic Testing Supplies",
    },
    txcd_32010003: {
      description:
        "Devices used by diabetic individuals to monitor sugar levels in the blood, sold under prescription order of a licensed professional (e.g., blood sugar meters, glucose meters or glucometers).  This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Blood Glucose Monitoring Devices with Prescription",
    },
    txcd_32010004: {
      description:
        "Single use supplies utilized by diabetics to monitor blood sugar or urine, including skin puncture lancets, test strips for blood glucose monitors, visual read test strips, and urine test strips, sold under prescription order of a licensed professional. This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Diabetic Testing Supplies with Prescription",
    },
    txcd_32020001: {
      description:
        "A substance that can only be obtained via a prescription of a licensed professional. A drug is a compound, substance, or preparation, and any component thereof, not including food or food ingredients, dietary supplements, or alcoholic beverages, that is: recognized in the official United States pharmacopoeia, official homeopathic pharmacopoeia of the United States, or official national formulary, and supplement to any of them; intended for use in the diagnosis, cure, mitigation, treatment, or prevention of disease; or intended to affect the structure or any function of the body. A drug can be intended for internal (ingestible, implant, injectable) or external (topical) application to the human body.  This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Prescription Drugs",
    },
    txcd_32020002: {
      description:
        'The term drug refers to a compound, substance or preparation intended for use in the diagnosis, cure, mitigation, treatment, or prevention of disease. An over-the-counter drug is a substance that contains a label identifying it as a drug and including a "drug facts" panel or a statement of active ingredients, that can be obtained without a prescription. A drug can be intended for internal (ingestible, implant, injectable) or external (topical) application to the human body.',
      name: "Drugs - Over the Counter",
    },
    txcd_32020003: {
      description:
        'The term drug refers to a compound, substance or preparation intended for use in the diagnosis, cure, mitigation, treatment, or prevention of disease. An over-the-counter drug with prescription is a substance that contains a label identifying it as a drug and including a "drug facts" panel or a statement of active ingredients, that can be obtained without a prescription, but is sold under prescription order of a licensed professional. A drug can be intended for internal (ingestible, implant, injectable) or external (topical) application to the human body. This code is intended for sales directly to end consumers that are NOT healthcare providers.',
      name: "Over-the-Counter Drugs with Prescription",
    },
    txcd_32020004: {
      description:
        "Synthetic or animal-based insulin used as an injectable drug for diabetes patients, sold under prescription order of a licensed professional.  This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Insulin with Prescription",
    },
    txcd_32020005: {
      description:
        "Synthetic or animal-based insulin used as an injectable drug for diabetes patients, sold without prescription order of a licensed professional.  This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Insulin",
    },
    txcd_32020006: {
      description:
        "Medical grade oxygen sold under prescription order of a licensed professional.  This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Medical Oxygen with Prescription",
    },
    txcd_32020011: {
      description:
        "Medical grade oxygen sold without prescription order of a licensed professional.  This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Medical Oxygen",
    },
    txcd_32030001: {
      description:
        "Male or female condoms used to prevent pregnancy or exposure to sexually transmitted diseases.",
      name: "Condoms",
    },
    txcd_32030002: {
      description:
        "Male or female condoms and vaginal sponges used to prevent pregnancy and/or exposure to STDs, sold under prescription order of a licensed professional.",
      name: "Condoms with Prescription",
    },
    txcd_32030003: {
      description:
        'Male or female condoms used to prevent pregnancy or exposure to STDs, containing a spermicidal lubricant as indicated by a "drug facts" panel or a statement of active ingredients.',
      name: "Condoms with Spermicide",
    },
    txcd_32030004: {
      description:
        'Male or female condoms and vaginal sponges used to prevent pregnancy and/or exposure to STDs, containing a spermicidal lubricant as indicated by a "drug facts" panel or a statement of active ingredients, sold under prescription order of a licensed professional.',
      name: "Condoms with Spermicide with Prescription",
    },
    txcd_32030005: {
      description:
        'A topical preparation containing a spermicidal lubricant to prevent pregnancy as indicated by a "drug facts" panel or a statement of active ingredients.',
      name: "Contraceptive Ointments",
    },
    txcd_32030006: {
      description:
        "Over-the-Counter emergency contraceptive pills act to prevent pregnancy after intercourse. The contraceptive contains a hormone that prevents ovulation, fertilization, or implantation of an embryo.",
      name: "Birth Control - Over-the-Counter Oral Contraceptives",
    },
    txcd_32030007: {
      description:
        "Over-the-Counter emergency contraceptive pills act to prevent pregnancy after intercourse, sold under prescription order of a licensed professional. The contraceptive contains a hormone that prevents ovulation, fertilization, or implantation of an embryo.",
      name: "Birth Control - Over-the-Counter Oral Contraceptives with Prescription",
    },
    txcd_32030008: {
      description:
        "Barrier based prescription only birth control methods, including the diaphragm and cervical cap that prevent the joining of the sperm and egg, available only under prescription order of a licensed professional.",
      name: "Birth Control - Prescription non-Oral Contraceptives - Barriers",
    },
    txcd_32030009: {
      description:
        "Hormonal based birth control methods other than the oral pill, including intrauterine devices, injections, skin implants, transdermal patches, and vaginal rings that release a continuous dose of hormones to eliminate ovulation and prevent pregnancy, available only under prescription order of a licensed professional.",
      name: "Birth Control - Prescription non-Oral Contraceptives - Hormonal",
    },
    txcd_32030010: {
      description:
        "An oral medication containing hormones effective in altering the menstrual cycle to eliminate ovulation and prevent pregnancy, available only under prescription order of a licensed professional. Other than preventing pregnancy, hormonal birth control can also be used to treat various conditions, such as Polycystic Ovary Syndrome, Endometriosis, Primary Ovarian Insufficiency, etc.",
      name: "Birth Control - Prescription Oral Contraceptives",
    },
    txcd_32040002: {
      description: "Vaginal cleaning products include douches and wipes.",
      name: "Feminine Cleansing Solutions",
    },
    txcd_32040003: {
      description:
        'Vaginal cleaning products include douches and wipes with medication such as an antiseptic, containing a "drug facts" panel or a statement of active ingredients.',
      name: "Feminine Cleansing Solutions - Medicated",
    },
    txcd_32040004: {
      description:
        'Over-the-counter antifungal creams, ointments or suppositories to treat yeast infections, containing a "drug facts" panel or a statement of active ingredients.',
      name: "Feminine Yeast Treatments",
    },
    txcd_32040005: {
      description: "Feminine hygiene product designed to absorb the menstrual flow.",
      name: "Tampons/Pads/Sanitary Napkins/Liners",
    },
    txcd_32050001: {
      description: "Adult Disposable Diapers.",
      name: "Adult Disposable Diapers",
    },
    txcd_32050005: {
      description:
        "Masks designed for one-time use to protect the wearer from contamination of breathable particles. This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Disposable Face Masks",
    },
    txcd_32050006: {
      description:
        "Soaps, cleaning solutions, shampoo, toothpaste, mouthwash, antiperspirants, suntan lotions, etc.  Please select a more granular category as appropriate.",
      name: "Grooming and Hygiene Products",
    },
    txcd_32050007: {
      description:
        "Soaps, cleaning solutions, shampoo, toothpaste, mouthwash, antiperspirants, suntan lotions, and sunscreens that contain medicinal ingredients as described on the product's label.  Please select a more granular category as appropriate.",
      name: "Grooming and Hygiene Products - Medicated",
    },
    txcd_32050009: {
      description:
        'A liquid, gel, foam, or wipe generally used to decrease infectious agents on the hands. Alcohol-based versions typically contain some combination of isopropyl alcohol, ethanol (ethyl alcohol), or n-propanol. Alcohol-free products are generally based on disinfectants, or on antimicrobial agents. These products contain a "drug facts" panel or a statement of active ingredients. This code is intended for sales directly to end consumers that are NOT healthcare providers.',
      name: "Hand Sanitizers",
    },
    txcd_32050012: {
      description:
        'Topical medicated solutions for treating skin acne.  These products contain a "drug facts" panel or a statement of active ingredients.  This code is intended for sales directly to end consumers that are NOT healthcare providers.',
      name: "Medicated Acne Treatments",
    },
    txcd_32050013: {
      description:
        'Lotions, moisturizers, creams, powders, sprays, etc that promote optimal skin health that do not contain a "drug facts" panel or a statement of active ingredients.',
      name: "Skin Care Products",
    },
    txcd_32050014: {
      description:
        'Lotions, moisturizers, creams, powders, sprays, etc that promote optimal skin health and contain a "drug facts" panel or a statement of active ingredients.',
      name: "Skin Care Products - Medicated",
    },
    txcd_32050015: {
      description:
        'Over-the-counter nicotine replacement products, including patches, gum, lozenges, sprays and inhalers that contain a "drug facts" panel or a statement of active ingredients.',
      name: "Smoking Cessation Products",
    },
    txcd_32050017: {
      description: "Toilet tissue or paper primarily used for the removal of feces.",
      name: "Toilet Tissue",
    },
    txcd_32050018: {
      description: "A small brush with a long handle, used for cleaning the teeth.",
      name: "Toothbrush",
    },
    txcd_32050019: {
      description: "A thick, soft, moist substance used on a brush for cleaning one's teeth.",
      name: "Toothpaste",
    },
    txcd_32050020: {
      description:
        'Baby oil is an inert (typically mineral) oil for the purpose of keeping skin soft and supple.  These products do not contain a "drug facts" panel or a statement of active ingredients.',
      name: "Baby Oil",
    },
    txcd_32050021: {
      description:
        'Baby powder is an astringent powder used for preventing diaper rash, as a spray, and for other cosmetic uses. It may be composed of talcum (in which case it is also called talcum powder) or corn starch. These products do not contain a "drug facts" panel or a statement of active ingredients.',
      name: "Baby Powder",
    },
    txcd_32050022: {
      description:
        'Breath spray is a product sprayed into the mouth and breath strips dissolve in the mouth for the purpose of eliminating halitosis. These products do not contain a "drug facts" panel or a statement of active ingredients.',
      name: "Breath Spray/Dissolvable Strips",
    },
    txcd_32050023: {
      description:
        'Various surfactant preparations to improve cleaning, enhance the enjoyment of bathing, and serve as a vehicle for cosmetic agents. These products do not contain a "drug facts" panel or a statement of active ingredients.',
      name: "Bubble Bath/Bath Salts,Oils,Crystals",
    },
    txcd_32050024: {
      description:
        'A hair care product typically applied and rinsed after shampooing that is used to improve the feel, appearance and manageability of hair. These products do not contain a "drug facts" panel or a statement of active ingredients.',
      name: "Conditioner - Hair",
    },
    txcd_32050025: {
      description:
        "Articles intended to be rubbed, poured, sprinkled, or sprayed on, introduced into, or otherwise applied to the human body or any part thereof for beautifying, promoting attractiveness, or altering the appearance. This category supports only the following items: Acrylic fingernail glue, Acrylic fingernails, Artificial eyelashes, Blush, Bronzer, Body glitter, Concealer, Eyelash glue, Finger/toenail decorations, Finger/toenail polish, Nail polish remover, Hair coloring, Hair mousse/gel, Hair oil, Hair spray, Hair relaxer, Hair wave treatment, Hair wax, Lip gloss, Lip liner, Lipstick, Liquid foundation, Makeup, Mascara, Nail polish remover, Powder foundation, Cologne, Perfume.",
      name: "Cosmetics - Beautifying",
    },
    txcd_32050026: {
      description:
        "A soft, strong, waxed or unwaxed thread for drawing between the teeth to remove food particles and prevent the buildup of plaque.",
      name: "Dental Floss/Picks",
    },
    txcd_32050027: {
      description:
        'Denture adhesives are pastes, powders or adhesive pads that may be placed in/on dentures to help them stay in place. These products do not contain a "drug facts" panel or a statement of active ingredients.',
      name: "Denture Creams/Adhesives",
    },
    txcd_32050028: {
      description:
        'Personal under-arm deodorants/antiperspirants containing natural ingredients and/or ingredients that are not considered drugs. These products do not contain a "drug facts" panel or a statement of active ingredients.',
      name: "Deodorant - Natural or No Active Ingredients",
    },
    txcd_32050029: {
      description:
        'Personal under-arm deodorants/antiperspirants. These products do contain a "drug facts" panel or a statement of active ingredients, typically aluminum.',
      name: "Deodorant/Antiperspirant",
    },
    txcd_32050030: {
      description:
        'Topical foams, creams, gels, etc. that prevent hair loss and promote hair regrowth. These products contain a "drug facts" panel or a statement of active ingredients.',
      name: "Hair Loss Products",
    },
    txcd_32050031: {
      description:
        'Depilatories are cosmetic preparations used to remove hair from the skin. Chemical depilatories are available in gel, cream, lotion, aerosol, roll-on, and powder forms. These products do not contain a "drug facts" panel or a statement of active ingredients.',
      name: "Hair Removal Products",
    },
    txcd_32050032: {
      description:
        'A skin protectant for the lips. These products do not contain a "drug facts" panel or a statement of active ingredients.',
      name: "Lip Balm",
    },
    txcd_32050033: {
      description:
        'A medicated skin protectant for the lips. These products contain a "drug facts" panel or a statement of active ingredients.',
      name: "Lip Balm - Medicated",
    },
    txcd_32050034: {
      description:
        'Cosmetic mouthwash may temporarily control bad breath and leave behind a pleasant taste, but has no chemical or biological application beyond their temporary benefit. These products do not contain a "drug facts" panel or a statement of active ingredients.',
      name: "Mouthwash - Cosmetic",
    },
    txcd_32050035: {
      description:
        'Therapeutic mouthwash, having active ingredients (such as antiseptic, or flouride) intended to help control or reduce conditions like bad breath, gingivitis, plaque, and tooth decay. These products contain a "drug facts" panel or a statement of active ingredients.',
      name: "Mouthwash - Therapeutic",
    },
    txcd_32050036: {
      description:
        'A hair care product for cleansing the hair/scalp. These products do not contain a "drug facts" panel or a statement of active ingredients.',
      name: "Shampoo",
    },
    txcd_32050037: {
      description:
        'A hair care product for cleansing the hair/scalp, with anti-dandruff active ingredients. These products contain a "drug facts" panel or a statement of active ingredients.',
      name: "Shampoo - Medicated",
    },
    txcd_32050038: {
      description:
        'A cosmetic foam or gel used for shaving preparation. The purpose of shaving cream is to soften the hair by providing lubrication.  These products do not contain a "drug facts" panel or a statement of active ingredients.',
      name: "Shaving Creams",
    },
    txcd_32050039: {
      description:
        'Soaps, body washes, shower gels for personal hygiene containing antibacterial. These products contain a "drug facts" panel or a statement of active ingredients.',
      name: "Soaps - Antibacterial",
    },
    txcd_32050040: {
      description:
        'A lotion, spray, gel, foam, stick or other topical product that absorbs or reflects some of the sun\'s ultraviolet (UV) radiation and thus helps protect against sunburn. Sunscreen contains a "drug facts" label or statement of active ingredients.',
      name: "Sunscreen",
    },
    txcd_32050041: {
      description:
        'Teeth whitening gels, rinse, strips, trays, etc containing bleaching agents. These products do not contain a "drug facts" panel or a statement of active ingredients.',
      name: "Teeth Whitening Kits",
    },
    txcd_32060001: {
      description:
        "When sold without prescription order of a licensed professional, equipment that: can withstand repeated use; is primarily and customarily used to serve a medical purpose; generally is not useful to a person in the absence of illness or injury; and is not worn in or on the body. Home use means the equipment is sold to an individual for use at home, regardless of where the individual resides. Examples include hospital beds, commode chairs, bed pans, IV poles, etc.",
      name: "Durable Medical Equipment for Home Use",
    },
    txcd_32060002: {
      description:
        "When sold under prescription order of a licensed professional, equipment that: can withstand repeated use; is primarily and customarily used to serve a medical purpose; generally is not useful to a person in the absence of illness or injury; and is not worn in or on the body. Home use means the equipment is sold to an individual for use at home, regardless of where the individual resides. Examples include hospital beds, commode chairs, bed pans, IV poles, etc.",
      name: "Durable Medical Equipment for Home Use with Prescription",
    },
    txcd_32060007: {
      description:
        "When sold under prescription order of a licensed professional, nutritional tube feeding equipment including button-style feeding tubes, standard G-tubes, NG-tubes, extension sets, adapters, feeding pumps, feeding pump delivery sets.",
      name: "Enteral Feeding Equipment for Home Use with Prescription",
    },
    txcd_32060012: {
      description:
        "When sold under prescription order of a licensed professional, a machine used that filters a patient's blood to remove excess water and waste products when the kidneys are damaged, dysfunctional, or missing. The kidney dialysis machine is an artificial part which augments the natural functioning of the kidneys.",
      name: "Kidney Dialysis Equipment for Home Use with Prescription",
    },
    txcd_32060017: {
      description:
        "When sold without prescription order of a licensed professional, a machine used that filters a patient's blood to remove excess water and waste products when the kidneys are damaged, dysfunctional, or missing. The kidney dialysis machine is an artificial part which augments the natural functioning of the kidneys.",
      name: "Kidney Dialysis Equipment for Home Use",
    },
    txcd_32060018: {
      description:
        "When sold under prescription order of a licensed professional, equipment used to administer oxygen directly into the lungs of the patient for the relief of conditions in which the human body experiences an abnormal deficiency or inadequate supply of oxygen. Oxygen equipment means oxygen cylinders, cylinder transport devices, including sheaths and carts, cylinder studs and support devices, regulators, flowmeters, tank wrenches, oxygen concentrators, liquid oxygen base dispensers, liquid oxygen portable dispensers, oxygen tubing, nasal cannulas, face masks, oxygen humidifiers, and oxygen fittings and accessories.",
      name: "Oxygen Delivery Equipment for Home Use with Prescription",
    },
    txcd_32060023: {
      description:
        "When sold without prescription order of a licensed professional, equipment used to administer oxygen directly into the lungs of the patient for the relief of conditions in which the human body experiences an abnormal deficiency or inadequate supply of oxygen. Oxygen equipment means oxygen cylinders, cylinder transport devices, including sheaths and carts, cylinder studs and support devices, regulators, flowmeters, tank wrenches, oxygen concentrators, liquid oxygen base dispensers, liquid oxygen portable dispensers, oxygen tubing, nasal cannulas, face masks, oxygen humidifiers, and oxygen fittings and accessories.",
      name: "Oxygen Delivery Equipment for Home Use",
    },
    txcd_32060024: {
      description:
        "A heating pad is a pad used for warming of parts of the body in order to manage pain. Types of heating pads include electrical, chemical and hot water bottles. This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Heating Pads",
    },
    txcd_32060025: {
      description:
        "A reusable pain management supply that includes artificial ice packs, gel packs, heat wraps, etc used for pain relief.  This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Cold or Hot Therapy Packs - Reusable",
    },
    txcd_32060026: {
      description:
        "When sold without prescription order of a licensed professional, nutritional tube feeding equipment including button-style feeding tubes, standard G-tubes, NG-tubes, extension sets, adapters, feeding pumps, feeding pump delivery sets.",
      name: "Enteral Feeding Equipment for Home Use",
    },
    txcd_32070003: {
      description:
        "An item that is applied directly to or inside a wound to absorb wound drainage, protect healing tissue, maintain a moist or dry wound environment (as appropriate), or prevent bacterial contamination. Examples include bandages, dressings, gauze, medical tape. This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Wound Care Supplies - Bandages, Dressings, Gauze",
    },
    txcd_32070004: {
      description:
        'A wound care supply is defined as an item that is applied directly to or inside a wound to absorb wound drainage, protect healing tissue, maintain a moist or dry wound environment (as appropriate), or prevent bacterial contamination.  These supplies contain medication such as an antibiotic ointment. They are a labeled with a "drug facts" panel or a statement of active ingredients.Examples include bandages, dressings, gauze, medical tape. This code is intended for sales directly to end consumers that are NOT healthcare providers.',
      name: "Wound Care Supplies - Bandages, Dressings, Gauze - Medicated",
    },
    txcd_32070018: {
      description:
        "A collection of mixed supplies and equipment that is used to give medical treatment, often housed in durable plastic boxes, fabric pouches or in wall mounted cabinets. Qualifying medicinal items (eg. OTC drugs) make up 51% or more of the value of the kit. This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "First Aid Kits",
    },
    txcd_32070019: {
      description:
        "Single use disposable gloves (latex, nitrile, vinyl, etc) not used for medical purposes.",
      name: "Gloves - Disposable (non medical use)",
    },
    txcd_32070020: {
      description:
        "Single use disposable gloves (latex, nitrile, vinyl, etc) that have an application in a first aid or medical setting. This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Gloves - Disposable (medical use)",
    },
    txcd_32070028: {
      description:
        "Items for use in cure, treatment or diagnosis of injury, illness, disease or incapacity, and which is consumed during the use.  Please select a more granular category as appropriate.",
      name: "Medical Supplies - Consumable",
    },
    txcd_32070029: {
      description:
        "A collection of mixed supplies and equipment that is used to give medical treatment, often housed in durable plastic boxes, fabric pouches or in wall mounted cabinets. Qualifying medicinal items (eg. OTC drugs) make up 50% or less of the value of the kit. This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "First Aid Kits - 50% or Less Medicinal Items",
    },
    txcd_32070030: {
      description: "Liquid solution for cleaning and disinfecting contact lenses.",
      name: "Contact Lens Disinfecting Solutions",
    },
    txcd_32070031: {
      description:
        "Liquid solution for lubricating/rewetting, but not disinfecting, contact lenses. This solution is applied directly to the eye.",
      name: "Contact Lens Lubricating Solutions",
    },
    txcd_32070032: {
      description:
        "Single use cotton balls or swabs for application of antiseptics and medications and to cleanse scratches, cuts or minor wounds. This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Cotton Balls/Swabs - Sterile",
    },
    txcd_32070033: {
      description:
        "Single use cotton balls or swabs for multi-purpose use other than applying medicines and cleaning wounds, due to not being sterile. This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Cotton Balls/Swabs - Unsterile",
    },
    txcd_32070034: {
      description:
        "A single use pain management supply that includes artificial ice packs, gel packs, heat wraps, etc used for pain relief. This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Cold or Hot Therapy Packs - Disposable",
    },
    txcd_32070035: {
      description:
        'A single use pain management supply that includes artificial ice packs, gel packs, heat wraps, etc used for pain relief.   These products contain a "drug facts" panel or a statement of active ingredients.  This code is intended for sales directly to end consumers that are NOT healthcare providers.',
      name: "Cold or Hot Therapy Packs - Disposable - Medicated",
    },
    txcd_32070036: {
      description:
        "Flexible adhesive strips that attach over the bridge of the nose to lift the sides of the nose, opening the nasal passages to provide relief for congestion and snoring. The products are drug free and contain no active drug ingredients.",
      name: "Nasal Breathing Strips",
    },
    txcd_32070037: {
      description:
        "Single use hollow needle commonly used with a syringe to inject insulin into the body by diabetic individuals, sold under prescription order of a licensed professional.  This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Hypodermic Needles/Syringes with Prescription - Insulin",
    },
    txcd_32070038: {
      description:
        "Single use hollow needle commonly used with a syringe to inject insulin into the body by diabetic individuals, sold without prescription order of a licensed professional.  This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Hypodermic Needles/Syringes - Insulin",
    },
    txcd_32070039: {
      description:
        'Hydrogen peroxide is a mild antiseptic used on the skin to prevent infection of minor cuts, scrapes, and burns. It may also be used as a mouth rinse to help remove mucus or to relieve minor mouth irritation (e.g., due to canker/cold sores, gingivitis). These products contain a "drug facts" panel or a statement of active ingredients. This code is intended for sales directly to end consumers that are NOT healthcare providers.',
      name: "Hydrogen Peroxide",
    },
    txcd_32070040: {
      description:
        'A multi-purpose skin protectant and topical ointment. These products contain a "drug facts" panel or a statement of active ingredients. This code is intended for sales directly to end consumers that are NOT healthcare providers.',
      name: "Petroleum Jelly",
    },
    txcd_32070041: {
      description:
        'Liquid drops to be placed inside the ear canal to reduce the symptoms of an ear ache, or to act as an ear drying aid, or to loosen, cleanse, and aid in the removal of ear wax. These products contain a "drug facts" panel or a statement of active ingredients. Examples include Ear Ache, Swimmers\' Ears, and Ear Wax removal drops. This code is intended for sales directly to end consumers that are NOT healthcare providers.',
      name: "Ear Drops - Medicated",
    },
    txcd_32070042: {
      description:
        'A liquid solution typically used as a topical antiseptic. The products contain a "drug facts" panel or a statement of active ingredients. This code is intended for sales directly to end consumers that are NOT healthcare providers.',
      name: "Isopropyl (Rubbing) Alcohol",
    },
    txcd_32080001: {
      description:
        "Aids that can increase, improve, or assist mobility in the bathroom such as raised toilet seat, tub & shower stool, handrails, grab bars, etc.",
      name: "Bath Aids",
    },
    txcd_32080003: {
      description:
        "Equipment which is primarily and customarily used to provide or increase the ability to move from one place to another, sold without a prescription, and which is appropriate for use either in a home or a motor vehicle; Is not generally used by persons with normal mobility; and does not include any motor vehicle or equipment on a motor vehicle normally provided by a motor vehicle manufacturer. Examples include wheelchairs, crutches, canes, walkers, chair lifts, etc.",
      name: "Mobility Enhancing Equipment",
    },
    txcd_32080004: {
      description: "Parts for items such as crutch pads, walker tips, cane tips, crutch tips, etc.",
      name: "Repair & Replacement Parts for Mobility Enhancing Equipment",
    },
    txcd_32080005: {
      description:
        "Equipment which is primarily and customarily used to provide or increase the ability to move from one place to another, sold under a prescription, and which is appropriate for use either in a home or a motor vehicle; Is not generally used by persons with normal mobility; and does not include any motor vehicle or equipment on a motor vehicle normally provided by a motor vehicle manufacturer. Examples include wheelchairs, crutches, canes, walkers, chair lifts, etc.",
      name: "Mobility Enhancing Equipment with Prescription",
    },
    txcd_32090003: {
      description:
        "Corrective lenses, including eyeglasses and contact lenses, sold without a prescription order of a licensed professional. This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Corrective Lenses",
    },
    txcd_32090005: {
      description:
        "Batteries specifically labeled and designed to operate hearing aid devices, sold without prescription order of a licensed professional. This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Hearing Aid Batteries",
    },
    txcd_32090006: {
      description:
        "Artificial devices to correct or alleviate hearing deficiencies, sold without prescription order of a licensed professional. This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Hearing Aids",
    },
    txcd_32090007: {
      description:
        "When sold without prescription order of a licensed professional, a replacement, corrective, or supportive device, worn on or in the body to: Artificially replace a missing portion of the body; Prevent or correct physical deformity or malfunction; or Support a weak or deformed portion of the body. Worn in or on the body means that the item is implanted or attached so that it becomes part of the body, or is carried by the body and does not hinder the mobility of the individual. Examples include artificial limbs, pacemakers, orthotics, orthopedics, ostomy/colostomy devices, catheters, etc.",
      name: "Prosthetic Device",
    },
    txcd_32090008: {
      description:
        "When sold under prescription order of a licensed professional, a replacement, corrective, or supportive device, worn on or in the body to: Artificially replace a missing portion of the body; Prevent or correct physical deformity or malfunction; or Support a weak or deformed portion of the body. Worn in or on the body means that the item is implanted or attached so that it becomes part of the body, or is carried by the body and does not hinder the mobility of the individual. Examples include artificial limbs, pacemakers, orthotics, orthopedics, ostomy/colostomy devices, catheters, etc.",
      name: "Prosthetic Devices with Prescription",
    },
    txcd_32090013: {
      description:
        "Corrective lenses, eyeglasses, sold under prescription order of a licensed professional.  This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Corrective Lenses with Prescription",
    },
    txcd_32090014: {
      description:
        "Contact lenses, sold under prescription order of a licensed professional. This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Contact Lenses with Prescription",
    },
    txcd_32090015: {
      description:
        "When sold under prescription order of a licensed professional, a replacement, corrective, or supportive device, worn in the mouth, including dentures, orthodontics, crowns, bridges, etc.",
      name: "Dental Prosthetics with Prescription",
    },
    txcd_32090016: {
      description:
        "When sold without prescription order of a licensed professional, a replacement, corrective, or supportive device, worn in the mouth, including dentures, orthodontics, crowns, bridges, etc.",
      name: "Dental Prosthetics",
    },
    txcd_32090017: {
      description:
        "Artificial devices to correct or alleviate hearing deficiencies, sold under prescription order of a licensed professional. This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Hearing Aids with Prescription",
    },
    txcd_32090018: {
      description:
        "Batteries specifically labeled and designed to operate hearing aid devices, sold under prescription order of a licensed professional. This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Hearing Aid Batteries with Prescription",
    },
    txcd_32100001: {
      description: "At home urine-based tests used to detect pregnancy hormone levels.",
      name: "Pregnancy Testing Kits",
    },
    txcd_32100002: {
      description:
        "At home urine-based tests used to detect impending ovulation to assist in pregnancy planning.",
      name: "Ovulation Testing Kits",
    },
    txcd_32100003: {
      description:
        "An at-home infectious disease test kit that can be sold without a prescription.",
      name: "Infectious Disease Test",
    },
    txcd_32100004: {
      description:
        "An at-home infectious disease test kit that can only be sold with a prescription.",
      name: "Infectious Disease Test - Prescription only",
    },
    txcd_32100005: {
      description:
        "At home saliva, cheek swab or blood drop based tests used to detect various genetic markers in an individual.",
      name: "DNA Testing Kits",
    },
    txcd_32100006: {
      description:
        "One-time use medical thermometers for oral, temporal/forehead, or rectal body temperature diagnostics. This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Medical Thermometers - Disposable",
    },
    txcd_32100007: {
      description:
        "Multiple use medical thermometers for oral, temporal/forehead, or rectal body temperature diagnostics. This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Medical Thermometers - Reusable",
    },
    txcd_32100008: {
      description:
        "Products carrying an Energy Star rating (e.g., light bulbs, appliances, etc.).  Please select a more granular product tax category where appropriate.",
      name: "Energy Star Products",
    },
    txcd_32100010: {
      description:
        "At home digital or manual (aneroid) sphygmomanometers, also known as a blood pressure meter, blood pressure monitor, or blood pressure gauge, are devices used to measure blood pressure, composed of an inflatable cuff to collapse and then release the artery under the cuff in a controlled manner.  This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Blood Pressure Testing Devices",
    },
    txcd_32100011: {
      description:
        "An electronic device that clips onto a patient's finger to measure heart rate and oxygen saturation in his or her red blood cells.  This code is intended for sales directly to end consumers that are NOT healthcare providers.",
      name: "Pulse Oximeter",
    },
    txcd_32100012: {
      description:
        "At home urine-based tests used to detect the presence of various drug substances in an individual.",
      name: "Drug Testing Kits",
    },
    txcd_32100013: {
      description:
        "At home blood-prick based tests used to monitor cholesterol levels in an individual.",
      name: "Cholesterol Testing Kits",
    },
    txcd_33020001: {
      description: "Ceiling Fans carrying an Energy Star rating.",
      name: "Ceiling Fans - Energy Star",
    },
    txcd_33020002: {
      description:
        "Domestic air conditioning (central or room) systems carrying Energy Star rating.",
      name: "Air conditioners - Energy Star",
    },
    txcd_33020003: {
      description: "Domestic gas or oil furnaces carrying an Energy Star rating.",
      name: "Furnaces - Energy Star",
    },
    txcd_33020004: {
      description: "Domestic air source heat pumps carrying Energy Star rating.",
      name: "Heat Pumps - Energy Star",
    },
    txcd_33020005: {
      description: "Domestic water heater carrying Energy Star rating.",
      name: "Water Heater - Energy Star",
    },
    txcd_33020006: {
      description:
        "Domestic appliance carrying an Energy Star Rating which reduces and maintains the level of humidity in the air.",
      name: "Dehumidifier - Energy Star",
    },
    txcd_33020007: {
      description:
        "Domestic gas or oil boilers for space or water heating carrying an Energy Star rating.",
      name: "Boilers - Energy Star",
    },
    txcd_33020008: {
      description:
        "An in home programmable thermostat, such as a WiFi enabled smart thermostat, carrying an Energy Star rating.",
      name: "Programmable Wall Thermostat - Energy Star",
    },
    txcd_33020009: {
      description: "Domestic standard size refrigerators carrying Energy Star rating.",
      name: "Refrigerators - Energy Star",
    },
    txcd_33020010: {
      description: "Domestic dish washing appliances carrying Energy Star rating.",
      name: "Dishwashers - Energy Star",
    },
    txcd_33020011: {
      description: "Domestic freezers carrying Energy Star rating.",
      name: "Freezers- Energy Star",
    },
    txcd_33020012: {
      description: "Domestic clothes washing appliances carrying Energy Star rating.",
      name: "Clothes Washing Machine - Energy Star",
    },
    txcd_33020013: {
      description: "Domestic clothes drying appliances carrying Energy Star rating.",
      name: "Clothes Drying Machine - Energy Star",
    },
    txcd_33020014: {
      description: "Non-electric can opener.",
      name: "Can Opener - Manual",
    },
    txcd_33020200: {
      description:
        "Water conserving products are for conserving or retaining groundwater; recharging water tables; or decreasing ambient air temperature, and so limiting water evaporation. Examples include soil surfactants, a soaker or drip-irrigation hose, a moisture control for a sprinkler or irrigation system, a rain barrel or an alternative rain and moisture collection system, a permeable ground cover surface that allows water to reach underground basins, aquifers,  or water collection points. These products are intended for use at a residential property.",
      name: "Water Efficient Products - Residential",
    },
    txcd_33030001: {
      description:
        "Single or multi-pack AA, AAA, c, D, 6-volt or 9-volt batteries, excluding automobile or boat batteries.",
      name: "Alkaline Batteries",
    },
    txcd_33031001: {
      description: "Mobile phone batteries.",
      name: "Mobile Phone Batteries",
    },
    txcd_33080201: {
      description:
        "Wipes used in the process of eliminating or reducing harmful microorganisms from inanimate objects and surfaces.",
      name: "Disinfectant Wipes",
    },
    txcd_33080202: {
      description:
        "Paper based items for household use designed to be disposed of after single use, including the the following...Facial tissue; Paper bags; Paper freezer wrap; Paper place mats; Paper plates and cups; Paper napkins; Paper straws; Paper tablecloths; Paper towels.",
      name: "Disposable Household Paper Products",
    },
    txcd_33080300: {
      description:
        "Includes blankets, pillows, bed linens/sheets, comforters, towels, wash cloths, shower curtains and bath mats.  Please select a more granular category where appropriate.",
      name: "Household Linens/Bedding Towels Shower Curtains",
    },
    txcd_33080301: {
      description:
        "Bedclothes items including sheets, pillow cases, bedspreads, comforters, blankets, throws, duvet covers, pillow shams, bed skirts, mattress pad, mattress toppers, and pillows.",
      name: "Bedding",
    },
    txcd_33080302: {
      description: "A small mat/rug used to cover portion of bathroom floor.",
      name: "Bath Mats/Rugs",
    },
    txcd_33080303: {
      description:
        "Towels used for individual drying of persons, including bath towels, beach towels, wash cloths, hand towels, face towels, sport towels, etc.",
      name: "Bath Towels",
    },
    txcd_33080304: {
      description: "Shower curtain/liner used to keep water from escaping a showering area.",
      name: "Shower Curtain or Liner",
    },
    txcd_33080305: {
      description:
        "A bumper/liner that borders the interior walls/slats of the crib to help protect the baby.",
      name: "Crib Bumpers/Liners",
    },
    txcd_33080306: {
      description: "Dish towels used for kitchenware drying.",
      name: "Dish Towels",
    },
    txcd_33080400: {
      description: "Yarn for use other than fabricating/repairing clothing.",
      name: "Yarn - Non-clothing",
    },
    txcd_33100001: {
      description: "Landscape soil, mulch, compost - residential.",
      name: "Landscape Soil, Mulch, Compost - Residential",
    },
    txcd_33100101: {
      description:
        "Products for use in non-commercial food producing gardens to control insects, weeds, and fungus.",
      name: "Agricultural Chemicals - Non-commercial gardening",
    },
    txcd_33100200: {
      description:
        "Products for use in non-commercial food producing gardens to enhance plant growth.",
      name: "Agricultural Fertilizer - Non-commercial gardening",
    },
    txcd_33110001: {
      description: "Standard incandescent light bulbs carrying an Energy Star rating.",
      name: "Incandescent Light Bulbs - Energy Star",
    },
    txcd_33110002: {
      description: "Compact Fluorescent light (CFL) bulbs carrying an Energy Star rating.",
      name: "Compact Fluorescent Light Bulbs - Energy Star",
    },
    txcd_33110003: {
      description: "Light emitting diode (LED) bulbs carrying an Energy Star rating.",
      name: "LED Bulbs - Energy Star",
    },
    txcd_33110004: {
      description:
        "Portable self-powered or battery powered light sources, including flashlights, lanterns, emergency glow sticks or light sticks.",
      name: "Portable Light Sources",
    },
    txcd_33110005: {
      description: "Candles to be used as a light source.",
      name: "Candles",
    },
    txcd_33120000: {
      description:
        "Qualifying items for purposes of certain sales tax holidays such as cell phone batteries, cell phone chargers, and two-way radios.",
      name: "Storm Preparedness Items",
    },
    txcd_33120001: {
      description:
        "Portable self-powered or battery powered radio, two-way radio, weather band radio.",
      name: "Portable Radios",
    },
    txcd_33120002: {
      description: "Non-electric food or beverage cooler.",
      name: "Food Storage Cooler",
    },
    txcd_33120003: {
      description: "Smoke Detectors.",
      name: "Smoke Detectors",
    },
    txcd_33120004: {
      description: "Carbon Monoxide Detectors.",
      name: "Carbon Monoxide Detectors",
    },
    txcd_33120005: {
      description: "Fire Extinguishers.",
      name: "Fire Extinguishers",
    },
    txcd_33120006: {
      description: "Portable fuel container.",
      name: "Portable Fuel Container",
    },
    txcd_33120007: {
      description: "Non-electric water container to store water for emergency usage.",
      name: "Water Storage Container",
    },
    txcd_33120008: {
      description: "Artificial ice, blue ice, ice packs, reusable ice.",
      name: "Artificial Ice",
    },
    txcd_33120009: {
      description: "Tarps, plastic sheeting, plastic drop cloths, waterproof sheeting.",
      name: "Tarpaulins and Weatherproof Sheeting",
    },
    txcd_33120010: {
      description:
        "Portable generator used to provide light or communications or power appliances during a power outage.",
      name: "Portable Generator",
    },
    txcd_33120011: {
      description: "Power cords used to connect electrical equipment and devices to power sockets.",
      name: "Power Cords",
    },
    txcd_33120012: {
      description:
        "An hand held tool with a bladed head on a handle used for hewing, cleaving, chopping, etc.",
      name: "Axes/Hatchets",
    },
    txcd_33120013: {
      description: "Gas-powered chainsaw.",
      name: "Garden Chainsaw",
    },
    txcd_33120014: {
      description:
        "Chainsaw accessories include chains, lubricants, motor oil, chain sharpeners, bars, wrenches, carrying cases, repair parts, safety apparel.",
      name: "Chainsaw Accessories",
    },
    txcd_33120015: {
      description:
        "Plywood, window film, storm shutters, hurricane shutters or other materials specifically designed to protect windows.",
      name: "Storm Shutters/Window Protection Devices",
    },
    txcd_33120016: {
      description: "Ladder used for home emergency evacuation.",
      name: "Emergency/Rescue Ladder",
    },
    txcd_33120017: {
      description: "Ropes and Cords and similar fastening products.",
      name: "Ropes and Cords",
    },
    txcd_33120018: {
      description:
        "Ground anchor systems and tie down kits for securing property against severe weather.",
      name: "Ground Anchor Systems and Tie-down Kits",
    },
    txcd_33120019: {
      description: "Duct Tape.",
      name: "Duct Tape",
    },
    txcd_33150001: {
      description: "WaterSense labeled toilets.",
      name: "Toilets - WaterSense",
    },
    txcd_33150002: {
      description: "WaterSense labeled urinals.",
      name: "Urinals - WaterSense",
    },
    txcd_33150003: {
      description: "WaterSense labeled bathroom sink faucets and accessories.",
      name: "Bathroom Faucets - WaterSense",
    },
    txcd_33150004: {
      description:
        "WaterSense labeled sprinkler body is the exterior shell that connects to the irrigation system piping and houses the spray nozzle that applies water on the landscape.",
      name: "Spray Water Sprinkler Bodies - WaterSense",
    },
    txcd_33150005: {
      description:
        "WaterSense labeled irrigation controllers, which act like a thermostat for your sprinkler system telling it when to turn on and off, use local weather and landscape conditions to tailor watering schedules to actual conditions on the site.",
      name: "Irrigation Controls - WaterSense",
    },
    txcd_33150006: {
      description: "WaterSense labeled showerheads.",
      name: "Showerheads - WaterSense",
    },
    txcd_34010001: {
      description: "A type of consumer electronic device used to play vinyl recordings.",
      name: "Audio Turntables",
    },
    txcd_34010002: {
      description:
        "Portable audio equipment that plays audio files encoded in MP3 and other audio formats.",
      name: "Digital Music Players",
    },
    txcd_34010003: {
      description:
        "A camera that captures moving images and sound and converts them into electronic signals so that they can be saved on a storage device, such as videotape or a hard drive, or viewed on a monitor.",
      name: "Video Cameras",
    },
    txcd_34020001: {
      description: "A camera that captures photographs in digital memory.",
      name: "Digital Cameras",
    },
    txcd_34020002: {
      description:
        "A framed display designed to display preloaded digital images (jpeg or any digital image format). Has slots for flash memory cards and/or an interface for digital photo camera connection.",
      name: "Digital Picture Frames",
    },
    txcd_34020003: {
      description: "A portable electronic device for reading digital books and periodicals.",
      name: "E-Book Readers",
    },
    txcd_34020004: {
      description: "Wired and bluetooth headphones and earbuds for audio listening.",
      name: "Headphones/Earbuds",
    },
    txcd_34020005: {
      description:
        "Consumer electronics peripherals and accessories.  Please select a more granular product tax category where appropriate.",
      name: "Consumer Electronics Peripherals/Accessories",
    },
    txcd_34020006: {
      description: "Televisions.",
      name: "Televisions",
    },
    txcd_34020027: {
      description:
        "Electronic devices bought for personal rather than commercial use.  Please select a more granular product tax category where appropriate.",
      name: "Consumer Electronics",
    },
    txcd_34021000: {
      description:
        "A portable device for connecting to a telecommunications network in order to transmit and receive voice, video, or other data.",
      name: "Mobile Phones",
    },
    txcd_34021001: {
      description:
        "A device for recharging the battery of a mobile phone, especially one consisting of a cable connected to an adaptor which plugs into an electrical socket or usb port.",
      name: "Mobile Phone Charging Device/cord",
    },
    txcd_34022000: {
      description:
        "A specialized computer system designed for interactive video gameplay that typically connects to a television or other monitor.",
      name: "Video Gaming Console - Fixed",
    },
    txcd_34022001: {
      description:
        "A handheld portable electronic device used for playing video games that has its own screen, speakers and controls in one unit.",
      name: "Video Gaming Console - Portable",
    },
    txcd_34040001: {
      description: "Typically a lithium-ion remote power source for laptop computers.",
      name: "Computer Batteries",
    },
    txcd_34040002: {
      description:
        "Cables with industry standard connection and termination configurations used to connect various peripherals and equipment to computers.",
      name: "Computer Cables",
    },
    txcd_34040003: {
      description: "Storage drives, hard drives, Zip drives, etc.",
      name: "Computer Drives",
    },
    txcd_34040004: {
      description: "Computer Keyboards.",
      name: "Computer Keyboards",
    },
    txcd_34040005: {
      description: "Computer Microphones.",
      name: "Computer Microphones",
    },
    txcd_34040006: {
      description: "Computer Monitor/Displays.",
      name: "Computer Monitor/Displays",
    },
    txcd_34040007: {
      description: "Computer Mouse/Pointing Devices.",
      name: "Computer Mouse/Pointing Devices",
    },
    txcd_34040008: {
      description: "Computer Printer.",
      name: "Computer Printer",
    },
    txcd_34040009: {
      description: "Computer Speakers.",
      name: "Computer Speakers",
    },
    txcd_34040010: {
      description:
        "A docking station is a hardware frame and set of electrical connection interfaces that enable a notebook computer to effectively serve as a desktop computer.",
      name: "Docking Stations",
    },
    txcd_34040011: {
      description:
        "A device that makes possible the transmission of data to or from a computer via telephone or other communication lines.",
      name: "Modems",
    },
    txcd_34040012: {
      description:
        "A motherboard is the physical component in a computer that contains the computer's basic circuitry and other components.",
      name: "Motherboards",
    },
    txcd_34040013: {
      description:
        "A port replicator is an attachment for a notebook computer that allows a number of devices such as a printer, large monitor, and keyboard to be simultaneously connected.",
      name: "Port Replicators",
    },
    txcd_34040014: {
      description:
        "A device that connects computer networks to each other, and sends information between networks.  The router, as commonly used in the home, is the hardware that allows communication between your personal computers and other connected device and the internet.",
      name: "Routers",
    },
    txcd_34040015: {
      description:
        "A device that scans documents and images and converts them into digital data for use on a computer.",
      name: "Scanners",
    },
    txcd_34040016: {
      description:
        "A sound card is an expansion component used in computers to receive and send audio.",
      name: "Sound Cards",
    },
    txcd_34040017: {
      description:
        "An expansion card that allows the computer to send graphical information to a video display device such as a monitor, TV, or projector. Video cards are often used by gamers in place of integrated graphics due to their extra processing power and video ram.",
      name: "Video/Graphics Card",
    },
    txcd_34040018: {
      description:
        "A webcam is a video camera that feeds or streams an image or video in real time to or through a computer to a computer network, such as the Internet. Webcams are typically small cameras that sit on a desk, attach to a user's monitor, or are built into the hardware.",
      name: "Web Camera",
    },
    txcd_35010000: {
      description:
        "Books or booklets consisting of text or illustrations bound in a stiffer cover than the pages.",
      name: "Books",
    },
    txcd_35010001: {
      description:
        "Children's books including picture books, painting, drawing, and activity books.",
      name: "Books for Children",
    },
    txcd_35010400: {
      description: "Printed religious books and manuals.",
      name: "Religious Books",
    },
    txcd_35010410: {
      description: "The sacred writings of a religion.",
      name: "Bibles",
    },
    txcd_35010500: {
      description:
        'Recognized in the ordinary and usual sense as a "book", except that the product is audio and delivered electronically or on a CD/DVD instead of in a printed format.',
      name: "Audiobook (Physical Copy)",
    },
    txcd_35020100: {
      description:
        "Publications distributed to the public at regular intervals that contains news of general interest.",
      name: "Newspapers",
    },
    txcd_35020200: {
      description: "Publications, including magazines, distributed on a periodic basis.",
      name: "Periodicals",
    },
    txcd_35020220: {
      description: "Periodicals, printed, sold by subscription.",
      name: "Magazine by Subscription",
    },
    txcd_36010001: {
      description:
        "Flea and tick products for animal use including soaps, cleaning solutions, and shampoos (e.g., flea collars, flea powder, tick and flea soap, and tick sprays).",
      name: "Flea & Tick Products",
    },
    txcd_36010002: {
      description:
        "Drugs or substance for treating animals and intended for use in the diagnosis, cure, mitigation, treatment, or prevention of disease.",
      name: "Over-the-Counter Drugs for Animal Use Without a Prescription",
    },
    txcd_36010003: {
      description:
        "Medical supplies available without a prescription and used in the treatment of companion animals (e.g., first aid items such as bandages and gauze).",
      name: "Over-the-Counter Medical Supplies for Pets",
    },
    txcd_36010004: {
      description:
        "Food for household pets that is consumed for nutritional value. This code is not intended for food related to working farm animals or animals raised for meat or milk production.",
      name: "Pet Food",
    },
    txcd_36010005: {
      description: "Pet food products offering additional nutrients or functional ingredients.",
      name: "Pet Vitamins",
    },
    txcd_36010006: {
      description:
        "Substances for treating animals, sold under prescription of a licensed veterinarian, and intended for use in the diagnosis, cure, mitigation, treatment, or prevention of disease.",
      name: "Drugs for Animal Use with Prescription",
    },
    txcd_36010007: {
      description:
        "Food for household pets that is consumed for nutritional value and sold under prescription of licensed veterinarian. This code is not intended for food related to working farm animals or animals raised for meat or milk production.",
      name: "Pet Food with Prescription",
    },
    txcd_37010000: {
      description: "Personal computers, including laptops, tablets, desktops.",
      name: "Personal Computers",
    },
    txcd_37010003: {
      description:
        "Removable storage media such as compact disks, flash drives, thumb drives, flash memory cards.",
      name: "Computer Storage Media",
    },
    txcd_37010036: {
      description: "Ink cartridges for printers.",
      name: "Printer Ink",
    },
    txcd_37030002: {
      description:
        "A globe that could be used by a student in a course of study as a reference and to learn the subject being taught.",
      name: "Globes - Student",
    },
    txcd_37030003: {
      description:
        "A map that could be used by a student in a course of study as a reference and to learn the subject being taught.",
      name: "Maps - Student",
    },
    txcd_37040001: {
      description: "Paper suitable for printers.",
      name: "Printer Paper",
    },
    txcd_37050001: {
      description:
        "Books that are required or approved for use in conjunction with a curriculum provided by an educational institution.",
      name: "School Textbooks",
    },
    txcd_37060001: {
      description:
        "Bags designed to carry students' books during the school day. This category does not include backpacks for traveling, hiking, camping, etc.",
      name: "Bookbags/Backpacks - Student",
    },
    txcd_37060002: {
      description:
        "Typically a small electronic device with a keyboard and visual display used for making used for making mathematical calculations.",
      name: "Calculators",
    },
    txcd_37060003: {
      description:
        "A calendar based notebook to aid in outlining one's daily appointments, classes, activities, etc.",
      name: "Daily Planners",
    },
    txcd_37060008: {
      description:
        "Portable locks used by students in a school setting to prevent use, theft, vandalism or harm.",
      name: "Padlocks - Student",
    },
    txcd_37060009: {
      description:
        "An item commonly used by a student in a course of study for artwork.  This category is limited to the following items...clay and glazes, paints, paintbrushes for artwork, sketch and drawing pads, watercolors.",
      name: "School Art Supplies",
    },
    txcd_37060010: {
      description:
        "Reference printed material commonly used by a student in a course of study as a reference and to learn the subject being taught.",
      name: "Dictionaries/Thesauruses",
    },
    txcd_37060011: {
      description: "Sheet music used by a student in conjunction with school activities.",
      name: "Sheet music - Student",
    },
    txcd_37060012: {
      description:
        "An item commonly used by a student in a course of study. This category is limited to the following items...binders, blackboard chalk, cellophane tape, compasses, composition books, crayons, erasers, folders, glue/paste/glue sticks, highlighters, index cards, index card boxes, legal pads, lunch boxes, markers, notebooks, paper (copy, graph, tracing, manila, colored, construction, notebook), pencils, pencil boxes, pencil sharpeners, pens, poster boards, protractors, rulers, scissors, writing tablets.",
      name: "School Supplies",
    },
    txcd_37060013: {
      description:
        "A device that joins pages of paper or similar material by fastening a thin metal staple through the sheets and folding the ends underneath.",
      name: "Staplers/Staples",
    },
    txcd_37060035: {
      description:
        "Pins/tacks to secure papers, pictures, calendars, etc. to bulletin boards, walls, etc.",
      name: "Push pins/tacks",
    },
    txcd_37060045: {
      description:
        "A handheld computer that is capable of plotting graphs, solving simultaneous equations, and performing other tasks with variables.",
      name: "Graphing Calculators",
    },
    txcd_37060046: {
      description: "A musical instrument used by a student in conjunction with school activities.",
      name: "Musical instruments - Student",
    },
    txcd_37070001: {
      description: 'Prewritten ("canned") software delivered on tangible media.',
      name: "Canned Software - Tangible Medium",
    },
    txcd_37070002: {
      description:
        'Prewritten ("canned") software on tangible media used for non-recreational purposes, such as antivirus, database, educational, financial, word processing, etc. The software is intended for personal use, rather than for consumption in a commercial enterprise. Note: The distinction between business use and personal use for this tax code is relevant only if you are transacting business in the US.',
      name: "Canned Software - Tangible Medium - Non-recreational",
    },
    txcd_37071001: {
      description:
        "A charge, apart from the charge for the software, for an agreement that is not required to be purchased in order to obtain the software.  The agreement entitles the software user to obtain periodic canned software updates, upgrades, and error corrections in electronic form.",
      name: "Software Maintenance Agreement - Optional, Prewritten, Electronic Delivery, Updates Only",
    },
    txcd_37071002: {
      description:
        "A charge, apart from the charge for the software, for an agreement that is not required to be purchased in order to obtain the software.  The agreement entitles the software user to obtain periodic canned software updates, upgrades, and error corrections in electronic form, as well as non-separately stated support services, such as consultation or phone support.",
      name: "Software Maintenance Agreement - Optional, Prewritten, Electronic Delivery, Updates and Services",
    },
    txcd_37071003: {
      description:
        "A charge, apart from the charge for the software, for an agreement that is not required to be purchased in order to obtain the software.  The agreement entitles the software user to only support services, such as consultation or phone support.  The agreements does not include periodic canned software updates, upgrades, or error corrections in any form.",
      name: "Software Maintenance Agreement - Optional, Prewritten, Services Only",
    },
    txcd_37071006: {
      description:
        "A charge, apart from the charge for the software, for an agreement that is not required to be purchased in order to obtain the software.  The agreement entitles the software user to obtain periodic canned software updates, upgrades, and error corrections in tangible form.",
      name: "Software Maintenance Agreement - Optional, Prewritten, Tangible Delivery, Updates Only",
    },
    txcd_37071007: {
      description:
        "A charge, apart from the charge for the software, for an agreement that is not required to be purchased in order to obtain the software.  The agreement entitles the software user to obtain periodic canned software updates, upgrades, and error corrections in tangible form, as well as non-separately stated support services, such as consultation or phone support.",
      name: "Software Maintenance Agreement - Optional, Prewritten, Tangible Delivery, Updates and Services",
    },
    txcd_37071009: {
      description:
        "A charge, apart from the charge for the software, for an agreement that is not required to be purchased in order to obtain the software.  The agreement entitles the software user to obtain, from the original seller of the software, periodic custom software updates, upgrades, and error corrections in electronic form.",
      name: "Software Maintenance Agreement - Optional, Custom, Electronic Delivery, Updates Only",
    },
    txcd_37071010: {
      description:
        "A charge, apart from the charge for the software, for an agreement that is not required to be purchased in order to obtain the software.  The agreement entitles the software user to obtain, from the original seller of the software, periodic custom software updates, upgrades, and error corrections in electronic form, as well as non-separately stated support services, such as consultation or phone support.",
      name: "Software Maintenance Agreement - Optional, Custom, Electronic Delivery, Updates and Services",
    },
    txcd_37071011: {
      description:
        "A charge, apart from the charge for the software, for an agreement that is not required to be purchased in order to obtain the software.  The agreement entitles the software user to only support services, such as consultation or phone support.  The agreements does not include periodic custom software updates, upgrades, or error corrections in any form.",
      name: "Software Maintenance Agreement - Optional, Custom, Services Only",
    },
    txcd_37071014: {
      description:
        "A charge, apart from the charge for the software, for an agreement that is not required to be purchased in order to obtain the software.  The agreement entitles the software user to obtain, from the original seller of the software, periodic custom software updates, upgrades, and error corrections in tangible form.",
      name: "Software Maintenance Agreement - Optional, Custom, Tangible Delivery, Updates Only",
    },
    txcd_37071015: {
      description:
        "A charge, apart from the charge for the software, for an agreement that is not required to be purchased in order to obtain the software.  The agreement entitles the software user to obtain, from the original seller of the software, periodic custom software updates, upgrades, and error corrections in tangible form, as well as non-separately stated support services, such as consultation or phone support.",
      name: "Software Maintenance Agreement - Optional, Custom, Tangible Delivery, Updates and Services",
    },
    txcd_37071101: {
      description:
        "A charge, apart from the charge for the software, for an agreement that is required to be purchased in order to obtain the software.  The agreement entitles the software user to obtain periodic canned software updates, upgrades, and error corrections in electronic form.  The agreement may or may not also include non-separately stated support services, such as consultation or phone support.",
      name: "Software Maintenance Agreement - Mandatory, Prewritten, Electronic Delivery",
    },
    txcd_37071103: {
      description:
        "A charge, apart from the charge for the software, for an agreement that is required to be purchased in order to obtain the software.  The agreement entitles the software user to obtain periodic canned software updates, upgrades, and error corrections in tangible form.  The agreement may or may not also include non-separately stated support services, such as consultation or phone support.",
      name: "Software Maintenance Agreement - Mandatory, Prewritten, Tangible Delivery",
    },
    txcd_37071104: {
      description:
        "A charge, apart from the charge for the software, for an agreement that is required to be purchased in order to obtain the software.  The agreement entitles the software user to obtain periodic custom software updates, upgrades, and error corrections in electronic form.  The agreement may or may not also include non-separately stated support services, such as consultation or phone support.",
      name: "Software Maintenance Agreement - Mandatory, Custom, Electronic Delivery",
    },
    txcd_37071106: {
      description:
        "A charge, apart from the charge for the software, for an agreement that is required to be purchased in order to obtain the software.  The agreement entitles the software user to obtain periodic custom software updates, upgrades, and error corrections in tangible form.  The agreement may or may not also include non-separately stated support services, such as consultation or phone support.",
      name: "Software Maintenance Agreement - Mandatory, Custom, Tangible Delivery",
    },
    txcd_40010000: {
      description:
        "Grain, as an important staple food, is the harvested seed of grasses such as wheat, oats, rice, corn, sorghum, millet, rye, and barley.",
      name: "Cereal Grains",
    },
    txcd_40010001: {
      description:
        "A dough of flour, eggs, and water made in different shapes and dried or used fresh.",
      name: "Pasta",
    },
    txcd_40010002: {
      description: "The starchy grain of ceral grass used as a staple food.",
      name: "Rice",
    },
    txcd_40020002: {
      description: "Cooking oils such as olive oil, vegetable oil, corn oil, etc.",
      name: "Edible Oils",
    },
    txcd_40020004: {
      description:
        "A sweet substance especially from the plants sugar cane and sugar beet, used to make food and drinks sweet.  This category also supports artificial sugars such as saccharine, aspartame, sucralose, etc.",
      name: "Sugar and Sugar Substitutes",
    },
    txcd_40020005: {
      description:
        "Flour is a white or brown powder that is made by grinding grain, used chiefly in baking.",
      name: "Flour",
    },
    txcd_40020006: {
      description:
        "A type of plant whose leaves are used in cooking to give flavor to particular dishes, such as basil, oregano, and cilantro, etc.",
      name: "Herbs",
    },
    txcd_40020007: {
      description: "Seasonings such as salt, pepper, paprika, chili powder, etc.",
      name: "Seasonings",
    },
    txcd_40020008: {
      description:
        "Any edible dye, pigment, or substance that imparts color when it is added to food or drink.",
      name: "Food Coloring",
    },
    txcd_40040000: {
      description:
        "Food and beverage products sold at retail grocery-type establishments that are intended for consumption off the premises of the vendor.",
      name: "Food for Non-Immediate Consumption",
    },
    txcd_40040003: {
      description:
        "A dark brown powder made from cocoa beans, used to add a chocolate flavor to beverages, as in hot chocolate.",
      name: "Cocoa Mix",
    },
    txcd_40040004: {
      description: "Foods and formulas meant for feeding babies and infants.",
      name: "Baby Food",
    },
    txcd_40040009: {
      description:
        "A dark brown powder made from cocoa beans, used to make chocolate and add a chocolate flavor to the baking process.",
      name: "Baking Cocoa",
    },
    txcd_40040010: {
      description: "Ice for human consumption.",
      name: "Ice Cubes",
    },
    txcd_40040013: {
      description: "The flesh (muscle tissue) of an animal consumed as food.",
      name: "Meat and Meat Products",
    },
    txcd_40040016: {
      description: "Nuts and seeds in unroasted, unsalted, unflavored form.",
      name: "Nuts and Seeds",
    },
    txcd_40040017: {
      description: "Nuts and seeds that have been salted, spiced, smoked, or roasted.",
      name: "Nuts and Seeds, Processed",
    },
    txcd_40040019: {
      description: "Vegetables are parts of plants that are consumed as food.",
      name: "Vegetables",
    },
    txcd_40040020: {
      description:
        "Cracker bread is a thin and crispy flat bread that is often used as an accompaniment to meals in many different cultures, most notably Turkish, Indian, and Mediterranean cuisine.",
      name: "Cracker Bread",
    },
    txcd_40040021: {
      description:
        "Plain Breads include items ordinary loaves, such as sourdough, multigrain, and rye loaves.",
      name: "Plain Breads",
    },
    txcd_40040022: {
      description:
        "Specialty Breads are artisan breads, including cheese bread, olive loaves, date and walnut bread, etc.",
      name: "Speciality Breads",
    },
    txcd_40050003: {
      description:
        "Food bundle or basket containing food staples combined with tangible personal property, with the food comprising between 50% and 75% of the overall value of the bundle.",
      name: "Food/TPP Bundle - with Food between 50% and 75%",
    },
    txcd_40050004: {
      description:
        "Food bundle or basket containing food staples combined with tangible personal property, with the food comprising between 50% and 90% of the overall value of the bundle.",
      name: "Food/TPP Bundle with Food 50% to 90%",
    },
    txcd_40050005: {
      description:
        "Food bundle or basket containing food staples combined with tangible personal property, with the food comprising 90% or more of the overall value of the bundle.",
      name: "Food/TPP Bundle with Food 90% or more",
    },
    txcd_40050006: {
      description:
        "Food bundle or basket containing food staples combined with tangible personal property, with the food comprising less than 50% of the overall value of the bundle.",
      name: "Food/TPP Bundle with Food less than 50%",
    },
    txcd_40050007: {
      description:
        "Food bundle or basket containing food staples combined with tangible personal property, with the food comprising 90% or more of the overall value of the bundle, where all food consists of candy (not containing flour).",
      name: "Food/TPP Bundle - with Food 90% or more - Food is all Candy",
    },
    txcd_40050008: {
      description:
        "Food bundle or basket containing food staples combined with tangible personal property, with the food comprising between 50% and 75% of the overall value of the bundle, where all food consists of candy (not containing flour).",
      name: "Food/TPP Bundle - with Food between 50% and 75% - Food is all Candy",
    },
    txcd_40050009: {
      description:
        "Food bundle or basket containing food staples combined with tangible personal property, with the food comprising between 76% and 89% of the overall value of the bundle.",
      name: "Food/TPP Bundle - with Food between 76% and 89%",
    },
    txcd_40050010: {
      description:
        "Food bundle or basket containing food staples combined with tangible personal property, with the food comprising between 76% and 89% of the overall value of the bundle, where all food consists of candy (not containing flour).",
      name: "Food/TPP Bundle - with Food between 76% and 89% - Food is all Candy",
    },
    txcd_40051001: {
      description:
        "Food bundle or basket containing food staples combined with candy, with the candy comprising 10% or less of the overall value of the bundle (food comprises 90% or more).  Note that any candy containing flour should be considered as food (and not candy) when determining bundle percentages.",
      name: "Food/Candy Bundle - with Candy 10% or less",
    },
    txcd_40051002: {
      description:
        "Food bundle or basket containing food staples combined with candy, with the candy comprising between 11% and 24% of the overall value of the bundle (food comprises 76% to 89%).  Note that any candy containing flour should be considered as food (and not candy) when determining bundle percentages.",
      name: "Food/Candy Bundle - with Candy 11% to 24%",
    },
    txcd_40051003: {
      description:
        "Food bundle or basket containing food staples combined with candy, with the candy comprising between 25% and 49% of the overall value of the bundle (food comprises 51 to 75%).  Note that any candy containing flour should be considered as food (and not candy) when determining bundle percentages.",
      name: "Food/Candy Bundle - with Candy 25% to 49%",
    },
    txcd_40051004: {
      description:
        "Food bundle or basket containing food staples combined with candy, with the candy comprising 50% or more of the overall value of the bundle (food comprises 50% or less). Note that any candy containing flour should be considered as food (and not candy) when determining bundle percentages.",
      name: "Food/Candy Bundle - with Candy 50% or more",
    },
    txcd_40060003: {
      description:
        "Food and beverage products in a form suited for consumption on the premises of the vendor, described as prepared foods, ready-to-eat foods, or meals.  Always utilize this PTC for heated foods, heated beverages, dispensed beverages, and foods sold with eating utensils.",
      name: "Food for Immediate Consumption",
    },
    txcd_40070001: {
      description: "Granola Bars, Cereal Bars, Energy Bars, Protein Bars containing flour.",
      name: "Granola Bars, Cereal Bars, Energy Bars, Protein Bars Containing Flour",
    },
    txcd_40070002: {
      description: "Granola Bars, Cereal Bars, Energy Bars, Protein Bars containing no flour.",
      name: "Granola Bars, Cereal Bars, Energy Bars, Protein Bars Containing No Flour",
    },
    txcd_40070005: {
      description:
        "Snack foods including chips, crisps, puffs, curls or sticks, popped corn, brittle pretzels, salted nuts and salted seeds, granola products and snack mixes. This category does not include items such as crackers, cookies, snack cakes or breakfast cereal.",
      name: "Snack Foods",
    },
    txcd_40070006: {
      description:
        'A biscuit is a typically hard, small baked product that would be called a "cookie" In the US.',
      name: "Biscuits/Cookies - Plain",
    },
    txcd_40070007: {
      description:
        'A biscuit is a typically hard, small baked product that would be called a "cookie" In the US.  This cookie is covered or coated in chocolate.',
      name: "Biscuits/Cookies - Chocolate Coated",
    },
    txcd_40090001: {
      description:
        'Tablet, capsule, powder, softgel, gelcap, or liquid intended that contain a vitamin, mineral, herb, other botanical, or amino acid and is labeled as a dietary supplement identifiable by the "supplement facts" box found on the label.',
      name: "Dietary Supplements",
    },
    txcd_40090002: {
      description:
        "Nutritional supplement in powder form, dairy based or plant based, focused on increasing ones intake of protein for various benefits.",
      name: "Protein Powder",
    },
    txcd_40090005: {
      description:
        "A food which intended to be or is represented for special dietary use solely as a food for infants by reason of its simulation of human milk or its suitability as a complete or partial substitute for human milk.",
      name: "Infant Formula",
    },
    txcd_40090008: {
      description:
        'Products in various forms that are intended for ingestion and represented as a conventional food and labeled as a nutritional supplement and identifiable by the "Nutrition Facts" box found on the label.',
      name: "Nutritional Supplements",
    },
    txcd_40100001: {
      description:
        "A preparation of natural or artificial sweeteners in combination with chocolate, fruits, nuts, or other ingredients or flavorings in the form of bars, drops, or pieces.",
      name: "Candy",
    },
    txcd_40100002: {
      description:
        "A preparation of natural or artificial sweeteners in combination with chocolate, fruits, nuts, or other ingredients or flavorings in the form of bars, drops, or pieces and that contains flour as an ingredient.",
      name: "Candy (Contains Flour)",
    },
    txcd_40100003: {
      description:
        "Ice cream, frozen yogurt, or similar, packaged in a container that is one pint or larger. The default behavior of this category assumes off-premises consumption.",
      name: "Ice Cream, Packaged - One Pint or Greater",
    },
    txcd_40100004: {
      description:
        "Ice cream, frozen yogurt, or similar, packaged in a container that is less than one pint. The default behavior of this category assumes off-premises consumption.",
      name: "Ice Cream, Packaged - Less Than One Pint Container",
    },
    txcd_40100010: {
      description: "A soft, cohesive substance designed to be chewed without being swallowed.",
      name: "Chewing Gum",
    },
    txcd_40100011: {
      description: "A mint -flavored candy intended to freshen the breath.",
      name: "Breath Mints",
    },
    txcd_40400005: {
      description:
        "Dried fruit is fruit from which the majority of the original water content has been removed either naturally, through sun drying, or through the use of specialized dryers or dehydrators.  Common dried fruits are dried fruits sold are raisins, dates, prunes, and figs.",
      name: "Dried Fruit - Unsweetened",
    },
    txcd_41020001: {
      description:
        "Beer is an alcoholic drink that is flavored with hops and consists of yeast-fermented malt. Malt beverage is a type of alcoholic drink in which the grain, or seed, of the barley plant is the main ingredient.  This code represents packaged beverages for non-immediate consumption.",
      name: "Alcoholic Beverages - Beer/Malt Beverage",
    },
    txcd_41020002: {
      description:
        "Alcoholic beverages created in a distillation process, and are known by the common names of vodka, gin, whiskey, rum, tequila, brandy, etc.  This code represents packaged beverages for non-immediate consumption.",
      name: "Alcoholic Beverages - Spirits",
    },
    txcd_41020003: {
      description:
        "An alcoholic beverage created through fermentation of grapes of various varieties.  This code represents packaged beverages for non-immediate consumption.",
      name: "Alcoholic Beverages - Wine",
    },
    txcd_41030001: {
      description:
        "Regular, unsweetened, non carbonated water sold in containers.  Includes waters containing only natural flavors or essences.  Does not include distilled water.",
      name: "Bottled Water",
    },
    txcd_41030002: {
      description:
        "Bottled Water for human consumption, unsweetened, carbonated artificially.  Includes carbonated waters containing only natural flavors or essences.",
      name: "Bottled Water - Carbonated Artificially",
    },
    txcd_41030003: {
      description:
        "Bottled Water for human consumption, unsweetened, carbonated naturally. Includes carbonated waters containing only natural flavors or essences.",
      name: "Bottled Water - Carbonated Naturally",
    },
    txcd_41040002: {
      description:
        "Carbonated non-alcoholic beverages that contain natural or artificial sweeteners, and zero natural fruit or vegetable juice, not including carbonated water. Includes energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Carbonated Soft Drinks - 0% Fruit or Vegetable juice",
    },
    txcd_41040003: {
      description:
        "Ready to drink non-carbonated beverage containing tea with natural or artificial sweeteners.",
      name: "Bottled Tea - Non-Carbonated - Sweetened",
    },
    txcd_41040004: {
      description:
        "Bottled water for human consumption, containing natural or artificial sweeteners, non-carbonated.  Waters containing zero calorie natural flavoring should be associated with the `Bottled Water` PTC.",
      name: "Bottled water - Sweetened",
    },
    txcd_41040005: {
      description:
        "Bottled water for human consumption, containing natural or artificial sweeteners, carbonated.  Carbonated waters containing zero calorie natural flavoring should be associated with either the the `Bottled Water - Carbonated Artificially` PTC or the `Bottled Water - Carbonated Naturally` PTC.",
      name: "Bottled water - Carbonated - Sweetened",
    },
    txcd_41040008: {
      description:
        "Non-carbonated, non-alcoholic beverages that contain sweeteners, and zero natural fruit or vegetable juice, such as sweetened cocktail mixes that can be combined with alcohol, but doesn't include flavored water.",
      name: "Non-Carbonated Soft Drinks - 0% Fruit or Vegetable juice",
    },
    txcd_41040009: {
      description:
        "Carbonated nonalcoholic beverages that contain natural or artificial sweeteners, and 1 - 9% natural vegetable juice. This does not include flavored carbonated water. This does include beverages marketed as energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Soft Drinks - Carbonated - 1 -9% Vegetable juice",
    },
    txcd_41040010: {
      description:
        "Carbonated nonalcoholic beverages that contain natural or artificial sweeteners, and 1 - 9% natural fruit juice. This does not include flavored carbonated water. This does include beverages marketed as energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Soft Drinks - Carbonated - 1-9% Fruit juice",
    },
    txcd_41040011: {
      description:
        "Carbonated nonalcoholic beverages that contain natural or artificial sweeteners, and 10 - 24% natural fruit juice.  This does not include flavored carbonated water.  This does include beverages marketed as energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Soft Drinks - Carbonated - 10-24% Fruit juice",
    },
    txcd_41040012: {
      description:
        "Carbonated nonalcoholic beverages that contain natural or artificial sweeteners, and 10 - 24% natural vegetable juice. This does not include flavored carbonated water. This does include beverages marketed as energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Soft Drinks - Carbonated - 10-24% Vegetable juice",
    },
    txcd_41040013: {
      description:
        "Carbonated nonalcoholic beverages that contain natural or artificial sweeteners, and 100% natural fruit or vegetable juice. This does not include flavored carbonated water. This does include beverages marketed as energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Soft Drinks - Carbonated - 100% Fruit or Vegetable juice",
    },
    txcd_41040014: {
      description:
        "Carbonated nonalcoholic beverages that contain natural or artificial sweeteners, and 25 - 50% natural fruit juice. This does not include flavored carbonated water. This does include beverages marketed as energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Soft Drinks - Carbonated - 25-50% Fruit juice",
    },
    txcd_41040015: {
      description:
        "Carbonated nonalcoholic beverages that contain natural or artificial sweeteners, and 25 - 50% natural vegetable juice. This does not flavored carbonated water. This does include beverages marketed as energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Soft Drinks - Carbonated - 25-50% Vegetable juice",
    },
    txcd_41040016: {
      description:
        "Carbonated nonalcoholic beverages that contain natural or artificial sweeteners, and 51 - 69% natural fruit juice. This does not include flavored carbonated water. This does include beverages marketed as energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Soft Drinks - Carbonated - 51-69% Fruit juice",
    },
    txcd_41040017: {
      description:
        "Carbonated nonalcoholic beverages that contain natural or artificial sweeteners, and 51 - 69% natural vegetable juice. This does not include flavored carbonated water. This does include beverages marketed as energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Soft Drinks - Carbonated - 51-69% Vegetable juice",
    },
    txcd_41040018: {
      description:
        "Carbonated nonalcoholic beverages that contain natural or artificial sweeteners, and 70 - 99% natural fruit juice. This does not include flavored carbonated water. This does include beverages marketed as energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Soft Drinks - Carbonated - 70-99% Fruit juice",
    },
    txcd_41040019: {
      description:
        "Carbonated nonalcoholic beverages that contain natural or artificial sweeteners, and 70 - 99% natural vegetable juice. This does not include flavored carbonated water. This does include beverages marketed as energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Soft Drinks - Carbonated - 70-99% Vegetable juice",
    },
    txcd_41040020: {
      description:
        "Non-carbonated nonalcoholic beverages that contain natural or artificial sweeteners, and 1 - 9% natural vegetable juice. This does not include flavored water. This does include sweetened cocktail mixes that can be combined with alcohol. This does include beverages marketed as energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Soft Drinks - Non-Carbonated - 1 -9% Vegetable juice",
    },
    txcd_41040021: {
      description:
        "Non-carbonated nonalcoholic beverages that contain natural or artificial sweeteners, and 1 - 9% natural fruit juice. This does not include flavored water. This does include sweetened cocktail mixes that can be combined with alcohol. This does include beverages marketed as energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Soft Drinks - Non-Carbonated - 1-9% Fruit juice",
    },
    txcd_41040022: {
      description:
        "Non-carbonated nonalcoholic beverages that contain natural or artificial sweeteners, and 10 - 24% natural fruit juice. This does not include flavored water. This does include sweetened cocktail mixes that can be combined with alcohol. This does include beverages marketed as energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Soft Drinks - Non-Carbonated - 10-24% Fruit juice",
    },
    txcd_41040023: {
      description:
        "Non-carbonated nonalcoholic beverages that contain natural or artificial sweeteners, and 10 - 24% natural vegetable juice. This does not include flavored water. This does include sweetened cocktail mixes that can be combined with alcohol. This does include beverages marketed as energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Soft Drinks - Non-Carbonated - 10-24% Vegetable juice",
    },
    txcd_41040024: {
      description:
        "Non-carbonated nonalcoholic beverages that contain natural or artificial sweeteners, and 100% natural fruit or vegetable juice. This does not include flavored water. This does include sweetened cocktail mixes that can be combined with alcohol. This does include beverages marketed as energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Soft Drinks - Non-Carbonated - 100% Fruit or Vegetable juice",
    },
    txcd_41040025: {
      description:
        "Non-carbonated nonalcoholic beverages that contain natural or artificial sweeteners, and 25 - 50% natural fruit juice. This does not include flavored water. This does include sweetened cocktail mixes that can be combined with alcohol. This does include beverages marketed as energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Soft Drinks - Non-Carbonated - 25-50% Fruit juice",
    },
    txcd_41040026: {
      description:
        "Non-carbonated nonalcoholic beverages that contain natural or artificial sweeteners, and 25 - 50% natural vegetable juice. This does not include flavored water. This does include sweetened cocktail mixes that can be combined with alcohol. This does include beverages marketed as energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Soft Drinks - Non-Carbonated - 25-50% Vegetable juice",
    },
    txcd_41040027: {
      description:
        "Non-carbonated nonalcoholic beverages that contain natural or artificial sweeteners, and 51 - 69% natural fruit juice. This does not include flavored water. This does include sweetened cocktail mixes that can be combined with alcohol. This does include beverages marketed as energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Soft Drinks - Non-Carbonated - 51-69% Fruit juice",
    },
    txcd_41040028: {
      description:
        "Non-carbonated nonalcoholic beverages that contain natural or artificial sweeteners, and 51 - 69% natural vegetable juice. This does not include flavored water. This does include sweetened cocktail mixes that can be combined with alcohol. This does include beverages marketed as energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Soft Drinks - Non-Carbonated - 51-69% Vegetable juice",
    },
    txcd_41040029: {
      description:
        "Non-carbonated nonalcoholic beverages that contain natural or artificial sweeteners, and 70 - 99% natural fruit juice. This does not include flavored water. This does include sweetened cocktail mixes that can be combined with alcohol. This does include beverages marketed as energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Soft Drinks - Non-Carbonated - 70-99% Fruit juice",
    },
    txcd_41040030: {
      description:
        "Non-carbonated nonalcoholic beverages that contain natural or artificial sweeteners, and 70 - 99% natural vegetable juice. This does not include flavored water. This does include sweetened cocktail mixes that can be combined with alcohol. This does include beverages marketed as energy drinks that carry a Nutrition Facts label and contain a blend of energy enhancing ingredients.",
      name: "Soft Drinks - Non-Carbonated - 70-99% Vegetable juice",
    },
    txcd_41050001: {
      description: "Ready to drink coffee based beverage containing milk or milk substitute.",
      name: "Bottled coffee - Containing Milk or Milk Substitute",
    },
    txcd_41050002: {
      description:
        "Ready to drink coffee based beverage not containing milk, containing natural or artificial sweetener.",
      name: "Bottled Coffee - No Milk - Sweetened",
    },
    txcd_41050003: {
      description:
        "Ready to drink coffee based beverage containing neither milk nor natural or artificial sweeteners.",
      name: "Bottled Coffee - No Milk - Unsweetened",
    },
    txcd_41050004: {
      description:
        "Ready to drink carbonated beverage containing tea and without any natural or artificial sweeteners.",
      name: "Bottled Tea - Carbonated - Unsweetened",
    },
    txcd_41050005: {
      description:
        "Ready to drink non-carbonated beverage containing tea without natural or artificial sweeteners.",
      name: "Bottled Tea - Non-Carbonated - Unsweetened",
    },
    txcd_41050006: {
      description: "Coffee beans or ground coffee.",
      name: "Coffee Beans or Ground Coffee",
    },
    txcd_41050007: {
      description:
        "Ready to drink carbonated beverage containing tea with natural or artificial sweeteners.",
      name: "Bottled Tea - Carbonated - Sweetened",
    },
    txcd_41050008: {
      description: "Tea leaves and tea bags.",
      name: "Tea Leaves or Tea Bags",
    },
    txcd_41051001: {
      description:
        "Carbonated beverages marketed as energy drinks, carrying a Supplement Facts Label, that contain a blend of energy enhancing vitamins, minerals, herbals, stimulants, etc.",
      name: "Energy Beverages - Carbonated - with Supplement Facts Label",
    },
    txcd_41051002: {
      description:
        "Non-carbonated beverages marketed as energy drinks, carrying a Supplement Facts Label, that contain a blend of energy enhancing vitamins, minerals, herbals, stimulants, etc.",
      name: "Energy Beverages - Non-Carbonated - with Supplement Facts Label",
    },
    txcd_41052001: {
      description:
        "Non-alcoholic beer is beer with little or no alcohol content. In the United States, beverages containing less than 0.5% alcohol by volume (ABV) fall under this term.",
      name: "Food and Beverage - Non-Alcoholic Beer/ Wine",
    },
    txcd_41053001: {
      description:
        "Ready to drink beverages, containing milk, formulated and labeled for their nutritional value, such as increased caloric or protein intake.",
      name: "Nutritional Supplement, Protein Drinks, Shakes - Contains Milk",
    },
    txcd_41053002: {
      description:
        "Ready to drink beverages, not containing milk, formulated and labeled for their nutritional value, such as increased caloric or protein intake and containing natural or artificial sweeteners.",
      name: "Nutritional Supplement, Protein Drink, Shakes - Contains No Milk",
    },
    txcd_41054001: {
      description:
        "Powdered mixes to be reconstituted into a drinkable beverage using milk or a milk substitute.",
      name: "Powdered Drink Mixes - To Be Mixed with Milk",
    },
    txcd_41054002: {
      description: "Powdered mixes to be reconstituted into a drinkable beverage using water.",
      name: "Powdered Drink Mixes - To Be Mixed with Water",
    },
    txcd_41060003: {
      description:
        "Milk type beverages from non-animal sources, such as soy, rice, almond, coconut, peanut, and hemp.",
      name: "Milk Substitutes",
    },
    txcd_41060006: {
      description:
        "Milk or milk substitutes, or drinks with bases of milk, coffee, unsweetened tea or cocoa.",
      name: "Milk Coffee Tea Cocoa Beverages",
    },
    txcd_50021001: {
      description:
        "Charges associated with recurring membership dues allowing access or use of health clubs and fitness clubs.  Outside of the United States, these charges are not applicable for services provided by non-profit sports organizations.",
      name: "Fitness Centers - Dues and Membership Fees",
    },
    txcd_50021002: {
      description:
        "Initiation fees are an upfront one-time charge occurring at the time a new member joins a health club or fitness center.  Outside of the United States, these charges are not applicable for services provided by non-profit sports organizations.",
      name: "Fitness Centers - Initiation Fees",
    },
    txcd_50021003: {
      description:
        "Charges associated with the service of providing in-person personal fitness training or group excercise classes.  Outside of the United States, these charges are not applicable for services provided by non-profit sports organizations.",
      name: "Fee for Personal Training/Fitness Classes",
    },
    txcd_50021101: {
      description:
        "Charges associated with one-time access for use of health clubs and fitness clubs.  Outside of the United States, these charges are not applicable for services provided by non-profit sports organizations.",
      name: "Fitness Centers - Single Use Access Fees",
    },
    txcd_50021103: {
      description:
        "Charges associated with the service of providing in-person instruction in an athletic pursuit, eg. golf, tennis, skiing, etc.  Outside of the United States, these charges are not applicable for services provided by non-profit sports organizations.",
      name: "Fee For Sport Instruction Classes",
    },
    txcd_90000001: {
      description:
        "A monetary donation for a cause, in which the donee receives nothing in return.",
      name: "Cash Donation",
    },
    txcd_90020001: {
      description:
        "Gratuity, otherwise known as a tip, is money that a customer leaves for an employee or employees that is in addition to and separate from the amount due for the goods or services rendered.",
      name: "Optional Gratuity",
    },
    txcd_92010001: {
      description:
        "A shipping charge for the delivery of physical goods in conjunction with the sale of these goods. The shipping charge is optional, meaning the customer had other means of obtaining the goods purchased and delivered via this charge. This tax category is not appropriate for stand alone transportation charges that are not associated with the sale of the goods being delivered.",
      name: "Shipping",
    },
  },
};
